{
  "meta": {
    "title": "Shape",
    "description": "Shape is a place where construction organisations can create, track and resolve issues seamlessly on mobile and desktop. Organisations using Shape collaborate more effectively and close-out defects and safety issues faster and smarter!"
  },
  "state": {
    "loading": "Loading"
  },
  "loadingScreen": {
    "messages": {
      "settingUpSite": "Setting up your site…",
      "readingBlueprints": "Reading the blueprints…",
      "layingGroundwork": "Laying the groundwork…",
      "raisingScaffolding": "Raising the scaffolding…",
      "tighteningBolts": "Tightening the last bolts…",
      "toppingOut": "Topping out — almost there…"
    }
  },
  "actions": {
    "archive": "Archive",
    "cancel": "Cancel",
    "create": "Create",
    "delete": "Delete",
    "dismiss": "Dismiss",
    "done": "Done",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "next": "Next",
    "ok": "Ok",
    "yes": "Yes",
    "restore": "Restore",
    "save": "Save",
    "update": "Update",
    "apply": "Apply",
    "unlink": "Unlink",
    "link": "Link",
    "export": "Export",
    "seeMore": "See more",
    "seeLess": "See less",
    "downloadAll": "Download all"
  },
  "admin": {
    "accessRequests": {
      "title": "Access & permission requests",
      "list": {
        "title": "Access requests",
        "noPendingRequests": "There are no pending access requests for <b>{{displayName}}</b>.",
        "hasPendingRequests": "You have the following access requests for <b>{{displayName}}</b> waiting to be reviewed:",
        "teamRequested": "Organisation requested",
        "destinationTeam": "Destination organisation",
        "reviewCTA": "Review",
        "reviewCTALabel": "Review access request from {{userName}}"
      },
      "reallocate": {
        "title": "Reallocate access request",
        "subtitle": "Select a team to reallocate organisation request from <b>{{userName}}</b>.",
        "selectLabel": "Organisation",
        "selectPlaceholder": "Select",
        "cancelCTA": "Cancel",
        "confirmCTA": "Reallocate"
      },
      "review": {
        "title": "Review access request",
        "routed": "Automatically routed to the <b>{{team}}</b>.",
        "redirected": "This request has been routed to <b>{{team}}</b>.",
        "from": "From",
        "organisationRequested": "Organisation",
        "message": "Message",
        "noMessage": "No message was left.",
        "reRoutedFrom": "Re-routed from <b>{{team}}</b> admin",
        "constructionRole": {
          "label": "Construction role",
          "placeholder": "Select"
        },
        "permissionRole": {
          "label": "Permissions",
          "placeholder": "Select"
        },
        "differentTeam": {
          "caption": "Not the right organisation? Reallocate this request to another organisation's admins.",
          "switchTeamCTA": "Reallocate"
        },
        "cancelCTA": "Reject",
        "confirmCTA": "Accept request",
        "unavailableToast": "This access request is no longer pending."
      },
      "reject": {
        "title": "Reject access request",
        "subtitle": "Are you sure you want to reject <b>{{userName}}&apos;s</b> request to access <b>{{teamName}}</b>?",
        "cancelCTA": "Cancel",
        "confirmCTA": "Reject"
      },
      "accept": {
        "title": "Accept access request",
        "subtitle": "If you accept this request you will grant <b>{{userName}}</b> access to <b>{{teamName}}</b>.",
        "alert": "Sending new invites implies billing changes",
        "cancelCTA": "Cancel",
        "confirmCTA": "Accept",
        "billing": {
          "warning": "Sending new invites implies billing changes.",
          "info_zero": "You are inviting {{COUNT}} new users which will imply the following price changes in your billing:",
          "info_one": "You are inviting {{COUNT}} new user which will imply the following price changes in your billing:",
          "info_other": "You are inviting {{COUNT}} new users which will imply the following price changes in your billing:",
          "newLicense": {
            "term": "New licenses",
            "details_zero": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users licenses",
            "details_one": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users license",
            "details_other": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users licenses"
          }
        }
      }
    },
    "roleUpgradeRequests": {
      "title": "Permission requests",
      "subtitle": "You have the following permission requests for <b>{{displayName}}</b> waiting to be reviewed:",
      "noPendingRequests": "There are no pending permission requests for <b>{{displayName}}</b>.",
      "list": {
        "requestedPermission": "Permission requested",
        "currentPermission": "Current permission",
        "reviewCTA": "Review",
        "reviewCTALabel": "Review permission request from {{userName}}"
      },
      "review": {
        "title": "Review permission request",
        "from": "From",
        "currentPermission": "Current permission",
        "requestedPermission": "Permission requested",
        "message": "Message",
        "noMessage": "No message added",
        "permission": {
          "label": "New Permissions"
        },
        "rejectCTA": "Reject",
        "approveCTA": "Approve",
        "acceptedToast": "{{userName}} now has the new permission.",
        "rejectedToast": "Request from {{userName}} rejected.",
        "unavailableToast": "This permission request is no longer pending."
      }
    },
    "contracts": {
      "title": "Contracts",
      "fields": {
        "title": "Title",
        "contractTitle": "Contract title",
        "contractDescription": "Contract type",
        "alertPeriodDays": "Alert period (days)",
        "contractor": "Contractor",
        "contracted": "Contracted",
        "organisation": "Organisation",
        "organisationPlaceholder": "Select organisation",
        "people": "People",
        "peoplePlaceholder": "Select people",
        "yourOrg": "Your org",
        "yourOrgInline": "(your org)",
        "yourOrgTooltip": "One of the organisations must be your own. Use the side button to switch the organisation's role between Contractor and Contracted.",
        "yourOrgInfoLabel": "More information"
      },
      "actions": {
        "newContractCTA": "New contract",
        "backToContractsCTA": "Back to contracts",
        "editContractCTA": "Edit contract",
        "cancelCTA": "Cancel",
        "saveCTA": "Save",
        "switchTeamCTA": "Switch team",
        "viewContractAriaLabel": "View contract {{title}}"
      },
      "alerts": {
        "saveSuccess": "Contract created successfully",
        "updateSuccess": "Contract updated successfully",
        "editAlert": "Once the contract is created, the organisations can't be changed. If you need a different pairing, you can create a new contract."
      },
      "aboutContracts": {
        "title": "About contracts",
        "body": "Contracts define how your organisation collaborates with others. They establish relationships, responsibilities, and track changes between parties.",
        "learnMore": "Learn more in the Help Center"
      },
      "create": {
        "title": "New contract"
      },
      "edit": {
        "title": "Edit contract"
      },
      "details": {
        "contractDetails": "Contract details"
      },
      "files": {
        "title": "Contractual files",
        "empty": "No contractual files",
        "emptyPrompt": "Store all contractual documents for this contract in one place.",
        "pending": "Pending upload",
        "revisionPlaceholder": "Revision",
        "columns": {
          "title": "Title",
          "type": "Type",
          "revision": "Revision",
          "created": "Created",
          "author": "Author",
          "size": "Size"
        },
        "actions": {
          "upload": "Upload",
          "remove": "Remove {{filename}}",
          "menu": "Actions for {{filename}}",
          "openLabel": "Open",
          "downloadLabel": "Download",
          "copyLink": "Copy link",
          "copyLinkSuccess": "Link copied to clipboard",
          "delete": "Delete",
          "retry": "Retry {{filename}}"
        },
        "deleteModal": {
          "title": "Delete file",
          "subTitle": "Are you sure you want to delete {{filename}}? This action can't be undone.",
          "success": "{{filename}} was deleted.",
          "error": "Couldn't delete the file. Please try again.",
          "actions": {
            "cancel": "Cancel",
            "delete": "Delete"
          }
        },
        "alerts": {
          "uploadError": "Some files couldn't be uploaded. You can add them again from the contract.",
          "updateError": "Couldn't update the file. Please try again.",
          "pendingUploadDescription": "The documents will be uploaded when the contract is saved. View and Download will become available after the upload is complete.",
          "uploadSuccess": "{{filename}} was uploaded.",
          "updateSuccess": "Changes saved."
        },
        "kinds": {
          "contract": "Contract",
          "addendum": "Addendum",
          "variation": "Variation",
          "deed_of_variation": "Deed of variation",
          "schedule": "Schedule",
          "programme": "Programme",
          "drawing": "Drawing",
          "specification": "Specification",
          "employers_requirement": "Employer's Requirement",
          "warranty": "Warranty",
          "bond": "Bond",
          "letter_of_intent": "Letter of intent",
          "side_letter": "Side letter",
          "other": "Other"
        },
        "uploadFailed": "Upload failed"
      },
      "emptyState": {
        "title": "No contracts yet",
        "subtitle": "Create your first contract to define how your organisation collaborates with others.",
        "card1": {
          "title": "Required association",
          "description": "Every change must be associated with a contract"
        },
        "card2": {
          "title": "Organisation relationship",
          "description": "Contracts define the relationship between two organisations"
        },
        "card3": {
          "title": "Your organisation",
          "description": "Your organisation must be either the contractor or contracted party"
        },
        "card4": {
          "title": "People collaboration",
          "description": "Define members to collaborate on contract work"
        },
        "howItWorksTitle": "How contracts work",
        "learnMoreInHelpCenter": "Learn more in the Help Center"
      }
    },
    "customFields": {
      "title": "Custom fields",
      "newButton": "New field",
      "form": {
        "newTitle": "New custom field",
        "editTitle": "Update custom field",
        "fieldTitle": {
          "label": "Field title",
          "characters": "characters",
          "errors": {
            "required": "Required field",
            "length": "Field title too long"
          }
        },
        "visibility": {
          "label": "Visibility",
          "description": "Only the principal organisation can add project wide fields.",
          "options": {
            "projectWide": {
              "label": "Project wide ({{actualNumber}} of {{maximumNumber}} in use)",
              "description": "Custom fields that are used by and visible to all organisations on the project."
            },
            "team": {
              "label": "Organisation ({{actualNumber}} of {{maximumNumber}} in use)",
              "description": "Custom fields that are only used by and visible to your organisation.",
              "current": "current organisation"
            }
          },
          "errors": {
            "maximumReached_projectWide": "You hit the limit and can't create more project wide custom fields.",
            "maximumReached_team": "You hit the limit and can't create more organisation custom fields.",
            "maximumReached": "You hit the limit and can't create more custom fields.",
            "unableToCreate": "You hit the limit and can't create more custom fields."
          }
        }
      },
      "table": {
        "title": "Title",
        "visibility": "Visibility",
        "projectWide": "Project wide",
        "team": "Organisation",
        "maximumInfo": "There is a limit of {{maximumProjectWide}} project wide and {{maximumTeam}} organisation custom fields.",
        "actions": {
          "header": "Actions",
          "edit": "Edit custom field",
          "remove": "Remove custom field"
        }
      },
      "delete": {
        "title": "Remove custom field",
        "subTitle": "You are about to remove {{customFieldLabel}} field. After this step, {{customFieldLabel}}, will be removed from all issues completely and you can't undo it.",
        "cancel": "$t(actions.cancel)",
        "remove": "Remove"
      },
      "empty": {
        "title": "You don't have custom fields yet!",
        "subTitle": "Get started by creating one.",
        "actionLabel": "$t(admin.customFields.newButton)"
      }
    },
    "locations": {
      "actions": {
        "cancel": "$t(actions.cancel)",
        "create": "$t(actions.create)",
        "delete": "$t(actions.delete)",
        "duplicate": "$t(actions.duplicate)",
        "deleteSelected": "Delete selected",
        "edit": "$t(actions.edit)",
        "ok": "$t(actions.ok)",
        "update": "$t(actions.update)",
        "collapseAll": "Collapse all",
        "expandAll": "Expand all",
        "selectAllCTA": "Select all",
        "unselectCTA": "Unselect",
        "moveUp": "Move up",
        "moveDown": "Move down"
      },
      "delete": {
        "confirmDeleteLocationOverlay": {
          "title": "Delete location",
          "subTitle": "Are you sure you want to delete this location? This action cannot be undone.",
          "cancelCTA": "$t(actions.cancel)",
          "deleteCTA": "$t(actions.delete)"
        },
        "locationHasChildren": {
          "title": "This location is in use and cannot be deleted.",
          "subTitle": "The location has associated sublocations. To allow deletion of this location, sublocations will need to be unlinked from it first.",
          "close": "Close"
        },
        "locationHasDocuments": {
          "title": "This location is in use and cannot be deleted.",
          "subTitle": "The location has associated documents. To allow deletion of this location, documents will need to be unlinked from it first.",
          "close": "Close"
        },
        "locationHasIssues": {
          "title": "This location is in use and cannot be deleted.",
          "subTitle": "The location has associated issues. To allow deletion of this location, issues will need to be unlinked from it first.",
          "close": "Close"
        },
        "locationHasShiftReports": {
          "title": "This location is in use and cannot be deleted.",
          "subTitle": "The location has associated shift reports. To allow deletion of this shift reports, issues will need to be unlinked from it first.",
          "close": "Close"
        },
        "deleteLocationErrorOverlay": {
          "title": "Unable to delete",
          "subTitle": "There was an error while trying to delete this item, please try again.",
          "dismissCTA": "$t(actions.dismiss)"
        }
      },
      "duplicate": {
        "toast": {
          "success": "Location duplicated successfully",
          "error": "Failed to duplicate location"
        }
      },
      "form": {
        "addTitle": "Add location",
        "editTitle": "Edit location",
        "location": "Location name",
        "shortCode": "Short code",
        "addCTA": "Add",
        "editCTA": "Update",
        "cancelCTA": "Cancel",
        "errors": {
          "required": "Required field"
        }
      },
      "selected_zero": "{{selectedNum}} locations selected",
      "selected_one": "{{selectedNum}} location selected",
      "selected_other": "{{selectedNum}} locations selected",
      "title": "Locations"
    },
    "disciplines": {
      "title": "Disciplines",
      "selected_zero": "{{selectedNum}} disciplines selected",
      "selected_one": "{{selectedNum}} discipline selected",
      "selected_other": "{{selectedNum}} disciplines selected",
      "actions": {
        "cancel": "$t(actions.cancel)",
        "create": "$t(actions.create)",
        "delete": "$t(actions.delete)",
        "duplicate": "$t(actions.duplicate)",
        "deleteSelected": "Delete selected",
        "edit": "$t(actions.edit)",
        "ok": "$t(actions.ok)",
        "update": "$t(actions.update)",
        "collapseAll": "Collapse all",
        "expandAll": "Expand all",
        "selectAllCTA": "Select all",
        "unselectCTA": "Unselect",
        "moveUp": "Move up",
        "moveDown": "Move down"
      },
      "form": {
        "addTitle": "Add discipline",
        "editTitle": "Edit discipline",
        "discipline": "Discipline name",
        "shortCode": "Short code",
        "addCTA": "Add",
        "editCTA": "Update",
        "cancelCTA": "Cancel",
        "errors": {
          "required": "Required field"
        }
      },
      "delete": {
        "confirmDeleteDisciplineOverlay": {
          "title": "Delete discipline",
          "subTitle": "Are you sure you want to delete this discipline? This action cannot be undone.",
          "cancelCTA": "$t(actions.cancel)",
          "deleteCTA": "$t(actions.delete)"
        },
        "disciplineHasChildren": {
          "title": "This discipline is in use and cannot be deleted.",
          "subTitle": "The discipline has associated subdisciplines. To allow deletion of this discipline, subdisciplines will need to be unlinked from it first.",
          "close": "Close"
        },
        "disciplineHasIssues": {
          "title": "This discipline is in use and cannot be deleted.",
          "subTitle": "The discipline has associated issues. To allow deletion of this discipline, issues will need to be unlinked from it first.",
          "close": "Close"
        },
        "deleteDisciplineErrorOverlay": {
          "title": "Unable to delete",
          "subTitle": "There was an error while trying to delete this item, please try again.",
          "dismissCTA": "$t(actions.dismiss)"
        }
      }
    },
    "resources": {
      "title": "Resources",
      "person": {
        "title": "People",
        "nameColumn": "Person name",
        "emptyState": {
          "title": "No people"
        },
        "createResourceButtonLabel": "New person",
        "createResourceModal": {
          "title": "New person",
          "nameInputLabel": "Person name",
          "nameInputPlaceholder": "Person name",
          "successMessage": "New person was added successfully"
        }
      },
      "organisation": {
        "title": "Organisations",
        "nameColumn": "Organisation name",
        "emptyState": {
          "title": "No organisations"
        },
        "createResourceButtonLabel": "New organisation",
        "createResourceModal": {
          "title": "New organisation",
          "nameInputLabel": "Organisation name",
          "nameInputPlaceholder": "Organisation name",
          "successMessage": "New organisation was added successfully"
        }
      },
      "role": {
        "title": "Roles",
        "nameColumn": "Role name",
        "emptyState": {
          "title": "No roles"
        },
        "createResourceButtonLabel": "New role",
        "createResourceModal": {
          "title": "New role",
          "nameInputLabel": "Role name",
          "nameInputPlaceholder": "Role name",
          "successMessage": "New role was added successfully"
        }
      },
      "equipment": {
        "title": "Equipment",
        "nameColumn": "Equipment name",
        "emptyState": {
          "title": "No equipment"
        },
        "createResourceButtonLabel": "New equipment",
        "createResourceModal": {
          "title": "New equipment",
          "nameInputLabel": "Equipment name",
          "nameInputPlaceholder": "Equipment name",
          "successMessage": "New equipment was added successfully"
        }
      },
      "material": {
        "title": "Material",
        "nameColumn": "Material name",
        "emptyState": {
          "title": "No materials"
        },
        "createResourceButtonLabel": "New material",
        "createResourceModal": {
          "title": "New material",
          "nameInputLabel": "Material name",
          "nameInputPlaceholder": "Material name",
          "successMessage": "New material was added successfully"
        }
      },
      "dropdown": {
        "disable": {
          "title": "Disable",
          "subtitle": "You will not see this resource option on new shift reports.",
          "toast": "\"{{resourceName}}\" was disabled and will be removed as a resource option in new shift reports."
        },
        "enable": {
          "title": "Enable",
          "subtitle": "You will see this resource option on new shift reports.",
          "toast": "\"{{resourceName}}\" was enabled and can now be used in new shift reports."
        }
      },
      "status": {
        "nameColumn": "Status",
        "tooltip": "Disabled resources can’t be selected in new shift reports.",
        "enabled": "Enabled",
        "disabled": "Disabled"
      }
    },
    "permissionLevels": {
      "owner": {
        "title": "Owner",
        "description": "Ultimate project control. Everything Admin can do, plus managing/removing Admins and Owners, full setting access, and paid license utilisation. Cannot be removed by Admins."
      },
      "admin": {
        "title": "Admin",
        "description": "Manages organisation members, invites external orgs, configures project settings (locations, disciplines, custom fields), and holds elevated data-editing rights."
      },
      "commercial": {
        "title": "Commercial contributor",
        "description": "Grants full access to contracts and the Change Tracker without administrative rights. Ideal for Quantity Surveyors and Commercial Managers."
      },
      "contributor": {
        "title": "Contributor",
        "description": "Standard role for site staff. Enables managing issues, weekly planning, and creating shift reports without risk of altering project-wide settings."
      },
      "viewer": {
        "title": "Viewer",
        "description": "Read-only access to Shape documents for site operatives. Can join Channels, send/receive messages, and upload photos or documents."
      },
      "channels": {
        "title": "Channels only",
        "description": "Uses the project only through the Shape Channels app: messages, photos, issues, progress logs. No web access."
      }
    },
    "project": {
      "addUsers": "Add users",
      "invite": {
        "title": "Add users",
        "organisation": "Organisation: {{name}}",
        "form": {
          "input": "Email",
          "addEmail": "Add",
          "footer": {
            "back": "Back",
            "cancel": "Cancel",
            "invite": "Invite",
            "next": "Next"
          },
          "billing": {
            "warning": "$t(admin.accessRequests.accept.billing.warning)",
            "info_zero": "You are inviting {{COUNT}} new users which will imply the following price changes in your billing:",
            "info_one": "You are inviting {{COUNT}} new user which will imply the following price changes in your billing:",
            "info_other": "You are inviting {{COUNT}} new users which will imply the following price changes in your billing:",
            "newLicense": {
              "term": "$t(admin.accessRequests.accept.billing.newLicense.term)",
              "details_zero": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users licenses",
              "details_one": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users license",
              "details_other": "{{pricePerLicense}} x {{numberOfLicenses}} Shape users licenses"
            }
          }
        },
        "freePermissionNotice": "People with the Channels only permission are completely free to add and do not count towards license cost",
        "success": "The invitation was successfully sent.",
        "people": {
          "email": "Email address",
          "permissions": "Permissions",
          "role": "Role",
          "title": "Title",
          "titlePlaceholder": "e.g. Project manager – Building B",
          "empty": "Type in email addresses above to add users to the invite list."
        },
        "removePersonCTA": "Remove person"
      }
    },
    "projectSettings": {
      "title": "Project settings",
      "projectDetails": {
        "title": "Project details",
        "noPermissionSave": "You don't have permission to edit project details"
      },
      "archive": {
        "title": "Archive project",
        "subtitle": "Archiving this project will move it into your archived list where you can still access all of your data.",
        "actions": {
          "archive": "Archive project",
          "noPermissionArchive": "You don't have permission to archive this project"
        }
      }
    },
    "teams": {
      "title": "Organisations",
      "new": "New organisation",
      "deleteTeam": {
        "cancelCTA": "Cancel",
        "deleteCTA": "Delete",
        "subtitle": "Are you sure you want to remove {{teamName}} from this project?",
        "title": "Delete a organisation"
      },
      "list": {
        "membersPlaceholder": "people",
        "actions": {
          "updateName": "Edit name",
          "delete": "Delete"
        }
      },
      "invite": {
        "header": "New organisation",
        "step1": "Step 1: Set organisation name",
        "step2": "Step 2: Add responsible people",
        "emailLabel": "Add the people responsible for this organisation by email address.",
        "emailPlaceholder": "Email",
        "nameLabel": "Give the organisation a name by which it will be known on this project.",
        "namePlaceholder": "Display name",
        "actions": {
          "add": "Add another organisation",
          "cancel": "$t(actions.cancel)",
          "create": "Create organisation",
          "done": "$t(actions.done)",
          "invite": "Add and notify to join"
        }
      },
      "updateName": {
        "cancelCTA": "Cancel",
        "updateCTA": "Update",
        "teamName": "Organisation name",
        "title": "Edit organisation name",
        "errors": {
          "maxLength": "The organisation name must be at most 40 characters",
          "minLength": "The organisation name must be at least 3 characters",
          "required": "Organisation name is required"
        }
      },
      "setup": {
        "header": "Setup organisation",
        "step1": "Step 1: Set your organisation's name",
        "step2": "Step 2: Invite your colleagues",
        "emailLabel": "Invite your colleagues by email address.",
        "nameLabel": "Your project is created! It's time to set it up to collaborate with other people. Give your organisation a name by which it will be known on this project.",
        "actions": {
          "setName": "Set name",
          "done": "$t(actions.done)"
        }
      }
    },
    "people": {
      "remove": {
        "title": "Remove member",
        "subtitle": "Removing this member will revoke their access to the project.",
        "confirmCTA": "Remove",
        "cancelCTA": "Cancel",
        "removingLabel": "Removing:",
        "reassignLabel": "Reassign to:",
        "reassignPlaceholder": "Select member",
        "billing": {
          "description": "Billing for this user will end starting from the next billing cycle.",
          "removeLicense": "Remove license",
          "licenseDetails": "{{pricePerLicense}} × {{numberOfLicenses}} Shape user license"
        },
        "dependencies": {
          "description": "This member has open issues. To proceed, you must select someone to inherit these issues.",
          "noneDescription": "This member is not involved in any issues.",
          "showMoreCTA": "Show more",
          "showLessCTA": "Show less",
          "associatedIssuesTitle": "Associated issues",
          "sectionTitles": {
            "observedIssues": "Observer",
            "assignmentRequestedIssues": "Assigned (not accepted)",
            "assignedIssues": "Assigned",
            "issuesAsApprover": "Approver"
          }
        },
        "confirmModal": {
          "title": "Confirm removal",
          "subTitle": "Removing a member is permanent and cannot be undone. Are you sure you want to continue?",
          "cancelCTA": "Cancel",
          "confirmCTA": "Remove"
        },
        "toast": {
          "success": "{{name}} was removed"
        }
      },
      "edit": {
        "title": "Edit role and permissions",
        "titlePlaceholder": "e.g. Project manager – Building B",
        "labels": {
          "role": "Permissions",
          "constructionRole": "Role",
          "title": "Title"
        }
      }
    },
    "menu": {
      "customFields": "$t(admin.customFields.title)",
      "locations": "Locations",
      "disciplines": "Disciplines",
      "teams": "Organisations",
      "accessRequests": "Access & permission requests",
      "contracts": "Contracts",
      "resources": "Resources",
      "projectSettings": "Project settings"
    }
  },
  "auth": {
    "page": {
      "title": "Log in or create an account",
      "emailLabel": "Work email",
      "continueCTA": "Continue"
    },
    "forgotPassword": {
      "backToLogin": {
        "backTo": "Back to",
        "login": "login"
      },
      "step1": {
        "title": "Reset your password",
        "subtitle": "Enter your email address to receive password reset instructions.",
        "resetPassword": "Reset password",
        "resetFailed": "There was a problem sending the reset instructions. Please try again!"
      },
      "step2": {
        "title": "Change password",
        "subtitle": "Enter a new password along with the code we've sent to",
        "enterSixDigitCode": "Enter 6-digit code",
        "password": "Password",
        "confirmPassword": "Confirm password",
        "changePassword": "Change password",
        "haventReceivedCode": "Haven't received the code or it expired?",
        "resendCode": "Resend verification code",
        "havingTrouble": "Having trouble with changing your password?",
        "contactUs": "Contact us",
        "verificationCodeResent": "Verification code resent",
        "resetFailed": "There was a problem resetting your password. Please try again!",
        "resendFailed": "There was a problem resending the verification code. Please try again!"
      },
      "step3": {
        "title": "New password set",
        "subtitle": "You can now log in with your new password."
      }
    },
    "confirmEmail": {
      "title": "Enter verification code",
      "subtitle": "To verify your email, enter the code we've sent to <b>{{email}}</b>.",
      "backToLogin": {
        "backTo": "Back to",
        "loginLink": "login"
      },
      "resendEmail": {
        "question": "Haven't received the code or it expired?",
        "resendButton": "Resend verification code"
      },
      "toast": {
        "success": "Email verified."
      },
      "support": "Having trouble with verifying your email?",
      "contactUs": "Contact us"
    },
    "accountLocked": {
      "title": "Account locked",
      "subtitle": "For your security, your account has been temporarily locked after multiple unsuccessful login attempts. You can try again in 60 minutes, or unlock your account now using a verification code sent to your email.",
      "unlockButton": "Unlock with verification code",
      "backToLogin": {
        "backTo": "Back to",
        "loginLink": "login"
      }
    },
    "unlockAccount": {
      "title": "Unlock account and log in",
      "subtitle": "Enter the verification code we sent to your email.",
      "codePlaceholder": "Enter 6-digit code",
      "passwordLabel": "Password",
      "submitButton": "Unlock account and log in",
      "resendEmail": {
        "question": "Haven't received the code or it expired?",
        "resendButton": "Resend verification code"
      },
      "support": "Having trouble with verifying your email?",
      "contactUs": "Contact us",
      "errors": {
        "default": "The code is invalid"
      },
      "backToLogin": {
        "backTo": "Back to",
        "loginLink": "login"
      }
    },
    "login": {
      "title": "Log in",
      "emailLabel": "Work email",
      "passwordLabel": "Password",
      "submitCTA": "Log in",
      "forgotYourPassword": "Forgot your password?",
      "notYou": "Not you?"
    },
    "resetPassword": {
      "contactUs": "Contact us",
      "support": "Having trouble with resetting your password?",
      "successStatus": {
        "title": "New password set",
        "subtitle": "You can now log in with your new password."
      },
      "failureStatus": {
        "alertMessage": "There was a problem resetting your password. Please try again!"
      },
      "backToLogin": {
        "backTo": "Back to",
        "loginLink": "login"
      },
      "expiredLink": {
        "title": "Expired link",
        "subtitle": "This reset password link has expired. You may generate a new one by clicking the button below.",
        "resendCTA": "Resend link"
      }
    },
    "signup": {
      "createAccount": {
        "title": "Create an account",
        "createCTA": "Create account",
        "emailInputLabel": "Work email",
        "firstNameInputLabel": "First name",
        "lastNameInputLabel": "Last name",
        "passwordInputLabel": "Password"
      },
      "eua": {
        "statement": "I've read and accept the",
        "euaLink": "User Agreement"
      },
      "backToLogin": {
        "hasAccount": "Already have an account?",
        "loginLink": "Log in"
      },
      "notYou": "Not you?",
      "google": {
        "title": "You are creating an account using Google"
      },
      "microsoft": {
        "title": "You are creating an account using Microsoft",
        "continueWithCTA": "Continue with Microsoft",
        "loginFailed": "Microsoft login failed. Please try again."
      }
    },
    "or": "or",
    "passwordCheckList": {
      "min": "At least 8 characters",
      "uppercase": "Includes uppercase letter",
      "lowercase": "Includes lowercase letter",
      "number": "Contains number",
      "special": "Contains special characters",
      "match_passwords": "Passwords must match"
    },
    "verificationSent": {
      "success": "New verification email sent.",
      "fail": "There was a problem resending the email, please try again."
    },
    "sso": {
      "title": "Log in with Google or Microsoft",
      "subtitle": "Your organisation requires Single Sign-On (SSO) for authentication. Please log in using your Google or Microsoft account to continue.",
      "backTo": "Go back"
    }
  },
  "channels": {
    "channelOtherMembers_zero": "{{name}} + {{count}} others",
    "channelOtherMembers_one": "{{name}} + 1 other",
    "channelOtherMembers_other": "{{name}} + {{count}} others",
    "previewAvatar": {
      "personal": "Personal avatar",
      "messaging": "User avatar",
      "channel": "Channel avatar",
      "issue": "Issue avatar"
    },
    "channelInvitationGuide": {
      "title": "How does this work?",
      "subTitle": "Log in or create a Shape account to join this organisation.",
      "joinTeamDescription": "Join {{teamName}} on Channels by 3 simple steps!",
      "contactSupport": "Contact our support",
      "helpText": "Need help? Visit our",
      "or": "or",
      "faqUrl": "https://help.shape.construction/en-gb/i-got-an-invitation-to-join-channels.-now-what",
      "faq": "FAQ",
      "step1": {
        "title": "Step 1",
        "description": "Create a Shape account or log in if you have an existing one."
      },
      "step2": {
        "title": "Step 2",
        "description": "Accept the organisation’s invitation once you are logged in."
      },
      "step3": {
        "title": "Step 3",
        "description": "Download and install Channels on your Android or Apple device.\n<br/><br/>\nOnce installed, log in using the account you used to accept the organisation's invitation.\n<br/><br/>\nYou can also scan the QR code below.\n"
      }
    },
    "events": {
      "delete": "The group was deleted"
    },
    "inviteDialog": {
      "description": "You are currently logged-in as {{email}}",
      "differentAccount": "Use a different account",
      "thisAccount": "Join using this account"
    },
    "invite": {
      "loading": "Loading",
      "joining": "Joining organisation...",
      "expired": "This invitation link has already expired.",
      "description": "You are invited to join this organisation on Channels",
      "storesTitle": "Don't have Channels yet?",
      "storesSubTitle": "Or continue exploring Shape",
      "webApp": "Shape web app",
      "successfully": "Successfully joined {{teamName}}"
    },
    "accessRequested": {
      "title": "Access requested",
      "description": "We've notified the {{projectName}} admin. You will receive an email when you're approved.",
      "downloadDescription": "Download and install Channels on your Android or Apple device. Once installed, log in using the account you used to accept the team's invitation.",
      "scanQR": "You can also scan the QR code below.",
      "qrCodeAlt": "QR code to download the app"
    },
    "join": {
      "loading": "Loading",
      "description": "You are not currently a member of this project yet. To view the channels and start messaging, please submit a request to the project administrator.",
      "requestAccess": "Request access",
      "notFound": "This project could not be found. Please check the link and try again.",
      "form": {
        "team": {
          "label": "Organisation",
          "placeholder": "Your organisation",
          "description": "Which organisation do you work for? This will help route your request to the right person.",
          "errorMessage": "Required field"
        },
        "email": {
          "label": "Send to (optional)",
          "placeholder": "admin@email.com",
          "description": "If you know an admin, type in their email to get access quicker.",
          "errorMessage": "Must be a valid email"
        },
        "message": {
          "label": "Message (optional)",
          "description": "Add a message to let the admin know why you want access."
        },
        "submitCTA": "Request access"
      }
    },
    "channelsList": {
      "title": "Channels web",
      "search": "Search channel or member name",
      "tabs": {
        "following": "Following",
        "issues": "Issues",
        "locations": "Locations",
        "all": "All",
        "unreadLabel": "has unread messages"
      },
      "followingChannels": {
        "emptyState": {
          "title": "No followed channels yet",
          "description": "Get notified about updates from followed channels. To follow a channel, open it and click the star in the header.",
          "seeAllChannels": "See all channels"
        }
      },
      "allChannels": {
        "emptyState": {
          "title": "No channels yet"
        }
      },
      "issueChannels": {
        "emptyState": {
          "title": "No issue channels yet",
          "subtitle": "Capture an issue to create an issue channel."
        }
      },
      "locationChannels": {
        "emptyState": {
          "title": "No locations yet",
          "description": "If you're a project administrator, go to Admin settings and add locations."
        }
      }
    },
    "details": {
      "actions": {
        "edit": "Edit",
        "leaveChannel": "Leave channel",
        "deleteGroup": "Delete group",
        "addMembers": {
          "title": "Add members",
          "description": "Existing Channels members"
        }
      },
      "addMembers": {
        "title": "Add members",
        "searchPlaceholder": "Search",
        "alreadySelected": "Already added to the group",
        "actions": {
          "done": "$t(actions.done)"
        },
        "notifications": {
          "success": "Members added successfully",
          "error": "Error adding members"
        }
      },
      "edit": {
        "title": "Edit group",
        "titlePlaceholder": "Group name",
        "addPhoto": "Add photo",
        "editPhoto": "Edit photo",
        "success": "Group updated successfully",
        "error": "Error updating the group",
        "actions": {
          "cancel": "$t(actions.cancel)",
          "save": "Save changes",
          "removePhoto": "Remove photo"
        }
      },
      "groupMemberOptions": {
        "removeFromGroup": "Remove from group",
        "makeGroupModerator": "Make a group moderator",
        "dismissModerator": "Dismiss as moderator",
        "openMemberOptionsLabel": "Open member options"
      },
      "removeMembers": {
        "notifications": {
          "removeMemberSuccess": "{{username}} removed {{member}} from the group",
          "removeMemberError": "Failed to remove member"
        },
        "removeMemberConfirmation": {
          "title": "Remove member",
          "description": "Are you sure you want to remove {{member}} from this group?",
          "actions": {
            "cancel": "$t(actions.cancel)",
            "delete": "$t(actions.yes)"
          }
        }
      },
      "updateMembersRole": {
        "notifications": {
          "memberToModeratorSuccess": "{{member}} is now a moderator",
          "memberNoLongerModeratorSuccess": "{{member}} is no longer a moderator",
          "updateMembersRoleError": "Failed to update members role"
        }
      },
      "channelType": {
        "team": "Organisation",
        "group": "Group",
        "messaging": "Private",
        "personal": "Personal",
        "issue": "Issue channel",
        "location": "Location channel"
      },
      "deleteConfirmation": {
        "title": "Delete for all",
        "subTitle": "Do you want to delete the group and all its messages for everyone? This action cannot be undone.",
        "cancelCTA": "$t(actions.cancel)",
        "deleteCTA": "$t(actions.delete)",
        "error": "Error deleting the group",
        "success": "Group deleted successfully"
      },
      "leaveConfirmation": {
        "title": "Leave channel",
        "subTitle": "Are you sure you want to leave this channel?",
        "cancelCTA": "$t(actions.cancel)",
        "leaveCTA": "$t(actions.yes)"
      },
      "members": "{{count}} members",
      "moderator": "Moderator",
      "mediaSection": {
        "title": "Auto-upload media and documents to Shape gallery",
        "subtitle": "If on, all files uploaded in this channel will automatically be added to Shape's gallery."
      }
    },
    "channel": {
      "messageInput": {
        "placeholder": "Send a message",
        "dragUploadAccepted": "Drag your files here",
        "dragUploadRejected": "Some of the files will not be accepted",
        "fileSizeError": "The file \"{{filename}}\" should be greater than {{min}} bytes and smaller than {{max}} MB"
      },
      "header": {
        "subtitle": "Click here for conversation settings",
        "events": {
          "typing_zero": "{{users, list}} are typing...",
          "typing_one": "{{users, list}} is typing...",
          "typing_other": "{{users, list}} are typing..."
        },
        "detailsCTA": "Details",
        "follow": "Follow channel",
        "unfollow": "Unfollow channel",
        "followedToast": "Channel followed. All updates will notify you unless muted.",
        "unfollowedToast": "Channel unfollowed. You will only be notified when you are @mentioned."
      },
      "preview": {
        "followingLabel": "Following",
        "mutedLabel": "Notifications muted"
      }
    },
    "newChannel": {
      "action": "Create new channel",
      "title": "Select a contact",
      "searchPlaceholder": "Search",
      "errorMessages": {
        "creatingChannelError": "Error on creating channel"
      },
      "newGroup": {
        "action": "New group",
        "membersStep": {
          "title": "Add people"
        },
        "infoStep": {
          "avatarPlaceholder": "Change",
          "groupNamePlaceholder": "Group name (optional)",
          "membersCount": "People: {{count}}",
          "selectedUsers": "Selected users",
          "title": "Channel info",
          "uploadErrorMessage": "The file selected has an unsupported extension or must be smaller than {{max}} MB"
        }
      }
    },
    "messages": {
      "actions": {
        "copy": "Copy message",
        "delete": "Delete message",
        "edit": "Edit message",
        "reply": "Reply",
        "saveToGallery": "Save to Shape gallery"
      },
      "copyMessage": "Link copied to clipboard",
      "deleteConfirmation": {
        "title": "Delete message",
        "subTitle": "Are you sure you want to permanently delete this message?",
        "cancel": "$t(actions.cancel)",
        "delete": "Delete"
      },
      "editMessage": {
        "title": "Edit message",
        "cancel": "$t(actions.cancel)"
      },
      "saveToGallery": {
        "success": "Attachments saved to gallery"
      }
    },
    "channelError": {
      "title": "Channel not available",
      "description": "This channel does not belong to the current project or could not be found.",
      "backToChannels": "Back to Channels"
    }
  },
  "crashReport": {
    "title": "Something went wrong",
    "cancelCTA": "Cancel",
    "submitCTA": "Submit",
    "description": {
      "label": "Please tell us what happened"
    },
    "subject": "User crash report"
  },
  "currentUserLabel": "(You)",
  "dataBook": {
    "title": "Data book",
    "overview": "Overview",
    "analyse": {
      "trigger": "Analyse",
      "heading": "View dashboards",
      "opensInNewTab": "(opens in new tab)"
    },
    "menu": {
      "home": "Home",
      "shiftManager": {
        "title": "Shift reports"
      },
      "issueTracker": {
        "title": "Issues"
      },
      "activities": {
        "title": "Activities"
      },
      "changeTracker": {
        "title": "Change tracker"
      },
      "channels": {
        "title": "Channels"
      },
      "customDashboard": {
        "title": "Custom dashboards"
      }
    },
    "metabaseIframeTitle": "Metabase Dashboard",
    "page": {
      "unlockPage": {
        "primaryButton": "Upgrade to pro"
      },
      "paywall": {
        "badge": {
          "title": "Unlock full data access with a Pro account"
        }
      },
      "shiftManager": {
        "title": "Shift reports",
        "description": "Offers actionable insights into shift report quality and employee engagement. Enable your team to track report health, identify data gaps, and monitor hours allocation trends for better workforce planning and decision-making.",
        "insights": {
          "title": "{{teamName}} performance"
        },
        "otherInsights": "Insights"
      },
      "shiftReportsHeatmap": {
        "title": "Heatmap",
        "description": "See shift report quality and consistency over time."
      },
      "ganttView": {
        "title": "Gantt view",
        "description": "Visualise project activities and timelines in a Gantt chart.",
        "table": {
          "activityDetails": "Activity details",
          "headers": {
            "name": "Name",
            "location": "Location",
            "id": "ID",
            "percentage": "%",
            "insights": "Insights",
            "start": "Start",
            "finish": "Finish"
          },
          "dailyLogCellLabel": "View daily log for {{activityName}} on {{date}}"
        },
        "emptyState": {
          "title": "No activities found",
          "body": "Try adding new activities or changing the date filter.",
          "manageActivities": "Manage activities",
          "changeDateFilter": "Change date filter"
        },
        "pagination": {
          "activitiesCount": "Showing <span class=\"font-semibold\">{{count}}</span> of <span class=\"font-semibold\">{{total}}</span> activities"
        },
        "insights": {
          "completed": "Completed",
          "inProgress": "In progress",
          "liveDelay": "Live delay",
          "potentialDelay": "Potential delay",
          "notStarted": "Not started",
          "start": "Start",
          "finish": "Finish"
        }
      },
      "shiftReportDataQuality": {
        "title": "Data quality",
        "description": "Deep dive into shift report quality. See where data is missing."
      },
      "shiftReportResourceAllocation": {
        "title": "Resource allocation",
        "description": "Analyse plant, labour, and material utilisation."
      },
      "issueTracker": {
        "title": "Issues",
        "description": "Monitor issues' quality health, identify data gaps, track workforce trends, and analyze issues and delays across projects. Immediately see areas needing attention and showcasing good practices for better planning, accountability, and overall performance improvement.",
        "insights": {
          "title": "{{teamName}} performance"
        }
      },
      "issuesHealthHeatmap": {
        "title": "Heatmap",
        "description": "See issues quality and consistency over time."
      },
      "issuesAnalytics": {
        "title": "Analytics",
        "description": "Issue tracking and data quality with open items and due date changes."
      },
      "issuesDelays": {
        "title": "Delays",
        "description": "Project performance highlighting delays to drive accountability."
      },
      "activities": {
        "title": "Activities"
      },
      "changeTracker": {
        "title": "Change tracker"
      },
      "weeklyPlanner": {
        "title": "Weekly planner"
      },
      "channels": {
        "title": "Channels"
      },
      "customDashboard": {
        "title": "Custom dashboards",
        "insights": "Insights",
        "badgeLabel": "PRO",
        "unlockPage": {
          "title": "Unlock custom dashboards - upgrade to pro",
          "description": "Get full control with custom dashboards - track what matters most, your way.",
          "primaryButton": "Upgrade",
          "secondaryButton": "Talk to us"
        },
        "addMore": {
          "heading": "Custom dashboards",
          "title": "Create a custom dashboard",
          "description": "Tailor your dashboard to what matters most for you and your team.",
          "btnTitle": "Talk to us"
        },
        "email": {
          "subject": "Custom dashboard request",
          "body": "Hello Shape team. I would like to create a custom dashboard for my organisation {{teamName}} [organisation id: {{teamId}}]."
        }
      },
      "heatmapDashboard": {
        "heatmap": {
          "title": "{{teamName}} performance",
          "navigateNextLabel": "Next",
          "navigatePreviousLabel": "Previous",
          "cell": {
            "label": "Score",
            "popover": {
              "label": "Health Score",
              "clickForDetails": "Click for details",
              "noPublishedRecord": "No published records",
              "publishedRecords": "Published records: <b>{{recordCount}}</b>",
              "averageScore": "Average score: <b>{{score}}%</b>"
            }
          },
          "axisLabels": {
            "to": "to"
          },
          "emptyState": {
            "title": "No data available yet",
            "body": "This chart will update automatically as users start submitting records. Invite your organisation members to Shape and start tracking their performance.",
            "inviteButton": {
              "label": "Invite people"
            }
          },
          "qualityLabel": {
            "title": "Completeness",
            "notUseful": "Not useful",
            "theBasics": "The basics",
            "good": "Good",
            "veryGood": "Very good",
            "comprehensive": "Comprehensive"
          }
        },
        "performanceDetails": {
          "title": "Performance detail",
          "shiftReportsTable": {
            "label": "Shift reports",
            "reportTitle": "Report {{reportDate}}",
            "headers": {
              "document": "Document",
              "score": "Score",
              "date": "Date",
              "shift": "Shift",
              "attachments": "Attachments"
            },
            "emptyState": {
              "title": "No reports found",
              "body": "This user hasn't submitted any reports for the selected time frame."
            }
          },
          "issuesTable": {
            "label": "Issues",
            "headers": {
              "title": "Title",
              "currentResponsible": "Current responsible",
              "score": "Score"
            },
            "emptyState": {
              "title": "No reports found",
              "body": "This user hasn't submitted any reports for the selected time frame."
            }
          }
        },
        "healthLevels": {
          "0": {
            "label": ""
          },
          "1": {
            "label": "Not useful",
            "issues": {
              "scoreRange": "Score range: 0-19%",
              "description": "Issues are severely lacking in essential information or have been inactive for too long."
            }
          },
          "2": {
            "label": "The basics",
            "issues": {
              "scoreRange": "Score range: 20-39%",
              "description": "Issues have some foundational details, but significant gaps make it difficult to take action."
            }
          },
          "3": {
            "label": "Good",
            "issues": {
              "scoreRange": "Score range: 40-59%",
              "description": "Issues meet minimum documentation standards but lack thoroughness, timeliness, or supporting evidence."
            }
          },
          "4": {
            "label": "Very good",
            "issues": {
              "scoreRange": "Score range: 60-79%",
              "description": "Issues are well-documented, active, and include most required information, though some areas could be improved."
            }
          },
          "5": {
            "label": "Comprehensive",
            "issues": {
              "scoreRange": "Score range: 80%+",
              "description": "Issues are fully complete, timely, and backed by strong supporting evidence, making them actionable and reliable."
            }
          }
        }
      }
    },
    "breadcrumbs": {
      "dataBook": "Data book",
      "shiftManager": "Shift reports",
      "issueTracker": "Issues",
      "activities": "Activities",
      "changeTracker": "Change tracker",
      "weeklyPlanner": "Weekly planner",
      "channels": "Channels",
      "customDashboard": "Custom dashboards"
    },
    "actions": {
      "helpSection": {
        "title": "Get to know more",
        "productTours": {
          "title": "Product tours",
          "description": "Explore shape through interactive tours & video guides.",
          "btnTitle": "Explore tours"
        },
        "helpCenter": {
          "title": "Help center",
          "description": "Self-service access to guides, FAQs, and support resources for Shape.",
          "btnTitle": "Visit help center"
        },
        "contactSupport": {
          "title": "Contact support",
          "description": "Need help? Reach out to our customer support for any assistance.",
          "btnTitle": "Send as an email"
        }
      },
      "pageToolbar": {
        "filters": "Filters",
        "needHelp": "Need help?",
        "share": "Share",
        "export": "Export"
      }
    },
    "share": {
      "shareButton": "Share",
      "popoverTitle": "Share dashboard link"
    }
  },
  "issuesScoring": {
    "label": "Issues scoring criteria",
    "scoringInfoCTA": "Score criteria",
    "tooltipText": "Click to see how issue quality scores are calculated.",
    "basics": {
      "title": "The basics",
      "titleInfo": "{{complete}} / {{total}}%",
      "description": "Description (at least 20 characters)",
      "validAssignee": "Valid assignee or responsible person",
      "lastActivityWithinFourWeeks": "Last activity is within 4 weeks or if the issue is resolved."
    },
    "additionalDetails": {
      "title": "Additional details",
      "note": "Additional details aren't included in the score until the basics are completed",
      "completionNote": "Complete the basics to unlock additional details",
      "location": {
        "title": "Location",
        "description": "Valid location",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "impact": {
        "title": "Impact",
        "description": "Impact is indicated",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "category": {
        "title": "Category",
        "description": "Type / Sub-type is specified",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "dueDate": {
        "title": "Due date",
        "description": "Due date is specified",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "discipline": {
        "title": "Discipline",
        "description": "Discipline",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "attachments": {
        "title": "Attachments",
        "description": "Includes a supporting attachment",
        "titleInfo": "{{complete}} / {{total}}%"
      },
      "staleness": {
        "title": "Staleness",
        "description": "The last activity is within 2 weeks or if the issue is resolved.",
        "titleInfo": "{{complete}} / {{total}}%"
      }
    },
    "notes": {
      "title": "Notes",
      "heatmapVisibility": "An issue remains visible in the heatmap for each week it is active (until resolved).",
      "scoreEvolution": "The score can change as more details are added or if the issue becomes stale."
    }
  },
  "dateTime": {
    "date": "Date",
    "time": "Time",
    "timezoneInfo": "Date/time must refer to <b>{{timezone}}</b>",
    "dateShouldBeFuture": "The date should be in the future."
  },
  "error": {
    "title": "Something went wrong",
    "content": "If this problem persists, please",
    "contactCTA": "contact us",
    "submitFeedbackCTA": "Submit feedback",
    "goBackCTA": "Go back to the project",
    "sessionError": "If you are experiencing login/signup issues,",
    "sessionErrorCTA": "click here",
    "version": "Shape version {{version}}",
    "file_too_big": "The file \"{{filename}}\" exceeds the maximum allowed size of {{max}} MB",
    "file_size_zero": "The file \"{{filename}}\" needs to be greater than {{min}} bytes",
    "uploadError": "Could not upload"
  },
  "errors": {
    "characterLimit": "{{fieldName}} must be at most {{maxLength}} characters",
    "requiredField": "Required field",
    "minValue": "Must be at least {{min}}",
    "invalidPhoneNumber": "Invalid phone number",
    "invalidDate": "Invalid date",
    "invalidTime": "Invalid time",
    "incompleteDateTime": "Enter a time as well as a date",
    "validNumber": "This field should be a valid number",
    "fieldGreaterThan": "This field should be greater than {{number}}",
    "fieldLessThan": "This field should be less than {{number}}",
    "validEmail": "Must be a valid email",
    "validWorkEmail": "Please make sure you use your work email.",
    "nameTooShort": "Name too short",
    "nameTooLong": "Name too long",
    "shortNameTooShort": "Short name too short",
    "mustBeLessThan": "Must be less than {{number}} characters",
    "projectsTimezone": "Projects must have a timezone",
    "verificationCode": "Verification code is required",
    "digitCode": "Must be a {{number}}-digit code",
    "passwordChars": "Passwords must be at least {{number}} characters",
    "passwordMatch": "Passwords must match",
    "oneRequired": "At least one field is required",
    "pleaseValidEmail": "Please provide a valid email address",
    "minimumChars": "Must have a minimum of {{number}} characters",
    "requiredName": "Name is required",
    "enterEmail": "Please enter an email address",
    "exceedDuration": "Duration must not exceed {{number}} days.",
    "acceptUserAgreement": "You must accept our User Agreement",
    "invalidType": "Invalid type",
    "fileUpload": {
      "fileTypeInvalid": "\"{{filename}}\" is not a .jpeg, .jpg or .png. Please upload in a supported format.",
      "fileSizeMin": "\"{{filename}}\" needs to be at least {{min}} bytes. Please upload a larger file.",
      "fileSizeMax": "\"{{filename}}\" cannot be more than {{max}} MB. Please upload a smaller file."
    }
  },
  "eua": {
    "title": "We've updated our End User Licence Agreement",
    "content": "To continue using the Shape app, please read and accept the updated Agreement. This will take effect on {{date}}.",
    "acceptCTA": "Accept",
    "loginCTA": "Back to login",
    "readCTA": "Read End User Licence Agreement",
    "modal": {
      "title": "End User Licence Agreement",
      "date": "Effective {{date}}"
    }
  },
  "exports": {
    "toasts": {
      "loading": "Your {{exportType}} export is in progress. It will automatically download when it's ready.",
      "success": "Export complete. If the download didn't start, please click the button below.",
      "failed": "Your {{exportType}} Export failed. Please try exporting again. If a problem arises, please check your internet connection."
    },
    "download": "Download",
    "operationName": {
      "issue": "issue",
      "issue_list": "bulk issue",
      "potential_change": "change",
      "shift_activity_list": "shift activity",
      "shift_report": "shift report",
      "shift_report_list": "bulk shift report",
      "weekly_work_plan": "weekly work plan",
      "weekly_work_plan_lookback": "weekly work plan lookback"
    }
  },
  "filters": {
    "toolbar": {
      "fields": {
        "label": "Fields"
      },
      "label": "Filters",
      "clearCTA": "Clear all",
      "dateSelectFilter": {
        "triggerLabel": "Date",
        "filterByLabel": "Select a date",
        "options": {
          "all": "All",
          "today": "Today",
          "yesterday": "Yesterday",
          "tomorrow": "Tomorrow",
          "thisWeek": "This week",
          "thisMonth": "This month",
          "sevenDaysAgo": "Last 7 days",
          "thirtyDaysAgo": "Last 30 days",
          "nextWeek": "Next week",
          "nextTwoWeeks": "Next 2 weeks",
          "nextFourWeeks": "Next 4 weeks",
          "nextEightWeeks": "Next 8 weeks",
          "custom": "Custom"
        },
        "plannedStart": {
          "triggerLabel": "Planned start",
          "filterByLabel": "Filter by planned start date"
        },
        "plannedEnd": {
          "triggerLabel": "Planned finish",
          "filterByLabel": "Filter by planned finish date"
        },
        "actualStart": {
          "triggerLabel": "Actual start",
          "filterByLabel": "Filter by actual start date"
        },
        "actualEnd": {
          "triggerLabel": "Actual finish",
          "filterByLabel": "Filter by actual finish date"
        },
        "expectedFinish": {
          "triggerLabel": "Expected finish",
          "filterByLabel": "Filter by expected finish date"
        },
        "happenedOn": {
          "triggerLabel": "Happened on",
          "filterByLabel": "Filter by date"
        }
      },
      "peopleSelectFilter": {
        "triggerLabel": "Author",
        "createdByTriggerLabel": "Created by",
        "responsibleTriggerLabel": "Responsible",
        "filterByLabel": "Filter by author",
        "responsibleFilterByLabel": "Filter by responsible",
        "searchPlaceholder": "Search for a person"
      },
      "ownerSelectFilter": {
        "triggerLabel": "Activity owner",
        "filterByLabel": "Filter by activity owner",
        "searchPlaceholder": "Search for an activity owner"
      },
      "categorySelectFilter": {
        "triggerLabel": "Category",
        "drawerTitle": "Categories",
        "searchPlaceholder": "Search for category / sub-category",
        "noCategory": "No category / sub-category"
      },
      "criticalSelectFilter": {
        "triggerLabel": "Critical",
        "filterByLabel": "Filter by critical",
        "options": {
          "all": "All",
          "critical": "Critical",
          "notCritical": "Not critical"
        }
      },
      "disciplineSelectFilter": {
        "triggerLabel": "Discipline",
        "drawerTitle": "Disciplines",
        "searchPlaceholder": "Search for discipline",
        "noDisciplineLabel": "No discipline"
      },
      "searchFilter": {
        "placeholder": "Search",
        "activitiesPlaceholder": "Search by name, reference or task ID"
      },
      "statusSelectFilter": {
        "triggerLabel": "Status",
        "filterByLabel": "Filter by status"
      },
      "locationSelectFilter": {
        "triggerLabel": "Location",
        "drawerTitle": "Locations",
        "searchPlaceholder": "Search for a location",
        "noLocationLabel": "No location"
      },
      "resourcesSelectFilter": {
        "triggerLabel": "Organisation",
        "filterByLabel": "Filter by organisation",
        "searchPlaceholder": "Search for an organisation",
        "loadMoreSuffix": {
          "person": "people",
          "role": "roles",
          "organisation": "organisations",
          "equipment": "equipment",
          "material": "materials"
        }
      },
      "weeklyPlanSelectFilter": {
        "placeholder": "Select work plan",
        "loading": "Loading",
        "loadMore": "Load more work plans"
      },
      "selectAllFilter": {
        "triggerLabel": "{{count}} selected",
        "options": {
          "selectNone": "Select none",
          "selectAllVisible": "Select all visible ({{count}} items)"
        }
      },
      "group": {
        "triggerLabel": "Group by",
        "filterByLabel": "Group by",
        "options": {
          "none": "None",
          "responsible": "Responsible",
          "location": "Location",
          "organisation": "Organisation"
        }
      }
    }
  },
  "feedbackForm": {
    "title": "Send feedback",
    "supportMessage": "If you have any problem, please send an email to",
    "likeQuestion": {
      "question": "What do you like about Shape?"
    },
    "improveQuestion": {
      "question": "What can we improve?"
    },
    "cancelCTA": "Cancel",
    "submitCTA": "Submit",
    "successMessage": "Thanks. Feedback submitted."
  },
  "helpCenter": {
    "title": "Help & Tips",
    "learnMore": "Learn more about Shape",
    "requestDemo": "Request a demo",
    "contact": "Contact support",
    "goTo": "Go to help center",
    "productTipsAlert": {
      "title": "Product tips",
      "cta": "See tips"
    },
    "articles": {
      "title": "Need some help?",
      "readMore": "Read more",
      "emptyState": {
        "title": "No entries found",
        "descriptionPart1": "We couldn't find any articles related to the current page. You can visit our",
        "helpCenterLink": "help center",
        "descriptionPart2": "and browse available articles, or you can",
        "contactSupportLink": "contact support",
        "descriptionPart3": "directly."
      }
    }
  },
  "imageMarkupEditor": {
    "title": "Image editor",
    "saveImage": "Save annotations"
  },
  "imageCaptionModal": {
    "title": "Edit caption",
    "caption": "Caption",
    "filename": "File name",
    "filetype": "File type",
    "cancelCTA": "Cancel",
    "updateCTA": "Update"
  },
  "install": {
    "altTitle": "Shape",
    "altDescription": "Refreshingly simple construction management.",
    "installTitle": "Install Shape",
    "installDescription": "Get the best Shape experience by installing the app on your device.",
    "mobileDescription": "Get the best experience on your device.",
    "mobileButton": "Install"
  },
  "installShape": {
    "title": "Install Shape",
    "description": "Shape works better on the app. Stay up-to-date with your site and interact with it.",
    "primaryCTA": "Install",
    "cancelCTA": "Later",
    "iOS": {
      "title": "Install Shape",
      "descriptionPrefix": "Quickly access Shape and never miss an update. Tap the share icon",
      "descriptionPostfix": "and then select \"Add to Home Screen\" to stay connected on the go."
    }
  },
  "issue": {
    "new": {
      "title": "New issue",
      "options": {
        "complete": {
          "title": "Complete",
          "description": "Go step by step through all the details needed."
        },
        "quick": {
          "title": "Quick",
          "description": "Only needs a title. Best choice for people who are on site with a mobile device."
        },
        "smart": {
          "title": "Smart issue",
          "description": "Drop in a quick blurb and any photos. We'll fill out the rest.",
          "aiPoweredBeta": "AI-powered Beta"
        }
      },
      "controls": {
        "saveCTA_large": "Save draft",
        "saveCTA": "Save",
        "backCTA": "Back",
        "nextCTA": "Next"
      },
      "savedDraftOverlay": {
        "title": "Issue draft saved!",
        "description": "Your issue is now saved as a draft. You can edit, add more details or delete it. It won’t be visible to anyone until you submit it.",
        "primaryCTA": "OK!",
        "deleteCTA": "Delete draft"
      },
      "deleteDraftOverlay": {
        "title": "Delete draft",
        "description": "Are you sure you want to delete this draft? This action cannot be undone.",
        "cancelCTA": "Cancel",
        "deleteCTA": "Delete"
      },
      "dueDate": {
        "description": "When is this issue due?",
        "labels": {
          "dueDate": "Due date",
          "dueTime": "Due time"
        }
      },
      "titleAndDescription": {
        "description": "What's the issue?",
        "labels": {
          "title": "Title",
          "titlePlaceholder": "Briefly describe the issue",
          "description": "Description",
          "descriptionPlaceholder": "Add more details"
        }
      },
      "category": {
        "description": "What's the issue type?"
      },
      "assign": {
        "description": "Choose a responsible person"
      },
      "location": {
        "description": "What's the location?"
      },
      "discipline": {
        "description": "What type of work is affected?",
        "level0": "All disciplines",
        "level0ShortCode": "ALL"
      }
    },
    "quickCapture": {
      "title": "New quick issue",
      "hint": "If you need to update or add more details,<br/>visit the Issues page.",
      "fields": {
        "title": {
          "label": "Title",
          "placeholder": "Short description",
          "errors": {
            "required": "Title is required",
            "length": "Title too long"
          }
        },
        "description": {
          "label": "Description",
          "placeholder": "Add more details if needed"
        },
        "media": {
          "label": "Upload an image",
          "invalidSizeError": "The file \"{{filename}}\" needs to be greater than {{min}} bytes and less than {{max}} MB"
        },
        "createAnother": {
          "label": "Create another"
        }
      },
      "actions": {
        "cancel": "Cancel",
        "create": "Create"
      }
    },
    "smartIssue": {
      "title": "Smart issue",
      "subtitle": "This AI-Powered feature is in Beta. Please review the draft created.",
      "fields": {
        "content": {
          "label": "Add a quick blurb and we'll find out the rest",
          "placeholder": "Describe the issue, attach photos, and we'll prepare a pre-filled issue for you.",
          "errors": {
            "required": "Please enter a description"
          }
        },
        "media": {
          "label": "Media",
          "invalidSizeError": "The file \"{{filename}}\" needs to be greater than {{min}} bytes and less than {{max}} MB"
        }
      },
      "actions": {
        "cancel": "Cancel",
        "generate": "Generate",
        "generating": "Generating"
      },
      "toasts": {
        "failed": "Something went wrong while creating your issue. Please try again."
      }
    },
    "uploadSync": {
      "status": {
        "success": "Your unpublished issue has been saved.",
        "offline": "Your issue has been saved. We'll try to upload it later on Issues > Unpublished tab once you're online."
      }
    },
    "draft": {
      "title": {
        "empty": "No title entered"
      },
      "createdAt": {
        "title": "Created",
        "empty": "N/A"
      },
      "updatedAt": {
        "title": "Updated",
        "empty": "N/A"
      }
    },
    "drafts": {
      "actions": {
        "selectAll": "Select all",
        "deselectAll": "Deselect all"
      },
      "deleteModal": {
        "title_zero": "Delete drafts",
        "title_one": "Delete draft",
        "title_other": "Delete drafts",
        "subtitle_zero": "These issues will be permanently removed.",
        "subtitle_one": "This issue will be permanently removed.",
        "subtitle_other": "These issues will be permanently removed.",
        "cancelCTA": "Cancel",
        "deleteCTA": "Delete"
      }
    },
    "detail": {
      "export": {
        "exportForm": {
          "instructions": "Select the elements to include in your report.",
          "issue": "Issue",
          "project": "Project",
          "media": {
            "caption": "Added {{addedAt}}"
          },
          "title": "Export issue",
          "print": {
            "sections": {
              "details": {
                "title": "Issue Details",
                "content": {
                  "title": "Title",
                  "description": "Description",
                  "type": "Type",
                  "status": "Status",
                  "dueDate": "Due date",
                  "discipline": "Discipline",
                  "location": "Location",
                  "createdAt": "Created at",
                  "observedAt": "Observed at",
                  "closedAt": "Closed at",
                  "statusStatement": "Status statement"
                }
              },
              "customFields": {
                "title": "Custom fields"
              },
              "impact": {
                "title": "Impact",
                "content": {
                  "impact": "Impact",
                  "dueDate": "Due date",
                  "workAffected": "Work affected",
                  "delayStart": "Delay start",
                  "delayFinish": "Delay finish",
                  "noEffect": "No effect",
                  "potentialDelay": "Potential delay",
                  "liveDelay": "Live delay",
                  "completedDelay": "Completed delay"
                }
              },
              "people": {
                "title": "People / Teams",
                "content": {
                  "responsiblePerson": "Responsible person",
                  "team": "Team",
                  "observer": "Observer"
                }
              },
              "approvers": {
                "title": "Approvers",
                "content": {
                  "pending": "Pending",
                  "approved": "Approved",
                  "rejected": "Rejected",
                  "bypassed": "Bypassed"
                }
              },
              "visibility": {
                "title": "Visibility",
                "content": {
                  "visibility": "Visibility",
                  "internal": "Private (only your team can see)",
                  "projectWide": "Public (anyone on the project can see)",
                  "specificTeams": "Specific Teams"
                }
              },
              "updates": {
                "title": "Updates",
                "content": {
                  "title": "Event"
                }
              },
              "documents": {
                "title": "Attached files & images",
                "content": {
                  "title": "Document"
                }
              }
            }
          }
        },
        "actions": {
          "cancel": "Cancel",
          "export": "Export"
        },
        "events": {
          "delete_image": "{{ownerName}} deleted an image",
          "update_image": "{{ownerName}} updated an image",
          "upload_image": "{{ownerName}} uploaded an image",
          "delete_document": "{{ownerName}} deleted a document",
          "upload_document": "{{ownerName}} uploaded a document"
        }
      },
      "title": {
        "empty": "No title entered",
        "edit": "Edit issue title"
      },
      "banners": {
        "archived": "This issue is archived.",
        "draft": "This issue is a draft and will not be visible until published.",
        "stale": "This issue is stale — no activity since {{date}}.",
        "idle": "This issue is idle — no recent activity since {{date}}."
      },
      "details": {
        "title": "Details",
        "fields": {
          "recordQuality": "Record quality"
        }
      },
      "description": {
        "collapsableText": {
          "title": "Description",
          "noContent": "Not entered"
        },
        "editModal": {
          "title": "Edit description",
          "inputLabel": "Description"
        }
      },
      "media": {
        "title": "Media",
        "tabs": {
          "images": "Images",
          "documents": "Files",
          "errors": {
            "file_too_big": "The file \"{{filename}}\" exceeds the maximum allowed size of {{max}} MB",
            "file_size_zero": "The file \"{{filename}}\" needs to be greater than {{min}} bytes"
          }
        },
        "deleteItemConfirmationModal": {
          "title": "Delete this item?",
          "subtitle": "This action can't be undone.",
          "deleteCTA": "Delete",
          "cancelCTA": "Cancel"
        }
      },
      "types": {
        "closeOut": {
          "label": "Close out",
          "description": "Incomplete work / Damage / Minor deviation / Defect",
          "shortLabel": "Close out"
        },
        "somethingNeeded": {
          "label": "Something needed",
          "description": "Access / Material / Equipment / Design / Quality doc / Safe work doc / Permit or consent",
          "shortLabel": "Something needed"
        },
        "safety": {
          "label": "Safety",
          "description": "Hazard / Positive observation",
          "shortLabel": "Safety"
        },
        "progress": {
          "label": "Progress",
          "description": "Hazard / Positive observation",
          "shortLabel": "Progress"
        },
        "incompleteWork": {
          "label": "Incomplete work",
          "description": "Elements of work still to be done",
          "shortLabel": "Inc. work"
        },
        "damage": {
          "label": "Damage",
          "description": "Damage to an installation",
          "shortLabel": "Damage"
        },
        "minorDeviation": {
          "label": "Minor deviation",
          "description": "Touch up work, minor adjustments",
          "shortLabel": "Minor dev"
        },
        "defect": {
          "label": "Defect",
          "description": "Non-conforming installation",
          "shortLabel": "Defect"
        },
        "access": {
          "label": "Access",
          "shortLabel": "Access"
        },
        "material": {
          "label": "Material",
          "shortLabel": "Material"
        },
        "equipment": {
          "label": "Equipment",
          "shortLabel": "Equipment"
        },
        "design": {
          "label": "Design",
          "shortLabel": "Design"
        },
        "qualityDocument": {
          "label": "Quality document",
          "shortLabel": "QA doc"
        },
        "safeWorkingDocument": {
          "label": "Safe work document",
          "shortLabel": "Safe work doc"
        },
        "permitOrConsent": {
          "label": "Permit or consent",
          "shortLabel": "Permit"
        },
        "hazard": {
          "label": "Hazard",
          "shortLabel": "Hazard"
        },
        "positiveObservation": {
          "label": "Positive observation",
          "shortLabel": "Pos obv"
        }
      },
      "archive": {
        "title": "Archive issue",
        "subtitle": "Please select the reason to archive.",
        "optionTitle": "Select archive reason",
        "options": {
          "withdrawn": "Withdrawn",
          "superseded": "Superseded",
          "duplicated": "Duplicated",
          "other": "Other"
        },
        "dismiss": "$t(actions.cancel)",
        "confirm": "$t(actions.archive)"
      },
      "restore": {
        "confirmation": {
          "title": "Restore issue",
          "subtitle": "Are you sure you want to restore this issue?",
          "dismiss": "$t(actions.cancel)",
          "confirm": "$t(actions.restore)"
        }
      },
      "header": {
        "overdue": "Overdue",
        "critical": "Critical",
        "quality": {
          "tooltip": "Click to increase quality score",
          "notUseful": "Not useful",
          "theBasics": "The basics",
          "good": "Good",
          "veryGood": "Very good",
          "comprehensive": "Comprehensive"
        }
      },
      "archived": "Archived",
      "impact": {
        "title": "Impact",
        "formTitles": {
          "addImpact": "Add impact",
          "editImpact": "Edit impact",
          "workAffected": "Edit work affected",
          "dueDate": "Edit due date",
          "delayStart": "Edit delay start date",
          "delayFinish": "Edit delay finish date",
          "plannedClosureDate": "Edit planned closure date"
        },
        "workAffected": {
          "label": "Work affected",
          "placeholder": "Describe the work affected of this delay"
        },
        "impactedActivities": {
          "label": "Impacted activities",
          "addActivities": "Add activities",
          "remove": "Remove activity",
          "removeConfirmation": {
            "title": "Remove this activity?",
            "subtitle": "You are about to remove an activity. This action is permanent and cannot be undone.",
            "confirmCTA": "Remove"
          },
          "toasts": {
            "addError": "Failed to link the selected activities.",
            "removeSuccess": "Activity removed successfully.",
            "removeError": "Failed to unlink the activity."
          }
        },
        "impact": {
          "notEntered": {
            "label": "Impact not entered",
            "groupingOptionLabel": "Not entered",
            "description": "The impact has not been entered."
          },
          "noEffect": {
            "label": "No effect",
            "groupingOptionLabel": "No effect",
            "description": "This issue has no effect on other works."
          },
          "potentialDelay": {
            "label": "Potential delay",
            "groupingOptionLabel": "Potential delay",
            "description": "The issue has the potential to cause delay to other works, but there is no impact yet."
          },
          "liveDelay": {
            "label": "Live delay",
            "groupingOptionLabel": "Live delay",
            "description": "The issue is preventing or slowing down progress on other works."
          },
          "completedDelay": {
            "label": "Completed delay",
            "groupingOptionLabel": "Completed delay",
            "description": "The issue has already delayed other works, but the delay is completed."
          }
        },
        "dates": {
          "afterDelayStart": "The date must be in the past and after the delay start.",
          "beforeDelayFinish": "The date must be in the past and before the delay finish.",
          "delayFinish": "Delay finish",
          "delayStart": "Delay start",
          "dueDate": "Due date",
          "shouldBeFuture": "The date should be in the future.",
          "shouldBePast": "The date should be in the past.",
          "noDate": "Not yet entered",
          "plannedClosureDate": "Planned closure date"
        }
      },
      "actions": {
        "reject": "Issue rejected",
        "approve": {
          "default": "Issue approved"
        },
        "start": "Issue started",
        "stop": "Issue not started",
        "complete": {
          "default": "Issue completed. Awaiting approval"
        },
        "reopen": "Issue reopened"
      },
      "assignments": {
        "accept": "Issue accepted",
        "reject": "Issue rejected",
        "assignedTo": "Issue assigned to {{name}}"
      },
      "state": {
        "draft": "Draft",
        "assignment_rejected": "Unassigned",
        "assigned": "Not started",
        "assignment_requested": "Pending responsible",
        "in_progress": "Started",
        "completed": "Pending approval",
        "resolved": "Resolved",
        "default": "Other"
      },
      "people": {
        "title": "People",
        "observer": {
          "title": "Observer"
        },
        "watchers": {
          "title": "Watchers",
          "originator": "Originator",
          "add": {
            "title": "Add watchers",
            "addWatcherCTA": "Add watcher",
            "removeWatcherCTA": "Remove watcher",
            "cancelCTA": "Cancel",
            "saveCTA": "Save"
          },
          "select": {
            "title": "Add watcher",
            "subtitle": "Select one person to add as a watcher.",
            "backCTA": "Go back",
            "addWatcherCTA": "Add watcher"
          }
        },
        "responsible": {
          "title": "Responsible person",
          "overlay": {
            "title": "Edit responsible person",
            "subTitle": "Select one responsible person and click assign.",
            "confirmCTA": "Assign"
          },
          "resolvedError": {
            "title": "Ooops!",
            "subtitle": "Resolved issues cannot be reassigned. Please reopen the issue to change the responsible person.",
            "acknowledgeCTA": "Okay"
          }
        }
      },
      "approvers": {
        "title": "Approvers",
        "edit": {
          "title": "Edit approvers",
          "subtitle": "Add, reorder or remove approvers.",
          "addApproverCTA": "Add approver",
          "cancelCTA": "Cancel",
          "noApprover": {
            "title": "No approver selected",
            "subtitle": "There must be at least one approver."
          },
          "saveCTA": "$t(actions.save)"
        },
        "add": {
          "title": "Add approver",
          "subtitle": "Select one person to add as an approver.",
          "backCTA": "Go back",
          "addApproverCTA": "Add approver"
        },
        "resolvedError": {
          "title": "Ooops!",
          "subtitle": "You cannot change the approvers of an issue while it is resolved. Please reopen it to change approvers.",
          "acknowledgeCTA": "Okay"
        }
      },
      "stateActions": {
        "assignmentRequested": {
          "meAssigner": "You have",
          "otherAssigner": "has",
          "action": "assigned this issue to",
          "meResponsible": "you.",
          "workflow": {
            "reject": {
              "title": "Reject assignment",
              "subTitle": "Are you sure you want to reject this assignment?",
              "buttonCTA": "Reject",
              "confirmCTA": "Reject",
              "cancelCTA": "Cancel",
              "reasonLabel": "Reject reason"
            },
            "approve": {
              "title": "Accept assignment",
              "subTitle": "Are you sure you want to accept this assignment?",
              "buttonCTA": "Accept",
              "confirmCTA": "Accept",
              "cancelCTA": "Cancel",
              "plannedClosureDate": {
                "title": "Add a planned closure date",
                "skipCTA": "Skip",
                "submitCTA": "Submit"
              }
            }
          },
          "resolveAction": "has not yet accepted this issue."
        },
        "assigned": {
          "introAction": "The issue is with",
          "meResponsible": "you",
          "endAction": "to rectify.",
          "displayedState": "Not started",
          "workflow": {
            "approveCTA": "Approve",
            "complete": {
              "title": "Do you want to attach evidence to the completed issue?",
              "subTitle": "This helps the issue to be accepted more quickly by the approver.",
              "confirmCTA": "Attach evidence",
              "skipCTA": "Skip",
              "confirmTitle": "Attach evidence",
              "addMoreCTA": "Add more",
              "finishCTA": "Finish"
            },
            "completeCTA": "Complete",
            "inProgressCTA": "Mark as started"
          }
        },
        "draft": {
          "publishCTA": "Publish",
          "publishConfirmation": {
            "title": "Add impact before publishing?",
            "subtitle": "It seems like this issue has no impact yet. Defining the impact will determine if this issue has no effect, has potential delay, has live delay, or has a completed delay.",
            "publishWithoutImpactCTA": "Publish without impact",
            "addImpactCTA": "Add impact"
          },
          "publishSuccess": {
            "issue": "Issue published.",
            "space": "Use this space to collaborate and track its history.",
            "assignedToMe": "You can Resolve this issue by clicking the Resolve button at anytime.",
            "assignedToOthers": "{{assignee}} will now receive an email informing them of their assignment."
          }
        },
        "inProgress": {
          "action": "The issue has started.",
          "displayedState": "Started",
          "workflow": {
            "approveCTA": "Approve",
            "outstandingCTA": "Mark as not started",
            "completeCTA": "Complete"
          }
        },
        "assignmentRejected": {
          "meAssignee": "You have",
          "otherAssignee": "has",
          "action": "rejected the issue.",
          "workflow": {
            "reassignCTA": "Reassign",
            "assignCTA": "Assign"
          }
        },
        "completed": {
          "awaitingApproval": "This issue is awaiting your approval.",
          "workflow": {
            "rejectCTA": "Reject",
            "approveCTA": "Approve"
          }
        },
        "resolved": {
          "resolvedBy": "The issue is resolved.",
          "reopen": "Reopen"
        }
      },
      "stateWorkflows": {
        "rejectResolve": {
          "inProgressCTA": "Started",
          "outstandingCTA": "Not started",
          "subTitle": "What status do you want to revert to?",
          "title": "Reject completion",
          "form": {
            "title": "Add reason",
            "field": "Why is the issue not resolved?",
            "cancelCTA": "Cancel",
            "rejectCTA": "Reject"
          }
        },
        "assign": {
          "title": "Assign responsible person",
          "subTitle": "Select one responsible person and click assign.",
          "cancelCTA": "Cancel",
          "skipCTA": "Skip",
          "submitCTA": "Assign"
        },
        "approveResolve": {
          "dialog": {
            "title": "Approve completion",
            "subTitle": "Did this issue delay your work?",
            "no": "No",
            "yes": "Yes"
          },
          "form": {
            "title_workAffected": "Enter the work affected",
            "title_startFinish": "When did the delay start and finish?",
            "title_finish": "When did the delay finish?",
            "title": "",
            "workAffected": {
              "field": "Work affected",
              "error": "Invalid work affected"
            },
            "finishDelay": {
              "startDelayField": "Delay start:",
              "finishDelayField": "Delay finish:",
              "error": "Delay finish must be after delay start.",
              "warning": "The date should be in the past."
            },
            "next": "Next",
            "previous": "Previous",
            "submit": "$t(actions.save)"
          }
        },
        "reopen": {
          "title": "Reopen issue",
          "subTitle": "Are you sure you want to reopen this issue? The issue will be marked as \"Not started\" again.",
          "confirmCTA": "Reopen",
          "cancelCTA": "Cancel"
        }
      },
      "visibility": {
        "title": "Visibility",
        "details": "Details",
        "all": "All",
        "projectWideTitle": "Public",
        "projectWideSubtitle": "Anyone on the project can see this issue",
        "privateTitle": "Private",
        "privateSubtitle": "Only your organisation can see this issue",
        "specificTeams": {
          "title": "Specific organisations",
          "subtitle": "Only the following organisations can see this issue:",
          "add": "Add organisation",
          "overlay": {
            "title": "Add organisation",
            "subtitle": "Select one organisation to add to specific organisations.",
            "members_zero": "{{COUNT}} People",
            "members_one": "{{COUNT}} Member",
            "members_other": "{{COUNT}} People"
          }
        },
        "edit": {
          "title": "Edit visibility",
          "cancelCTA": "Cancel",
          "saveCTA": "$t(actions.save)"
        },
        "view": {
          "title": "View visibility",
          "privateComms": {
            "subtitle": "Organisation comms is only visible to your organisation",
            "yourTeam": "Your organisation",
            "teamMembers": "People"
          },
          "sharedComms": {
            "subtitle": "Shared comms is visible to anyone who can view this issue",
            "issueVisibility": {
              "title": "Issue visibility",
              "members_zero": "{{COUNT}} people",
              "members_one": "{{COUNT}} member",
              "members_other": "{{COUNT}} people"
            }
          },
          "cancelCTA": "Cancel",
          "saveCTA": "$t(actions.save)"
        }
      },
      "location": {
        "edit": "Edit location",
        "observedAt": "Observed at",
        "noDate": "Not yet entered",
        "notEntered": "No location entered",
        "title": "Location"
      },
      "status": {
        "title": "Status",
        "update": "Update status",
        "completed": "Completed",
        "selectStatusCTA": "Select status",
        "saveCTA": "Save",
        "nextCTA": "Next",
        "cancelCTA": "Cancel"
      },
      "statusStatement": {
        "title": "Latest status statement",
        "placeholder": "Make a statement to describe this issue's status.",
        "shortTitle": "Status:",
        "addCTA": "Add",
        "viewCTA": "View",
        "viewOrUpdateCTA": "View or update",
        "date": {
          "dateLabel": "Applies since",
          "weeks": "weeks"
        },
        "drawer": {
          "title": "Status statement",
          "subtitle": "An update that adds clarity to the issue's progress."
        },
        "form": {
          "statement": {
            "label": "Give a new status statement",
            "placeholder": "E.g. \"Awaiting response on the technical query\"",
            "successToast": "Status statement added"
          },
          "date": {
            "label": "Applies since"
          },
          "submitCTA": "Submit statement"
        },
        "history": {
          "title": "Previous status statements",
          "placeholder": {
            "title": "No status statements yet",
            "subtitle": "The history of status statements will be shown here."
          }
        }
      },
      "dates": {
        "closedAt": "Closed at",
        "observedAt": "Observed at",
        "noDate": "Not yet entered"
      },
      "datesForm": {
        "date": "Date",
        "time": "Time",
        "closedAt": "Edit closed at",
        "observedAt": "Edit observed at",
        "shouldBeBeforeClosedAt": "The date must be before the closed at.",
        "shouldBeAfterObservedAt": "The date must be after the observed at.",
        "observedAtNote": "Manually enter the date and time the issue was first observed",
        "closedAtNote": "Manually enter the date and time the issue was closed"
      },
      "category": {
        "edit": "Edit type",
        "empty": "No category entered",
        "title": "Type"
      },
      "discipline": {
        "edit": "Edit discipline",
        "empty": "No discipline entered",
        "title": "Discipline"
      },
      "createdAt": {
        "title": "Created at"
      },
      "updatedAt": {
        "title": "Updated at"
      },
      "topActions": {
        "watchToast": "You are now watching this issue.",
        "unwatchToast": "You are now unwatching this issue.",
        "moreMenu": {
          "critical_true": "Unmark as critical",
          "critical": "Mark as critical",
          "archive": "$t(actions.archive)",
          "restore": "$t(actions.restore)",
          "exportPdf": "Export as PDF",
          "watch": "Watch issue",
          "watch_true": "Unwatch issue",
          "shareIssue": "Share issue"
        },
        "toolbar": {
          "close": "Close",
          "moreActions": "More actions",
          "fullscreen": "Fullscreen",
          "fullscreen_true": "Exit fullscreen"
        },
        "share": {
          "title": "Share issue",
          "content": "Make sure whoever you shared this issue with are able to access it. You may need speak to your project's admin to grant them access.",
          "shareCTA": "Share",
          "shareLinkTitle": "Shape item: {{title}}",
          "shareLinkContent": "Click the link to see this Shape item. Title:  {{title}}"
        },
        "savedDraft": "Saved draft"
      },
      "activity": {
        "tabs": {
          "details": "Details",
          "teamComms": "Private comms",
          "sharedComms": "Updates & comments",
          "gallery": "Gallery"
        },
        "input": {
          "placeholder": "Add a comment",
          "hint": {
            "open": "Anyone seeing this issue can see your comment.",
            "team": "Only people in your organisation can see your message."
          }
        },
        "public": {
          "empty": {
            "title": "No conversations yet",
            "message": "This space is for you to exchange thoughts and ideas. All messages are public."
          }
        },
        "team": {
          "banner": "Only visible to your organisation.",
          "empty": {
            "title": "No conversations yet",
            "message": "This space is for you to exchange thoughts and ideas. All messages are accessible only by members of the organisation."
          }
        },
        "delete": {
          "confirmation": {
            "title": "Are you sure?",
            "subTitle": "You can't undo this action, do you want to delete this message?",
            "confirmCTA": "Delete",
            "dismissCTA": "Cancel"
          },
          "error": {
            "title": "Ooops!",
            "subTitle": "Sorry, we can't update your comment now, please try again.",
            "acknowledgeCTA": "Okay"
          }
        }
      },
      "customFields": {
        "title": "$t(admin.customFields.title)",
        "projectWide": "Project wide",
        "team": "Organisation",
        "noData": "Not yet entered",
        "editAll": "Edit all",
        "editForm": {
          "title_zero": "Edit custom fields",
          "title_one": "Edit custom field",
          "title_other": "Edit custom fields",
          "fieldValue": {
            "characters": "characters",
            "errors": {
              "length": "Field value too long"
            }
          }
        }
      },
      "notEntered": "Not yet entered"
    },
    "gallery": {
      "emptyPlaceholder": {
        "subtitle": "Issue documents will appear here as soon as they are uploaded."
      }
    },
    "list": {
      "title": "Issues",
      "export": {
        "exportCTA": "Export",
        "title": "Export issues",
        "modal": {
          "infoBanner": "Exporting issues from your current view.",
          "pdfExportLimit": "Only the latest 100 created issues will be included in this export.",
          "label": "What format do you need?",
          "confirmCTA": "Export",
          "title": "Export issues",
          "contentLabel": "Choose a format:",
          "inputTitle": "Set a report title (optional):",
          "inputPlaceholder": "Issues report",
          "cancelCTA": "Cancel",
          "exportCTA": "Export"
        },
        "confirmModal": {
          "title": "Issues exported",
          "subTitle": "You will get an email when the export is ready.",
          "dismissCTA": "Dismiss"
        }
      },
      "options": {
        "otherActions": "Other actions",
        "collapseAll": "Collapse all",
        "sortAscending": "Sort ascending",
        "sortDescending": "Sort descending",
        "saveViewCTA": "Save",
        "saveViewSuccess": "Your view options have been saved."
      },
      "filters": {
        "label": "Filters",
        "options": "Options",
        "viewOptions": "View options",
        "groupBy": "Group by",
        "sortBy": "Sort by",
        "clearCTA": "Clear all",
        "cancelCTA": "Cancel",
        "applyCTA": "Apply",
        "group": {
          "details": "Details",
          "people": "People",
          "dates": "Dates",
          "visibility": "Visibility"
        },
        "publishedDate": {
          "label": "Date created",
          "filterBy": "Filter by date created",
          "applyLabel": "Apply"
        },
        "dueDate": {
          "label": "Due date",
          "filterBy": "Filter by due date",
          "applyLabel": "Apply"
        },
        "updatedDate": {
          "label": "Last updated at",
          "filterBy": "Filter by last updated at",
          "applyLabel": "Apply"
        },
        "plannedClosureDate": {
          "label": "Planned closure date",
          "filterBy": "Filter by planned closure date",
          "applyLabel": "Apply"
        },
        "closedDate": {
          "label": "Closed at",
          "filterBy": "Filter by closed at",
          "applyLabel": "Apply"
        },
        "originator": {
          "label": "Originator",
          "currentUserText": "(Me)",
          "filterBy": "Filter by originator",
          "searchPlaceholder": "Search"
        },
        "responsible": {
          "label": "Responsible person",
          "currentUserText": "(Me)",
          "filterBy": "Filter by responsible person",
          "searchPlaceholder": "Search"
        },
        "approver": {
          "label": "Approver",
          "currentUserText": "(Me)",
          "filterBy": "Filter by approver",
          "searchPlaceholder": "Search"
        },
        "impact": {
          "label": "Impact",
          "filterBy": "Filter by impact",
          "noEffect": {
            "label": "No effect",
            "description": "Issue has no effect on other works."
          },
          "potentialDelay": {
            "label": "Potential delay",
            "description": "Issue can cause delay to other works in the future."
          },
          "liveDelay": {
            "label": "Live delay",
            "description": "Issue is currently preventing or slowing down progress on other works."
          },
          "completedDelay": {
            "label": "Completed delay",
            "description": "Issue has already delayed other works, but has been resolved."
          },
          "notEntered": {
            "label": "Not entered",
            "description": "Issue does not have an impact entered."
          }
        },
        "filterState": {
          "label": "Status",
          "filterBy": "Filter by status",
          "unassigned": "Unassigned",
          "pendingResponsible": "Pending responsible",
          "notStarted": "Not started",
          "started": "Started",
          "pendingApproval": "Pending approval",
          "resolved": "Resolved"
        },
        "category": {
          "label": "Issue type",
          "title": "Filter by issue type",
          "searchPlaceholder": "Search for issue type",
          "noCategory": "No issue type"
        },
        "discipline": {
          "label": "Discipline"
        },
        "location": {
          "label": "Location",
          "title": "Locations",
          "searchPlaceholder": "Search for a location",
          "noLocation": "No location"
        },
        "responsibleTeam": {
          "label": "Responsible organisation",
          "filterBy": "Filter by responsible organisation",
          "searchPlaceholder": "Search"
        },
        "visibility": {
          "all": "All",
          "label": "Visibility",
          "filterBy": "Filter by visibility",
          "private": {
            "label": "Private",
            "description": "Show issues visible only to your organisation"
          },
          "public": {
            "label": "Public",
            "description": "Show issues visible to anyone in the project"
          },
          "specificOrganisations": {
            "label": "Specific organisations",
            "description": "Show issues visible only to the selected organisations",
            "members_zero": "No members",
            "members_one": "{{COUNT}} member",
            "members_other": "{{COUNT}} members"
          },
          "specificOrganisationModal": {
            "title": "Specific organisations",
            "subTitle": "You are filtering issues visible to the following organisations.",
            "noOrganisationSelected": "No organisations selected yet",
            "addOrganisationCTA": "Add organisation",
            "applyCTA": "Apply"
          },
          "addOrganisationModal": {
            "title": "Add organisation",
            "subTitle": "Select one organisation to add to specific organisations.",
            "description": "You are filtering issues visible to the following organisations:",
            "noOrganisationAvailable": "No available organisations",
            "goBackCTA": "Go back",
            "addCTA": "Add"
          }
        }
      },
      "view": {
        "actions": {
          "tooltip": "Manage"
        },
        "new": {
          "title": "New view",
          "description": "Any filtering, sorting, and grouping you do within the view will automatically be saved.",
          "form": {
            "viewName": "View name",
            "viewNamePlaceholder": "Give this new view a name",
            "requiredMessage": "Required field",
            "clearCTA": "Clear all"
          },
          "createCTA": "Create view",
          "cancelCTA": "Cancel"
        },
        "edit": {
          "title": "Rename",
          "form": {
            "title": "Rename view",
            "viewName": "View name",
            "viewNamePlaceholder": "Give this view a name",
            "requiredMessage": "Required field"
          },
          "createCTA": "Save",
          "cancelCTA": "Cancel",
          "successMessage": "“{{oldName}}” has been renamed to “{{newName}}”."
        },
        "delete": {
          "title": "Delete",
          "confirmation": {
            "title": "Delete view",
            "subtitle": "Are you sure you want to delete this view? This action can’t be undone.",
            "dismiss": "$t(actions.cancel)",
            "confirm": "$t(actions.delete)",
            "successMessage": "Created view has been successfully deleted."
          }
        }
      },
      "grouping": {
        "maximumSelectedWarning": "Maximum number of nested groups reached."
      },
      "tabs": {
        "allIssues": "All issues",
        "archived": "Archived",
        "drafts": "Unpublished",
        "myIssues": "My issues"
      },
      "emptyPlaceholder": {
        "default": {
          "title": "You don't have any issues",
          "subtitle": "Create an issue to track its updates, add comments, and share with other stakeholders."
        },
        "all": {
          "title": "This project has no issues yet",
          "subtitle": "Issues will appear here once someone creates an issue."
        },
        "drafts": {
          "title": "You don't have any unpublished issues",
          "subtitle": ""
        },
        "archived": {
          "title": "You don't have any archived issues",
          "subtitle": ""
        },
        "hasFilters": {
          "title": "No filter results",
          "subtitle": "Please check your view filters."
        }
      },
      "qualityIndicators": {
        "notUseful": {
          "title": "Not useful",
          "issue": {
            "scoreRange": "Score range: 0-19%",
            "description": "Issues are severely lacking in essential information or have been inactive for too long."
          },
          "downtime": {
            "scoreRange": "Score range: 0-19%",
            "description": "Downtime records are severely lacking in essential information."
          },
          "progress_log": {
            "scoreRange": "Score range: 0-19%",
            "description": "Progress logs are severely lacking in essential information."
          }
        },
        "theBasics": {
          "title": "The basics",
          "issue": {
            "scoreRange": "Score range: 20-39%",
            "description": "Issues have some foundational details, but significant gaps make it difficult to take action."
          },
          "downtime": {
            "scoreRange": "Score range: 20-39%",
            "description": "Downtime records have some foundational details, but significant gaps make it difficult to take action."
          },
          "progress_log": {
            "scoreRange": "Score range: 20-39%",
            "description": "Progress logs have some foundational details, but significant gaps make it difficult to take action."
          }
        }
      }
    },
    "options": {
      "actions": {
        "collapseAll": "Collapse all",
        "sortAscending": "Sort ascending",
        "sortDescending": "Sort descending",
        "reset": "Reset",
        "groupBy": "Group",
        "sortBy": "Sort"
      },
      "groupBy": {
        "description": "Group by",
        "responsiblePerson": "Responsible person",
        "responsibleTeam": "Responsible organisation",
        "discipline": "Discipline",
        "impact": "Impact",
        "location": "Location",
        "originator": "Originator",
        "originatorTeam": "Originator's organisation",
        "state": "Status",
        "customField": "Custom fields",
        "none": "None",
        "custom": {
          "title": "Custom",
          "description": "Create your own groupings by combining the options above.",
          "modal": {
            "title": "Create custom groups",
            "description": "Create your own groups by combining subgroup options.",
            "subtitle": "Applied subgroups",
            "addSubgroup": "Add subgroup",
            "createCTA": "Create",
            "cancelCTA": "Cancel",
            "removeGroupCTA": "Remove",
            "noGroups": "No groups applied"
          }
        }
      },
      "sortBy": {
        "description": "Sort by",
        "created": "Created on",
        "delay_finish": "End of delay",
        "delay_start": "Start of delay",
        "due_date": "Due on",
        "planned_date": "Planned closure",
        "reference": "Reference number",
        "title": "Issue title",
        "updated": "Last updated on",
        "status": "Status",
        "impact": "Impact"
      }
    },
    "events": {
      "state": {
        "sending": "Sending..."
      },
      "accept_assignment": "{{ownerName}} accepted the assignment",
      "add_approver_zero": "{{ownerName}} added {{approvers, list}} as approvers",
      "add_approver_one": "{{ownerName}} added {{approvers, list}} as an approver",
      "add_approver_other": "{{ownerName}} added {{approvers, list}} as approvers",
      "add_team_zero": "{{ownerName}} added the organisations {{teams, list}}",
      "add_team_one": "{{ownerName}} added the organisation {{teams, list}}",
      "add_team_other": "{{ownerName}} added the organisations {{teams, list}}",
      "add_watcher_zero": "{{ownerName}} added {{watchers, list}} as watchers",
      "add_watcher_one": "{{ownerName}} added {{watchers, list}} as a watcher",
      "add_watcher_other": "{{ownerName}} added {{watchers, list}} as watchers",
      "add_watcher_self": "{{ownerName}} joined this issue as a watcher",
      "add_status_statement": "{{ownerName}} added a new status statement: {{statusStatement}}",
      "delete_status_statement": "{{ownerName}} deleted the status statement: {{statusStatement}}",
      "approve": "{{ownerName}} approved the issue",
      "archive": "{{ownerName}} archived the issue",
      "assign": "{{ownerName}} assigned the issue to {{recipientName}}",
      "change_status": {
        "type": "Status",
        "message": "{{ownerName}} changed the {{status}} from {{from}} to {{to}}"
      },
      "comment_on": {
        "delete": "Delete comment"
      },
      "create": "{{ownerName}} created the issue",
      "link_activity": {
        "field": "Impacted activities",
        "message": "{{ownerName}} updated the {{field}}: {{activities, list}}"
      },
      "reject_assignment_yes": "{{ownerName}} rejected the assignment with the following reason: {{reason}}",
      "reject_assignment": "{{ownerName}} rejected the assignment",
      "reject_resolution": "{{ownerName}} rejected the resolution request",
      "remove_approver_zero": "{{ownerName}} removed {{approvers, list}} as approvers",
      "remove_approver_one": "{{ownerName}} removed {{approvers, list}} as an approver",
      "remove_approver_other": "{{ownerName}} removed {{approvers, list}} as approvers",
      "remove_team_zero": "{{ownerName}} removed the organisations {{teams, list}}",
      "remove_team_one": "{{ownerName}} removed the organisation {{teams, list}}",
      "remove_team_other": "{{ownerName}} removed the organisations {{teams, list}}",
      "remove_watcher_zero": "{{ownerName}} removed {{watchers, list}} as watchers",
      "remove_watcher_one": "{{ownerName}} removed {{watchers, list}} as a watcher",
      "remove_watcher_other": "{{ownerName}} removed {{watchers, list}} as watchers",
      "remove_watcher_self": "{{ownerName}} stopped watching this issue",
      "reopen": "{{ownerName}} reopened the issue",
      "restore": "{{ownerName}} restored the issue",
      "unlink_activity": {
        "field": "Impacted activities",
        "message": "{{ownerName}} removed {{field}}: {{activities, list}}"
      },
      "update": {
        "field": "{{updateField}} to {{value}}",
        "message": "{{ownerName}} updated {{parametersArray, list}}",
        "change_field": "{{updateField}} from {{from}} to {{to}}",
        "clear_field": "{{updateField}} cleared from {{from}}",
        "update_field": "{{updateField}} to {{value}}"
      },
      "update_impact": {
        "field": "{{updateField}} to {{value}}",
        "message": "{{ownerName}} changed the impact: {{parametersArray, list}}",
        "field_impact": "Impact",
        "field_due_date": "Due date",
        "field_delay_start": "Delay start date",
        "field_delay_finish": "Delay finish date",
        "field_work_affected": "Work affected",
        "change_field": "{{updateField}} from {{from}} to {{to}}",
        "clear_field": "{{updateField}} cleared from {{from}}",
        "update_field": "{{updateField}} to {{value}}"
      },
      "update_observer": {
        "type": "Observer",
        "message": "{{ownerName}} changed the {{observer}} to {{updatedObserverName}}"
      },
      "upload_document": "{{ownerName}} uploaded {{documentName}}",
      "new": "New"
    }
  },
  "loadMoreButton": {
    "loading": "Loading",
    "loadMore": "Load more {{buttonType}}"
  },
  "locale": {
    "options": {
      "en": {
        "label": "English",
        "subLabel": "English"
      },
      "es-419": {
        "label": "Español (Latinoamérica)",
        "subLabel": "Spanish (Latin America)"
      },
      "de-DE": {
        "label": "Deutsch",
        "subLabel": "German"
      },
      "tr": {
        "label": "Türkçe",
        "subLabel": "Turkish"
      },
      "pt-PT": {
        "label": "Português",
        "subLabel": "Portuguese"
      },
      "fr-FR": {
        "label": "Français",
        "subLabel": "French"
      },
      "el-GR": {
        "label": "Ελληνικά",
        "subLabel": "Greek"
      },
      "ro": {
        "label": "Română",
        "subLabel": "Romanian"
      }
    }
  },
  "myProjects": {
    "title": "My Projects",
    "currentProjects": "Current projects",
    "archivedProjects": "Archived",
    "emptyState": {
      "projectsTitle": "You don't have any projects yet.",
      "archivedProjectsTitle": "You don't have any archived projects.",
      "subTitle": "You can get in touch with your project manager and request access. Looking to get started by yourself? Click above to start crushing issues."
    },
    "newProject": "New project"
  },
  "myAccount": {
    "title": "My account",
    "notifications": {
      "title": "Notifications",
      "emailPreferences": {
        "title": "Email preferences",
        "backToAccountSettings": "Back to account settings",
        "description": "Set how often each update arrives, or enable <b>Digest</b> instead to include it in a single email sent once a week.",
        "estimatedEmails": {
          "label": "Estimated emails",
          "liveUpdateNote": "Per week counter updates live as you make changes.",
          "perWeekCount": "<b>{{COUNT}}</b> per week",
          "summary_one": "<b>{{COUNT}}</b> estimated email per week",
          "summary_other": "<b>{{COUNT}}</b> estimated emails per week"
        },
        "frequencyColumn": "Email frequency",
        "cadence": {
          "realtime": "Real-time",
          "realTimeOnly": "Real-time only",
          "daily": "Daily",
          "weekly": "Weekly",
          "weekly_digest": "In digest",
          "disabled": "Off"
        },
        "cadenceDescription": {
          "realtime": "An email as soon as it happens.",
          "daily": "One email each morning with the day's updates.",
          "weekly": "One email a week with everything from the past seven days.",
          "weekly_digest": "Bundled into one digest email each week instead of arriving on its own.",
          "weeklyDigestLessDetailed": "Bundled into one digest email each week instead of arriving on its own. Less detailed than the stand-alone email.",
          "disabled": "No emails for this."
        },
        "locked": {
          "frequencyNote": "These alerts are time-sensitive, so they're always sent straight away and can't wait for the digest."
        },
        "sections": {
          "issueActivities": "Issue activities",
          "channels": "Channels",
          "shiftReports": "Shift reports",
          "summaries": "Summaries"
        },
        "streams": {
          "issuesAssignments": {
            "title": "Assignments",
            "description": "Issues assigned to you or your team"
          },
          "issuesStatusChange": {
            "title": "Status changes",
            "description": "Issues you follow move to a new status"
          },
          "issuesOverdue": {
            "title": "Overdue",
            "description": "Issues you follow pass their due date"
          },
          "issuesStatusStatement": {
            "title": "Status statement updates",
            "description": "Latest description of the issue's current status"
          },
          "channelsMention": {
            "title": "Channel mentions",
            "description": "Direct @mentions in chat channels"
          },
          "channelsActivity": {
            "title": "Channel activity",
            "description": "Summary of channel posts you might have missed"
          },
          "shiftReportsCollaboratorInvite": {
            "title": "Collaborator invites",
            "description": "Someone adds you as a collaborator on a shift report"
          },
          "shiftReportsReviewRequests": {
            "title": "Review requests",
            "description": "Someone asks you to review a shift report"
          },
          "issuesSummary": {
            "title": "Issues summary",
            "description": "Summary of issue activity on your projects"
          },
          "morningCoffee": {
            "title": "Morning coffee",
            "description": "A daily round-up of your assignments, approvals, status updates, chat mentions, shift report comments and access requests, per project"
          },
          "activitiesReadiness": {
            "title": "Activity readiness",
            "description": "How ready next week's activities are on your projects"
          },
          "projectsAccessRequests": {
            "title": "Access request reminder",
            "description": "Pending requests to join your projects"
          },
          "issuesLeaderboard": {
            "title": "Leaderboard (Issues)",
            "description": "Your performance ranking across the team"
          }
        },
        "action": {
          "frequencyUpdated": "{{STREAM}} is set to ‘{{FREQUENCY}}’",
          "digestAdded": "{{STREAM}} is added to the weekly digest",
          "updateFailed": "That change could not be saved. Please try again."
        },
        "transactionalNote": "Transaction emails like invites, access requests, and password resets are always sent and can't be turned off."
      }
    },
    "avatar": {
      "memberSince": "Member since {{SIGNUP_DATE}}",
      "change": "Change",
      "uploadErrorMessage": "The file selected has an unsupported extension or must be greater than {{min}} bytes and smaller than {{max}} MB",
      "modalTitle": "Profile picture",
      "saveCTA": "Update",
      "cancelCTA": "Cancel"
    },
    "details": {
      "title": "Account details",
      "firstLastName": "First and last name",
      "email": "Email",
      "unconfirmedEmail": "Currently waiting confirmation for <b>{{EMAIL}}</b>",
      "password": "Password",
      "updateEmail": {
        "title": "Update email address",
        "subTitle": "Update your email and save. We’ll send you an email asking you to confirm the change.",
        "fields": {
          "email": "Email"
        },
        "alert": {
          "title": "Email update pending verification",
          "description": "Check <b>{{EMAIL}}</b> to verify it’s you and complete the update.",
          "resend": {
            "CTA": "Resend email",
            "action": {
              "success": "Unconfirmed email erased!",
              "fail": "There was a problem erasing the unconfirmed email, please try again."
            }
          },
          "cancel": {
            "CTA": "Cancel email change",
            "action": {
              "success": "Unconfirmed email erased!",
              "fail": "There was a problem erasing the unconfirmed email, please try again."
            }
          }
        },
        "action": {
          "success": "Verification email sent!",
          "fail": "Your email could not be updated. Please try again."
        }
      },
      "updateName": {
        "title": "Update name",
        "subTitle": "Update your first and last name and save.",
        "fields": {
          "firstName": "First name",
          "lastName": "Last name"
        },
        "action": {
          "success": "Your name was updated!",
          "fail": "Your name could not be updated. Please try again."
        }
      },
      "updatePassword": {
        "title": "Update password",
        "subTitle": "Enter your current and new password.",
        "fields": {
          "currentPassword": "Current password",
          "newPassword": "New password",
          "repeatNewPassword": "Repeat new password"
        },
        "action": {
          "success": "Your password was updated!",
          "fail": "Your password could not be updated. Please try again."
        }
      }
    },
    "signIns": {
      "title": "Sign-ins and connected apps",
      "summary": "Log out of other sessions, manage connected apps",
      "sessions": {
        "title": "Where you're logged in",
        "description": "Log out everywhere else if you've lost a device or don't recognise a session.",
        "note": "Logging out doesn't disconnect apps. Apps below keep access to your Shape data until you disconnect them.",
        "thisDevice": "This device",
        "loggedIn": "Logged in {{date}}",
        "otherSessions_one": "{{count}} other session",
        "otherSessions_other": "{{count}} other sessions",
        "otherSessionsDescription": "Other browsers and devices where you're logged in to Shape.",
        "noOtherSessions": "You're not signed in anywhere else.",
        "loadError": "Couldn't load where you're logged in. Please try again.",
        "logOutOthers": {
          "button": "Log out of all other sessions",
          "modal": {
            "title": "Log out of all other sessions",
            "description": "Are you sure you want to log out of Shape everywhere except this device? Anyone using those sessions will need to log in again.",
            "confirm_one": "Log out {{count}} session",
            "confirm_other": "Log out {{count}} sessions"
          },
          "success_one": "Logged out of {{count}} other session. Connected apps weren't affected.",
          "success_other": "Logged out of {{count}} other sessions. Connected apps weren't affected.",
          "error": "Couldn't log out of other sessions. Nothing changed and they're still logged in."
        }
      },
      "connectedApps": {
        "title": "Connected apps",
        "description": "Apps you've allowed to access your Shape data. They have the same access as you and stay connected when you log out of Shape.",
        "empty": {
          "title": "No apps connected",
          "description": "When you connect an app like Claude or ChatGPT to Shape, it'll appear here. You can disconnect it at any time."
        },
        "loadError": "Couldn't load your connected apps. Please try again.",
        "disconnect": {
          "button": "Disconnect",
          "buttonLabel": "Disconnect {{name}}",
          "modal": {
            "title": "Disconnect “{{name}}”",
            "description": "Are you sure you want to disconnect {{name}}? It will lose access to your Shape data straight away. It doesn't remove anything {{name}} has already received.",
            "confirm": "Disconnect"
          },
          "success": "{{name}} disconnected",
          "error": "Couldn't disconnect {{name}}. Nothing changed and it still has access."
        },
        "disconnectAll": {
          "button": "Disconnect all apps",
          "modal": {
            "title": "Disconnect all apps",
            "description": "Are you sure you want to disconnect {{apps, list}}? They'll lose access to your Shape data straight away. You'll stay logged in to Shape.",
            "confirm_one": "Disconnect {{count}} app",
            "confirm_other": "Disconnect {{count}} apps"
          },
          "success_one": "Disconnected {{count}} app. You're still logged in to Shape.",
          "success_other": "Disconnected {{count}} apps. You're still logged in to Shape.",
          "error": "Couldn't disconnect your apps. Nothing changed and they still have access."
        }
      }
    },
    "privacy": {
      "title": "Privacy",
      "cookiePreferences": "Cookie preferences",
      "cookieDeclaration": "Cookie declaration"
    }
  },
  "navigation": {
    "back": "Back",
    "backTo": "Back to {{route}}",
    "issues": "Issues",
    "activities": "Activities",
    "notifications": "Notifications",
    "search": "Search issues",
    "filter": "Filters",
    "shiftReports": "Shift reports",
    "gallery": "Gallery",
    "channels": "Channels web",
    "weeklyPlanner": "Weekly planner",
    "changeTracker": "Change tracker",
    "dataBook": "Data book",
    "logs": "Logs",
    "progress": "Progress",
    "people": "People"
  },
  "projectForm": {
    "newTitle": "New project",
    "editTitle": "Edit project",
    "fields": {
      "projectName": "Project name",
      "shortName": {
        "label": "Short name",
        "description": "This is a quick way to identify your project. It will show as a reference on all issues in the project e.g issues in a project with the short name RES may have the reference RES-FIN-0001."
      },
      "projectAvatar": {
        "label": "Project avatar",
        "ariaLabel": "Upload a project avatar",
        "uploadDescription": "You can upload a file PNG, JPG or JPEG up to {{max}}MB. If you leave it blank, an avatar with chosen short name will be used.",
        "uploadErrorMessage": "The file selected has an unsupported extension or must be greater than {{min}} bytes and smaller than {{max}} MB"
      },
      "timezone": "Timezone",
      "language": "Shared documents language",
      "languageDescription": "Sets the language for shared deliverables (exports) like shift reports, issue exports, and weekly work plans.",
      "uploadCTA": "Upload"
    },
    "actions": {
      "cancel": "$t(actions.cancel)",
      "save": "$t(actions.save)",
      "saveDemo": "Save demo project"
    },
    "showcaseProjectLoading": "Creating demo project. It usually takes a couple of minutes. Please wait...",
    "projectCreatedFeedback": "Project created.",
    "projectEditedFeedback": "Project was successfully edited."
  },
  "projectGallery": {
    "officeOnly": "Office only",
    "metadata": {
      "caption": {
        "add": "Add caption"
      },
      "location": {
        "add": "Add location",
        "cancel": "Cancel",
        "edit": "Edit location",
        "save": "Save"
      }
    },
    "upload": {
      "new": "Upload",
      "alert": "Details apply to all items"
    },
    "uploadPreview": {
      "picker": {
        "trigger": "Add documents"
      },
      "thumbnail": {
        "document": "Document",
        "removeDocument": "Remove document"
      },
      "save": "Save"
    },
    "emptyGalleryPlaceholder": {
      "title": "Gallery is empty",
      "subtitle": "Project documents will appear here as soon as they are uploaded."
    },
    "noResultsPlaceholder": {
      "title": "No matching results",
      "subtitle": "Try to adjust your filters or clear all to show results.",
      "clearCTA": "Clear all filters"
    },
    "filters": {
      "label": "Filters",
      "document": {
        "searchPlaceholder": "Search by caption"
      },
      "author": {
        "label": "Author",
        "placeholder": "Search for a person"
      },
      "format": {
        "label": "Format",
        "all": "All",
        "images": "Images",
        "files": "Files"
      },
      "officeOnly": {
        "label": "Office only"
      },
      "locations": {
        "label": "Location",
        "title": "Locations",
        "placeholder": "Search for a location",
        "options": {
          "noLocation": "No location"
        }
      },
      "clearAll": "Clear all"
    },
    "sort": {
      "label": "Sort",
      "newest": "Newest",
      "oldest": "Oldest"
    },
    "add": "Add",
    "documentViewer": {
      "infoPanel": {
        "visibility": "Visibility",
        "officeOnly": {
          "hint": "Only office roles in your organisation can see this file.",
          "help": "About office only visibility",
          "tooltip": {
            "roles": "Only office roles can see this file: Owner, Admin, and Commercial contributor. No one else, including in the gallery.",
            "inheritance": "Files inherit visibility from where they were added."
          }
        },
        "tabTitle": "Details",
        "title": "Upload information",
        "author": "Author",
        "dateUploaded": "Date uploaded",
        "source": "Source",
        "uploadLocation": "Location",
        "addLocation": "Add location",
        "caption": "Caption",
        "addCaption": "Add caption",
        "sourceAndReferences": {
          "title": "Source and references",
          "subscriptionPlan": {
            "title": "This is a pro feature",
            "body": "Unlock this and other features with a pro plan.",
            "link": "Contact us",
            "learnMore": "to learn more"
          },
          "noSource": "Gallery",
          "noReferences": "No references yet",
          "subtitle": {
            "source": "Source",
            "references": "References"
          }
        }
      },
      "propertiesTab": {
        "title": "Properties",
        "type": "Type",
        "size": "Size",
        "dimensions": "Dimensions",
        "pixelCount": "Pixel count",
        "iso": "ISO",
        "dateTaken": "Date taken",
        "timeTaken": "Time taken",
        "deviceModel": "Device model",
        "geolocation": "Geolocation",
        "noData": "No data"
      }
    },
    "page": {
      "title": "Gallery"
    },
    "editDocumentModal": {
      "title": "Edit document details",
      "saveCTA": "Save",
      "cancelCTA": "Cancel",
      "fields": {
        "caption": "Caption",
        "location": "Location"
      }
    },
    "document": {
      "error": "Error on getting document"
    }
  },
  "channelsOnly": {
    "title": "Access via Shape Channels",
    "body": "Your account is set up for Channels-only access. To create issues, upload photos, or message your team, please use the Shape Channels mobile app.",
    "appStoreAlt": "Download on the App Store",
    "playStoreAlt": "Get it on Google Play"
  },
  "notAuthorised": {
    "title": "Not authorised",
    "subtitle": {
      "userFromProject": "You need to request access from admins to view this content.",
      "userOutsideProject": "You are not authorised to view this page because you're not involved in this project. In order to view it, you need to request access from an admin."
    },
    "requestAccessCTA": "Request access",
    "goToMyProjects": "Go to My Projects",
    "goToProject": "Go to {{projectName}}",
    "requestAccessModal": {
      "title": "Request access",
      "fields": {
        "team": {
          "label": "Organisation",
          "placeholder": "Your organisation",
          "description": "Which organisation do you work for? This will help route your request to the right person.",
          "errorMessage": "Required field"
        },
        "email": {
          "label": "Send to",
          "placeholder": "admin@email.com",
          "description": "If you know an admin, type in their email to get access quicker.",
          "errorMessage": "Must be a valid email"
        },
        "message": {
          "label": "Message",
          "description": "Add a message to let the admin know why you want access."
        }
      },
      "cancelCTA": "Cancel",
      "requestCTA": "Send request",
      "successToast": "Request sent."
    }
  },
  "notFound": {
    "title": "Page not found",
    "subtitle": "The page you requested could not be found.",
    "goToMyProjects": "Go to My Projects",
    "goToProject": "Go to {{projectName}}"
  },
  "notifications": {
    "page": {
      "title": "Notifications",
      "markReadCTA": "Mark all as read",
      "goBack": "Go back"
    },
    "permission": {
      "modal": {
        "completeTitle": "Thanks!",
        "completeDescription": "We'll keep you up-to-date!",
        "title": "Stay up to date",
        "description": "Getting notified as soon as something needs your attention is the best way to get issues closed faster.",
        "actionText": "Update me",
        "testPrefix": "permission"
      }
    },
    "pushPrompt": {
      "card": {
        "body": "<span className=\"font-semibold\">Get a desktop notification for assignments, approvals and replies</span> - even when Shape isn't open.",
        "turnOn": "Turn on",
        "notNow": "Not now",
        "confirmation": "<span className=\"font-semibold\">You're all set!</span> Shape will let you know the moment something needs you."
      },
      "toast": {
        "assigned": "Get a desktop alert the moment you're assigned an issue.",
        "approvalRequest": "Get a desktop alert the moment an issue needs your approval.",
        "approvalDecision": "Get a desktop alert the moment your work is approved or rejected.",
        "cta": "$t(notifications.pushPrompt.card.turnOn)",
        "confirmation": "$t(notifications.pushPrompt.card.confirmation)"
      },
      "testNotification": "You're all set — we'll notify you here."
    },
    "popover": {
      "toggle": "Notifications toggle",
      "loadMore": "See all notifications",
      "manageEmailAlerts": "Manage email alerts",
      "otherProjectsUnread$total_zero": "notifications",
      "otherProjectsUnread$total_one": "notification",
      "otherProjectsUnread$total_other": "notifications",
      "otherProjectsUnread$count_zero": "{{count}} other projects",
      "otherProjectsUnread$count_one": "{{count}} other project",
      "otherProjectsUnread$count_other": "{{count}} other projects",
      "otherProjectsUnread": "{{total}} unread $t(notifications.popover.otherProjectsUnread$total, {\"count\": {{total}} }) in $t(notifications.popover.otherProjectsUnread$count, {\"count\": {{count}} })",
      "selectProject": "Select a project to view notifications"
    },
    "emptyState": {
      "title": "No notifications yet"
    },
    "item": {
      "addedToProject": {
        "action": "has added you to the project",
        "body": "Click here to view the project and start collaborating."
      },
      "youWereAssignedToIssue": {
        "action": "has assigned you the issue"
      },
      "yourIssueAssignmentWasAccepted": {
        "action": "has accepted an issue you assigned"
      },
      "yourIssueAssignmentWasRejected": {
        "action": "has rejected an issue you assigned"
      },
      "yourIssueWasReassigned": {
        "action": "re-assigned an issue you created assigned"
      },
      "newIssueComment": {
        "action": "left a comment on the issue"
      },
      "newIssuePrivateComment": {
        "action": "left a private comment on the issue"
      },
      "newIssueStatusStatement": {
        "action": "added a status statement to"
      },
      "newShiftReportComment": {
        "action": "left a comment on the shift report"
      },
      "issueCommentMention": {
        "action": "mentioned you on the issue"
      },
      "shiftReportCommentMention": {
        "action": "mentioned you on the shift report"
      },
      "issueNeedsYourApproval": {
        "action": "The issue <span className=font-semibold>{{issueTitle}}</span> needs your approval"
      },
      "yourIssueApprovalRequestWasRejected": {
        "action": "rejected your approval request for the issue",
        "body": "Reason: {{reason}}"
      },
      "yourIssueApprovalRequestWasAccepted": {
        "action_undefined": "<span className=\"font-semibold\"> {{actorFirstName}} </span> approved the issue <span className=\"font-semibold\"> {{issueTitle}}</span>",
        "action": "<span className=\"font-semibold\"> {{actorFirstName}} </span> Approver {{progress}} approved the issue <span className=\"font-semibold\"> {{issueTitle}}</span>"
      },
      "issueWasResolved": {
        "action_undefined": "approved the issue",
        "action": "(Approver {{progress}}) approved the issue",
        "body": "Issue resolved!"
      },
      "issueWasReopened": {
        "action": "reopened the issue"
      },
      "newProjectAccessRequest": {
        "action": "has requested access to the project"
      },
      "newRoleUpgradeRequest": {
        "action": "has requested a permission upgrade"
      }
    }
  },
  "notification": {
    "error": {
      "title": "Ooops!",
      "subTitle": "Sorry, there was an error doing this action, please try again. {{message}}",
      "acknowledgeCTA": "Okay"
    }
  },
  "oauth": {
    "authorize": {
      "title": "{{clientName}} wants to access your Shape account",
      "access": "<bold>{{clientName}} will have the same access as you:</bold> it can see and change everything you can in Shape, across all your projects.",
      "trust": "Only allow access if you trust {{clientName}}. You can disconnect it at any time in <bold>My account › Sign-ins and connected apps</bold>.",
      "notYou": "Not you?",
      "allow": "Allow access",
      "cancel": "Cancel",
      "redirecting": {
        "title": "Taking you back to {{clientName}}…",
        "allowed": "{{clientName}} can now access your Shape account. If nothing happens, close this window and go back to {{clientName}}.",
        "denied": "<bold>Access not allowed.</bold> Nothing has been shared. If nothing happens, close this window and go back to {{clientName}}."
      },
      "error": {
        "title": "We couldn't complete this request",
        "subtitle": "Something went wrong while connecting the app. Go back to the app you came from and try connecting again.",
        "technicalDetails": "Technical details",
        "goToShape": "Go to Shape"
      },
      "footer": {
        "privacy": "Privacy",
        "help": "Help"
      }
    }
  },
  "offline": {
    "title": "You're offline",
    "subTitle": "Looks like you're not connected to a network",
    "status": "Network connectivity limited or unavailable."
  },
  "otpConfirmationForm": {
    "inputPlaceholder": "Enter {{numberOfDigits}}-digits code",
    "submit": "Verify",
    "errors": {
      "default": "The code is invalid",
      "lockedForConfirmation": "Too many verification attempts. Your account has been locked."
    }
  },
  "projects": {
    "members_zero": "{{count}} members",
    "members_one": "{{count}} member",
    "members_other": "{{count}} members",
    "actions": {
      "editDetails": "Edit details",
      "archive": "$t(actions.archive)"
    },
    "tooltips": {
      "onlyAdminCanEdit": "Only the project admin can edit the project's details"
    },
    "archiveModal": {
      "title": "Archive this project",
      "subTitle": "Archiving this project will move it into your archived list where you can still access all of your data.",
      "actions": {
        "cancel": "Cancel",
        "archive": "$t(actions.archive)"
      },
      "feedback": "Your project was archived. You can now find it in the “Archived” tab."
    }
  },
  "projectSetup": {
    "label": "Project setup",
    "newProject": "Create project",
    "createLocation": "Create a location tree",
    "inviteTeamMember": "Add a person",
    "inviteTeam": "Add another organisation",
    "createCustomField": "Create a custom field"
  },
  "quickNewButton": {
    "trigger": {
      "title": "New"
    },
    "issueTracker": {
      "heading": "Issue tracker",
      "options": {
        "completeIssue": {
          "title": "Complete issue",
          "description": "Fill out all details about the issue."
        },
        "quickIssue": {
          "title": "Quick issue",
          "description": "Add at least a title and fill out details later."
        },
        "smartIssue": {
          "title": "Smart issue",
          "description": "Drop in a quick blurb and any photos. We'll fill out the rest.",
          "aiPoweredBeta": "AI-powered Beta"
        }
      }
    },
    "shiftManager": {
      "heading": "Shift manager",
      "options": {
        "shiftReport": {
          "title": "Shift report"
        }
      }
    },
    "weeklyPlanner": {
      "heading": "Weekly planner",
      "options": {
        "workPlan": {
          "title": "Work plan"
        }
      }
    },
    "gallery": {
      "heading": "Gallery",
      "options": {
        "upload": {
          "title": "Upload files & images"
        }
      }
    },
    "activity": {
      "title": "Activity"
    }
  },
  "team": {
    "untitled": "Untitled Organisation",
    "editTitle": "Edit organisation's name",
    "upgradeCTA": {
      "label": "Organisation page upgrade plan",
      "desktop": "Upgrade plan",
      "mobile": "Upgrade"
    },
    "dropdownActions": {
      "remindToJoin": "Remind to join",
      "editInvite": "Edit invite",
      "cancel": "Cancel",
      "edit": "Edit",
      "remove": "Remove"
    },
    "remindAllToJoin": {
      "cta": "Remind all to join",
      "feedback": "Invites sent."
    },
    "remindToJoinFeedback": "Invite sent.",
    "tabs": {
      "joined": "Joined",
      "pending": "Pending",
      "emptyState": {
        "joined": {
          "title": "No one has joined this organisation yet.",
          "subTitle": "Get started by adding users."
        },
        "pending": {
          "title": "There are no pending invites.",
          "subTitle": "Get started by adding users."
        }
      },
      "subscription": {
        "upgrade": "Upgrade plan",
        "update": "Update plan"
      }
    },
    "table": {
      "header": {
        "user": "User",
        "role": "Role",
        "permissions": "Permissions"
      }
    },
    "subscriptions": {
      "card": {
        "shapeGeneral": "Shape (General)",
        "issueTracker": "Issue Tracker",
        "shiftManager": "Shift Manager",
        "dataBook": "Data Book",
        "gallery": "Gallery",
        "actions": {
          "current": "Your current plan",
          "subscribe": "Upgrade",
          "downgrade": "Downgrade plan",
          "contactUs": "Contact us",
          "manageBilling": "Manage billing",
          "email": {
            "free": {
              "subject": "Downgrade plan",
              "body": "Hello Shape Team. May I request the Free version downgrade for my organisation {{teamName}} [organisation id: {{teamId}}].",
              "customDashboards": {
                "body": "Hello Shape Team. May I request the Free version downgrade for my organisation {{teamName}} [organisation id: {{teamId}}]."
              }
            },
            "pro": {
              "subject": "Upgrade plan",
              "body": "Hello Shape Team. May I request the Pro version upgrade for my organisation {{teamName}} [organisation id: {{teamId}}].",
              "customDashboards": {
                "body": "Hello Shape Team. May I request the Pro version upgrade for my organisation {{teamName}} [organisation id: {{teamId}}]. I would like to create a custom dashboard for my team."
              }
            }
          }
        }
      },
      "checkout": {
        "error": {
          "title": "Subscription failed",
          "subtitle": "There was a subscription checkout error.",
          "actions": {
            "dismiss": "Dismiss"
          }
        }
      },
      "loading": {
        "title": "Waiting for status update...",
        "description": "Please don’t leave this page while waiting for the status update."
      },
      "error": {
        "title": "Update failed",
        "description": "We’ve encountered an unexpected error and failed to proceed with the upgrade. Please try again later or contact us at support@shape.construction.",
        "goToTeams": "Go to organisations"
      },
      "success": {
        "title": "Update successful",
        "description": "{{teamName}} is now in a {{planName}} plan and has unlocked the following features",
        "goToTeam": "Go to organisation"
      },
      "plans": {
        "free": {
          "title": "Free",
          "subtitle": "For individuals and small organisations to track and report what’s happening on site",
          "price": "£0",
          "priceInfo": "",
          "shapeGeneral": {
            "collaborators": {
              "name": "Collaborators",
              "detail": "Unlimited"
            },
            "realtimeProjectTimeline": {
              "name": "Real-time project timeline",
              "detail": ""
            }
          },
          "issueTracker": {
            "fullIssueHistory": {
              "name": "Full issue history",
              "detail": ""
            },
            "privateChannelPerIssue": {
              "name": "Private channel per issue",
              "detail": ""
            },
            "offlineIssueCapture": {
              "name": "Offline issue capture",
              "detail": ""
            }
          },
          "shiftManager": {
            "createSiteDiary": {
              "name": "Create site diary",
              "detail": "Unlimited"
            },
            "resourceAllocation": {
              "name": "Resource allocation",
              "detail": ""
            },
            "addPhotoEvidenceToAnyLineItem": {
              "name": "Add photo evidence to any line item",
              "detail": ""
            },
            "professionalPDFOutputs": {
              "name": "Professional PDF outputs",
              "detail": ""
            },
            "saveEffortWithDataPrefill": {
              "name": "Save effort with data pre-fill",
              "detail": ""
            }
          },
          "dataBook": {
            "dataHealthHeatmap": {
              "name": "Issues and shift reports heatmap",
              "detail": ""
            }
          },
          "gallery": {
            "createSiteDiary": {
              "name": "Traceable files & photos",
              "detail": ""
            },
            "automaticCentralisedStorage": {
              "name": "Automatic, centralised storage",
              "detail": ""
            },
            "addCaptionsAndLocationsToAllFiles": {
              "name": "Add captions and locations to all files",
              "detail": ""
            },
            "allPhotosAutoUploaded": {
              "name": "All photos auto-uploaded",
              "detail": ""
            }
          }
        },
        "pro": {
          "title": "Pro",
          "subtitle": "For project organisations to better manage, report, and analyse construction projects",
          "price": "Talk to us",
          "priceInfo": "per person / month, billed monthly",
          "shapeGeneral": {
            "collaborators": {
              "name": "Collaborators",
              "detail": "Unlimited"
            },
            "realtimeProjectTimeline": {
              "name": "Real-time project timeline",
              "detail": ""
            },
            "commercialAssistant": {
              "name": "AI assistant",
              "detail": ""
            }
          },
          "issueTracker": {
            "everythingInFreePlus": {
              "name": "Everything in Free plus:",
              "detail": ""
            },
            "excelDataExport": {
              "name": "Excel data export",
              "detail": ""
            },
            "pdfIssueExport": {
              "name": "PDF issues export",
              "detail": ""
            },
            "generateSingleIssueReport": {
              "name": "Generate single issue report",
              "detail": ""
            }
          },
          "shiftManager": {
            "everythingInFreePlus": {
              "name": "Everything in Free plus:",
              "detail": ""
            },
            "saveTimeWithMultiUserMode": {
              "name": "Save time with multi-user mode",
              "detail": ""
            },
            "excelDataExport": {
              "name": "Excel data export",
              "detail": ""
            },
            "topDownDataQualityView": {
              "name": "Top-down data quality view",
              "detail": ""
            }
          },
          "dataBook": {
            "dataHealthHeatmap": {
              "name": "Issues and shift reports heatmap",
              "detail": ""
            },
            "customDashboards": {
              "name": "Custom dashboards",
              "detail": ""
            },
            "dataInsights": {
              "name": "Data insights",
              "detail": ""
            }
          }
        }
      }
    }
  },
  "treeSelector": {
    "clearAll": "Clear all"
  },
  "search": {
    "placeholder": "Search",
    "issues": {
      "placeholder": "Search issues"
    },
    "people": {
      "currentUser": "(me)",
      "placeholder": "Search for a person",
      "allTeams": "All Organisations",
      "addPerson": "Add a person",
      "addThisPerson": "Add this person",
      "emailSearch": {
        "title": "Add \"{{EMAIL}}\"",
        "subtitle": "Seems like this person is not yet on your project. You may set the permissions, role, and add this person by clicking \"Add this person\" button below."
      },
      "noResults": {
        "title": "We can't find \"{{SEARCHTERM}}\" in the list",
        "subtitle": "Please check the spelling or add by typing the person's email"
      },
      "noOneLeftToAdd": {
        "title": "No one left to add",
        "subtitle": "Everyone in this organisation is already an approver. To add someone new, invite more people."
      },
      "noOneLeftToAddAllOrganisation": {
        "title": "No one left to add",
        "subtitle": "There’s no one left to add from any organisation. To add someone new, invite more people."
      },
      "addPersonForm": {
        "title": "Add a person",
        "subtitle": "You may add a person to your project using their email. You may also set their permissions and role below.",
        "emailField": "Email",
        "roleField": "Permissions",
        "constructionRoleField": "Role",
        "goBackCTA": "Back to search",
        "submitCTA": "Add and select",
        "billingInfo": "You are adding 1 new user. An additional x 1 Shape user license ({{pricePerLicense}}) will be added to your billing."
      },
      "quotaBanner": {
        "badge": "You reached the maximum number of people in an organisation.",
        "teamPageCTA": "Manage organisation",
        "upgradePlanCTA": "Upgrade plan"
      }
    },
    "locations": {
      "title": "Location",
      "placeholder": "Search for a location"
    },
    "disciplines": {
      "placeholder": "Search for a discipline"
    },
    "noResults": {
      "title": "No matching search results",
      "subTitle": "Please check spelling or try different keywords"
    },
    "date": {
      "title": "Date",
      "filter": "Date filters",
      "apply": "Apply"
    },
    "planActivity": {
      "noResults": {
        "title": "Can't find an activity?",
        "subtitle": "It might not be in your work plan or there may be an existing progress log for it"
      }
    }
  },
  "appSidebar": {
    "home": "Home",
    "projectsMenu": "Projects menu",
    "selectProject": "Select project",
    "unreadActivity": "Unread activity in other projects",
    "dataBook": "Data book",
    "admin": "Admin",
    "getShapeAndChannelsOnMobile": {
      "title": "Get Shape and Channels on your phone",
      "titleHighlighted": "Get <span className=\"font-semibold\">Shape</span> and <span className=\"font-semibold\">Channels</span> on your phone",
      "popover": {
        "title": "$t(appSidebar.getShapeAndChannelsOnMobile.titleHighlighted)",
        "shape": {
          "title": "Shape",
          "step1a": "Either tap",
          "step1b": "for iOS or",
          "step1c": "for Android",
          "step2": "Select Add to Homescreen"
        },
        "channels": {
          "title": "Channels",
          "step1": "Scan the QR code or search “Channels” on the App Store or Google Play Store"
        }
      },
      "modal": {
        "title": "Get Shape and Channels on your phone",
        "shapeApp": {
          "title": "Add shape to your home screen",
          "step1a": "Scan the QR code or visit",
          "step1b": "on your web browser",
          "step2": "Login to your Shape account",
          "step3": "Either tap for iOS or for Android",
          "step4": "Select Add to Homescreen"
        },
        "channelsApp": {
          "title": "Download the Shape Channels standalone messaging app",
          "step1": "Keep your work out of your personal messaging apps. Share files & photos instantly, and automatically sync them in your project gallery on Shape."
        },
        "print": "Print"
      }
    }
  },
  "people": {
    "title": "People",
    "none": "None",
    "emptyState": {
      "title": "No people linked yet",
      "description": "Link people to a captured progress log in Channels or publish a shift report with a filled People section",
      "goToShiftManager": "Go to Shift manager"
    },
    "noResults": {
      "title": "No matching results",
      "description": "Try to adjust your filters or clear all to show results.",
      "clearFilters": "Clear all filters"
    },
    "list": {
      "table": {
        "date": "Date",
        "name": "Name",
        "role": "Role",
        "organisation": "Organisation",
        "hours": "Hours allocated",
        "shiftReport": "Linked shift report",
        "shiftReportLink": "Shift report",
        "createdBy": "Created by"
      }
    },
    "filters": {
      "name": {
        "triggerLabel": "Name",
        "filterByLabel": "Filter by name",
        "searchPlaceholder": "Search for a person"
      },
      "role": {
        "triggerLabel": "Role",
        "filterByLabel": "Filter by role",
        "searchPlaceholder": "Search for a role"
      },
      "organisation": {
        "triggerLabel": "Organisation",
        "filterByLabel": "Filter by organisation",
        "searchPlaceholder": "Search for an organisation"
      },
      "createdBy": {
        "triggerLabel": "Created by",
        "filterByLabel": "Filter by creator"
      }
    }
  },
  "progressLogs": {
    "title": "Progress",
    "actions": {
      "edit": "Edit progress log"
    },
    "emptyState": {
      "title": "No progress logs yet",
      "description": "Progress logs show recorded progress across activities. Add a log from a shift report or a weekly work plan to see it here.",
      "action": "New progress log",
      "missing": "Missing",
      "goToShiftReport": "Go to shift report",
      "goToWeeklyPlanner": "Go to weekly planner",
      "none": "None",
      "popoverText": "To show details, please link an activity to the progress log"
    },
    "newProgressLog": {
      "btnTitle": "New progress log",
      "heading": "Record progress",
      "title": "Progress observation",
      "subtitle": "Describe and measure the progress done on the linked activity.",
      "cancelCTA": "Cancel",
      "createCTA": "Create",
      "createSuccessToast": "Progress log was successfully created.",
      "createErrorToast": "Failed to create progress log.",
      "updateErrorToast": "Failed to update activity."
    },
    "editProgressLog": {
      "title": "Edit progress log",
      "cancelCTA": "Cancel",
      "saveCTA": "Save",
      "successToast": "Progress log was successfully edited.",
      "updateErrorToast": "Failed to update progress log.",
      "linkedActivity": {
        "title": "Linked Activity",
        "unlink": "Unlink",
        "searchPlaceholder": "Search name, shape ID, or task ID",
        "percentComplete": "% Complete: {{percentage}}% as of {{date}}"
      }
    },
    "list": {
      "table": {
        "date": "Date",
        "description": "Progress description",
        "qualityUnits": "Quantity and units",
        "createdBy": "Created by",
        "activity": "Activity",
        "taskID": "Task ID",
        "location": "Location",
        "complete": "% Complete",
        "usedIn": "Used in",
        "actions": "Actions",
        "shiftReport": "Shift report"
      }
    },
    "tooltips": {
      "noEditPermission": "You don't have permission to edit this progress log"
    },
    "form": {
      "fields": {
        "comment": {
          "label": "Comment",
          "placeholder": "Add a comment about the progress. This is optional."
        },
        "status": {
          "label": "Status",
          "options": {
            "not_started": "Not started",
            "in_progress": "In progress",
            "completed": "Completed"
          }
        }
      }
    }
  },
  "profileMenu": {
    "appVersion": "Shape App version {{version}}",
    "signedInAs": "Signed in as",
    "menu": {
      "myAccount": "My account",
      "myProjects": "My projects",
      "installApp": "Install Shape",
      "sendFeedback": "Send feedback",
      "logout": "Logout",
      "language": "Language"
    }
  },
  "weeklyPlanner": {
    "workPlans": {
      "title": "Weekly work plans",
      "newPlanCTA": "New work plan",
      "tabs": {
        "myPlans": "My plans",
        "all": "All plans",
        "closed": "Closed",
        "archived": "Archived"
      },
      "table": {
        "heading": {
          "name": "Name",
          "period": "Period",
          "author": "Author",
          "lastUpdated": "Last Updated",
          "status": "Status"
        },
        "emptyStates": {
          "myPlans": {
            "title": "You don’t have any work plans",
            "description": "Create a work plan to plan your activities for the week and track their progress as the week goes by.",
            "action": "New work plan"
          },
          "all": {
            "title": "This project has no work plans yet",
            "description": "Work plans will appear here once anyone creates a work plan.",
            "action": "New work plan"
          },
          "closed": {
            "title": "There are no closed work plans yet",
            "description": "Work plans will appear here once anyone closes out a plan that has ended."
          },
          "archived": {
            "title": "There are no archived work plans yet",
            "description": "Work plans will appear here once anyone archives a work plan.",
            "action": "New work plan"
          }
        },
        "you": "(You)",
        "actions": {
          "publishPlan": "Publish plan",
          "publishLookback": "Publish lookback",
          "edit": "Edit",
          "duplicate": "Duplicate",
          "archive": "Archive",
          "restore": "Restore",
          "tooltips": {
            "menu": "Menu",
            "export": "Export work plan",
            "noEditPermission": "You do not have permission to edit this work plan",
            "noEditClosed": "This work plan is uneditable because it is closed",
            "noDuplicatePermission": "You do not have permission to duplicate this work plan",
            "noArchivePermission": "You do not have permission to archive this work plan",
            "noRestorePermission": "You do not have permission to restore this work plan"
          }
        },
        "archivePlan": {
          "successToast": "\"{{planName}}\" was archived."
        },
        "restorePlan": {
          "successToast": "\"{{planName}}\" was restored. You can find it in My plans/All plans."
        },
        "loadMoreError": {
          "message": "Could not load more plans.",
          "retry": "Try again"
        }
      },
      "newPlan": {
        "title": "New plan",
        "cancelCTA": "Cancel",
        "createCTA": "Create"
      },
      "editPlan": {
        "title": "Edit plan",
        "cancelCTA": "Cancel",
        "saveCTA": "Save"
      },
      "duplicatePlan": {
        "title": "Duplicate plan",
        "cancelCTA": "Cancel",
        "duplicateCTA": "Duplicate"
      },
      "publishPlan": {
        "publish": "Publish plan",
        "modal": {
          "title": "Publish plan",
          "subTitle": "The work plan will be made visible to others. You will not be able to edit the plan once finalised.",
          "cancelCTA": "Cancel",
          "confirmCTA": "Confirm",
          "successToast": "The plan is now visible to others"
        }
      },
      "publishLookback": {
        "publish": "Publish lookback",
        "modal": {
          "title": "Publish lookback",
          "subTitle": "Are you sure you want to finalise all details in the lookback? This will close this work plan permanently and download a PDF report.",
          "cancelCTA": "Cancel",
          "confirmCTA": "Confirm",
          "successToast": "{{planTitle}} lookback was published.<br/><br/>A PDF copy of the work plan will be downloaded."
        }
      },
      "form": {
        "fields": {
          "planName": {
            "label": "Plan name",
            "placeholder": "eg. Week 21 Night Shift",
            "maxLengthLimit": "{{inputLength}} character(s) left."
          },
          "duration": {
            "label": "Duration",
            "startDatePlaceholder": "Start date",
            "endDatePlaceholder": "End date"
          }
        }
      },
      "planEditor": {
        "header": {
          "activityName": "Activity name",
          "location": "Location",
          "organisation": "Organisation",
          "responsible": "Responsible",
          "status": "Status",
          "ready": "Ready?",
          "requirements": "Requirements",
          "planActivityStatus": "Planned?",
          "progress": "Progress now",
          "expectedProgressDate": "Expected progress by <br/> {{expectedEndDate}}",
          "schedule": "Schedule",
          "comment": "Comment",
          "actions": {
            "editPlanDetails": "Edit plan details",
            "duplicate": "Duplicate",
            "archive": "Archive",
            "restore": "Restore",
            "export": {
              "label": "Export",
              "plan": "Export plan",
              "lookback": "Export lookback",
              "lookbackDisabled": "There is no lookback available yet"
            }
          }
        },
        "activityName": {
          "placeholder": "e.g. Slab formwork",
          "error": "Current value here is not a confirmed activity in Shape. Please click on the value to create or select an activity."
        },
        "location": {
          "empty": "Not entered",
          "label": "Select a location",
          "modal": {
            "title": "Select a location",
            "cancelCTA": "$t(actions.cancel)",
            "saveCTA": "$t(actions.save)"
          }
        },
        "organisation": {
          "empty": "Not entered",
          "resourceSearchField": {
            "placeholder": "Not entered",
            "createButton": "Create \"{{term}}\"",
            "noResults": "No matching search results",
            "error": "The current value is not a confirmed resource in Shape. Please click on the value to select or create a new resource.",
            "organisationSuffix": "organisations"
          }
        },
        "responsiblePerson": {
          "empty": "Not entered",
          "search": "Search for a person"
        },
        "activityStatus": {
          "options": {
            "not_started": "Not started",
            "in_progress": "In progress",
            "completed": "Completed"
          }
        },
        "planActivityStatus": {
          "options": {
            "fallback": "Fallback",
            "planned": "Planned",
            "additional": "Additional"
          }
        },
        "requirements": {
          "tooltip": "View requirements",
          "none": "none",
          "count": "{{completed}} / {{total}}"
        },
        "schedule": {
          "tooltip": "Select a day by clicking on it. Selected days are indigo.",
          "tooltipReadOnly": "You cannot modify the schedule because the plan has been published.",
          "day1label": "Sun",
          "day2label": "Mon",
          "day3label": "Tue",
          "day4label": "Wed",
          "day5label": "Thu",
          "day6label": "Fri",
          "day7label": "Sat"
        },
        "addRowCTA": "Add row",
        "addActivitiesCTA": "Add activities",
        "activityDropdown": {
          "tooltip": "Menu",
          "delete": "Remove from plan",
          "viewActivity": "View activity"
        },
        "exportPDF": {
          "confirmation": {
            "plan": {
              "title": "Export work plan to PDF",
              "subtitle": "Are you sure you want to export this work plan? The PDF will be downloaded."
            },
            "lookback": {
              "title": "Export lookback to PDF",
              "subtitle": "Are you sure you want to export this lookback? The PDF will be downloaded."
            },
            "dismiss": "$t(actions.cancel)",
            "confirm": "Export"
          }
        },
        "addActivitiesModal": {
          "title": "Add activities",
          "cancelCTA": "Cancel",
          "addSelectedCTA": "Add selected",
          "tooltip": "Please select at least <br/> one activity to add.",
          "successToast_zero": "{{numberOfActivities}} activities have been successfully added.",
          "successToast_one": "{{numberOfActivities}} activity has been successfully added.",
          "successToast_other": "{{numberOfActivities}} activities have been successfully added.",
          "errorToast": "The activities could not be added. Please try again.",
          "emptyList": {
            "title": "You don't have any activities yet.",
            "subtitle": "Please create in the weekly work plan or import in the Activities page.",
            "goToActivitiesLink": "Go to activities"
          },
          "filtersNoResults": {
            "title": "No matching search results",
            "subtitle": "Try to adjust your filters or clear all to show results.",
            "clearAllFiltersCTA": "Clear all filters"
          }
        },
        "notEditableAlertMessage": "You can't make changes on this Plan tab because it has been published. To add more activities, head to the Progress & Lookback tab.",
        "placeholderFormLabel": "New plan activity form",
        "prefillPlan": {
          "button": "Prefill from previous",
          "modal": {
            "title": "Override the current work plan",
            "subtitle": "Activities that are \"Not started\" or \"In progress\" from <b>{{planName}} ({{planStartDate}} to {{planEndDate}})</b> will populate this plan.",
            "cancelCTA": "Cancel",
            "overrideCTA": "Override"
          },
          "toast": {
            "success": "Activities from {{planName}} were copied over successfully."
          }
        }
      },
      "details": {
        "tabs": {
          "plan": "Plan",
          "progressAndLookback": "Progress & Lookback"
        },
        "ppc": {
          "label": "PPC {{ppc}}%",
          "button": "PPC",
          "title": "Percent Plan Complete (PPC)",
          "description": "This measures how accurately planned this week's activities are. A score close to 100% indicates the plan is reliable. A low score indicates problems on site are hampering progress or overcommitment.",
          "calculation": "The calculation for this is: Number of \"Achieved\" planned activities / Total \"Planned\" activities * 100."
        },
        "draftVisibility": {
          "label": "You only",
          "title": "Drafts are only visible to you",
          "description": "<p>Draft plans are editable and only visible to the author of the work plan.</p> <p>Clicking on the “Publish plan” button will make the plan uneditable. This will also make this visible to others.</p>"
        },
        "taskIDVisibility": {
          "title": "Task ID and Activity name",
          "description": "If the activity has a Task ID, it is shown along with the activity's name. The Task ID can be added or edited in the activity's details."
        },
        "organisationMessage": {
          "title": "Organisation",
          "description": "Organisation options can also be found or created in shift reports or admin > resources."
        },
        "archivedPlan": {
          "description": "This work plan has been archived.",
          "restoreCTA": "Restore",
          "toast": {
            "success": "\"{{planName}}\" was restored. You can find it in My plans/All plans."
          }
        }
      },
      "progressTracker": {
        "card": {
          "expectingProgress": "Expecting {{percent}}% progress by {{day}}",
          "progressOnThisDay": "Progress on this day",
          "editCTA": "Edit",
          "showPreviousCTA": "Show previous",
          "previousProgress": "Previous progress ({{day}})",
          "dropdownActions": {
            "workPlanActivityDetails": "Work plan activity details",
            "delete": "Delete"
          },
          "deleteConfirmationModal": {
            "title": "Delete progress log",
            "subtitle": "Are you sure you want to delete this draft? This action cannot be undone.",
            "cancelCTA": "$t(actions.cancel)",
            "deleteCTA": "$t(actions.delete)",
            "successToast": "Progress log has been successfully deleted."
          }
        },
        "drawer": {
          "title_true": "Update progress",
          "title": "Record progress",
          "cancelCTA": "Cancel",
          "nextCTA": "Next",
          "backCTA": "Back",
          "doneCTA": "Done",
          "dateLabel": "Happened on",
          "datePlaceholder": "Select a date",
          "dateReadOnlyTooltip": "You cannot change the date",
          "searchActivityLabel": "Activity",
          "progressLabel": "% Complete",
          "descriptionLabel": "Description",
          "descriptionPlaceholder": "Add a description or comment about the progress. This is optional.",
          "activityProgress": "% Complete: {{percent}}%",
          "activityReadOnlyTooltip": "You cannot change the activity",
          "evidenceLabel": "Evidence",
          "evidencePlaceholderTitle": "No evidence yet",
          "createSuccessToast": "The {{date}} progress log was successfully added in the activity \"{{description}}\"",
          "updateSuccessToast": "Progress log has been successfully updated.",
          "progressLogFormFields": {
            "progressObservation": {
              "title": "Progress observation",
              "content": "Describe and measure the progress done on the linked activity."
            },
            "quantityUnits": {
              "quantity": "Quantity",
              "units": "Units"
            }
          },
          "shiftActivityForm": {
            "activityUpdates": {
              "title": "Activity updates",
              "content": "Update activity details considering the progress observation."
            },
            "activityDetails": {
              "label": "Activity linked to this progress log"
            },
            "actualStart": {
              "label": "Actual start",
              "description": "Inferred from the first progress log."
            },
            "actualFinish": {
              "label": "Actual finish",
              "description": "Inferred from the last progress log."
            },
            "expectedFinish": {
              "label": "Expected finish"
            }
          },
          "alert": {
            "editDescription": "This activity already has a progress log on {{date}}. Please edit that log instead or change the date.",
            "editCTA": "Edit existing log",
            "connectedToWorkPlanDescription": "This progress log was created in a weekly work plan."
          }
        }
      },
      "lookback": {
        "header": {
          "activityName": "Activity name",
          "location": "Location",
          "organisation": "Organisation",
          "status": "Status",
          "planActivityStatus": "Planned?",
          "expectedProgressDate": "Expected progress <br/> by {{planEndDate}}",
          "achievedProgressDate": "Achieved progress <br/> by {{planEndDate}}",
          "progressLogs": "Progress logs",
          "varianceCategory": "Variance category",
          "varianceRemarks": "Remarks",
          "varianceRecoveryMitigationMeasures": "Recovery/mitigation measures",
          "expectedFinishDate": "Expected finish",
          "comment": "Comment"
        },
        "location": {
          "empty": "Not entered"
        },
        "activityStatus": {
          "options": {
            "noStatus": "No status",
            "notStarted": "Not started",
            "inProgress": "In progress",
            "completed": "Completed"
          }
        },
        "planActivityStatus": {
          "options": {
            "fallback": "Fallback",
            "planned": "Planned",
            "additional": "Additional"
          }
        },
        "achievedProgress": {
          "achievedBadge": "Achieved",
          "explainVarianceCTA": "Explain"
        },
        "planStatus": {
          "closed": {
            "alert": "The information in this tab has been locked because this work plan is closed."
          },
          "reviewing": {
            "alert_zero": "<b>{{count}} activities</b> are missing  variance explanations",
            "alert_one": "<b>{{count}} activity</b> is missing a variance explanation",
            "alert_other": "<b>{{count}} activities</b> are missing  variance explanations"
          }
        },
        "progressLogs": {
          "tooltip": {
            "noProgressLog": "No progress log. Click to add.",
            "missingProgressLog": "Missing progress log. Click to add.",
            "checkProgressLog": "Click to check the progress log for this day.",
            "noPermissions": "You don't have sufficient permissions to add a progress log.",
            "planClosed": "You cannot add a progress log on a closed work plan."
          },
          "drawer": {
            "title": "Progress log on {{date}}"
          }
        },
        "varianceCategory": {
          "options": {
            "approval_delays": "Approval delays",
            "client_changes": "Client changes",
            "delay_in_decision_or_communication": "Delay in decision or communication",
            "design_information_issues": "Design information issues",
            "documentation_issues": "Documentation issues",
            "equipment_unavailability": "Equipment unavailability",
            "inaccurate_estimates": "Inaccurate estimates",
            "inadequate_access_to_workface": "Inadequate access to workface",
            "material_shortage": "Material shortage",
            "miscellaneous": "Miscellaneous",
            "personnel_shortage": "Personnel shortage",
            "previous_trade_handover_delay": "Previous trade handover delay",
            "priority_reassessment": "Priority reassessment",
            "process_inefficiencies": "Process inefficiencies",
            "rework_required": "Rework required",
            "safety_concerns_unsafe_conditions": "Safety concerns/unsafe conditions",
            "scheduling_conflicts": "Scheduling conflicts",
            "technical_challenges": "Technical challenges",
            "weather_conditions": "Weather conditions"
          }
        },
        "emptyState": {
          "title": "There are no activities in your plan",
          "description": "Add activities into the “Plan week” tab, record the progress of those activities in the “Track works” tab, and return here to compare the planned and actual activity progress."
        },
        "dayLog": {
          "numberOfLogs": "{{numberOfLogs}} / 1",
          "delta": "{{delta}} %",
          "tooltip": {
            "complete": "Complete: Both progress observation and % Complete are filled.",
            "incomplete": "Incomplete: Needs a progress observation and % Complete update.",
            "incomplete-delta": "Incomplete: Please add a % Complete update.",
            "incomplete-logs": "Incomplete: Please add a progress observation.",
            "not-scheduled": "No work scheduled. Click to record progress if needed."
          }
        },
        "recordVariance": {
          "title": "Add variance details",
          "saveCTA": "Save",
          "activityFromPlan": "Activity from work plan",
          "varianceCategory": {
            "label": "Category"
          },
          "varianceRemarks": {
            "label": "Remarks",
            "placeholder": "Add remarks on why the variance happened."
          },
          "varianceRecoveryMitigationMeasures": {
            "label": "Recovery/mitigation measures",
            "placeholder": "Add recovery/mitigation measures."
          }
        },
        "placeholders": {
          "location": "Not entered",
          "organisation": "Not entered",
          "varianceCategory": "Not entered",
          "expectedFinishDate": "Not entered"
        },
        "additionalActivityPlaceholderRow": "Additional activity row",
        "addAdditionalActivityCTA": "Add additional activity",
        "additionalActivityCTAPopup": "Add unexpected work that emerged during the week"
      },
      "savingIndicator": {
        "saved": "Saved",
        "saving": "Saving"
      }
    }
  },
  "mediaGallery": {
    "upload": {
      "scope": {
        "document": "Add document",
        "image": "Add image",
        "file": "Add file"
      },
      "success": "{{filename}} successfully uploaded.",
      "error": "{{filename}} could not be uploaded. Please try again later.",
      "trigger": {
        "title": "Add"
      },
      "options": {
        "gallery": {
          "short_title": "Gallery",
          "title": "Upload from gallery"
        },
        "camera": {
          "short_title": "Camera",
          "title": "Upload from camera"
        },
        "documents": {
          "short_title": "Documents",
          "title": "Upload from device"
        },
        "projectGallery": {
          "short_title": "Project gallery",
          "title": "Attach from project gallery"
        }
      }
    },
    "uploadMedia": "Upload media",
    "uploadFile": "Upload a file",
    "uploadFileDescription": "Files up to 100MB",
    "uploadImage": "Upload an image",
    "uploadImages": "Upload images",
    "uploadImageDescription": "JPG, PNG up to 10MB",
    "pdf": {
      "uploadError": {
        "title": "We’re having difficulties opening your file",
        "description": "Please upload this file again to properly view it"
      },
      "notSupported": {
        "title": "PDF preview is not supported in Shape's mobile view yet",
        "link": "Open in a new tab"
      }
    },
    "downloadAllTooltip_one": "{{count}} file available to download",
    "downloadAllTooltip_other": "{{count}} files available to download"
  },
  "projectsMenu": {
    "newProject": "New project",
    "allProjects": "All projects"
  },
  "featureLimits": {
    "badge": "Pro",
    "banner": {
      "title": "This is a pro feature",
      "body": "Unlock this and other features with a pro plan. Contact us to learn more."
    }
  },
  "quotaLimits": {
    "cta": "More info",
    "badge": "$t(search.people.quotaBanner.badge)"
  },
  "subscriptionPlan": {
    "modal": {
      "heading": "Upgrade to unlock",
      "title": "This is a pro feature",
      "subtitle": "Unlock this and other features with a pro plan.",
      "learnMore": "Learn more",
      "talkToUs": "Talk to us"
    },
    "page": {
      "printIssue": "Print issue",
      "title": "is a pro feature",
      "subtitle": "Unlock this and other features with a pro plan."
    },
    "goBackToIssue": "Go back to issue",
    "badge": {
      "trial": "Pro trial",
      "free": "Free"
    },
    "upgradeBanner": {
      "trial": {
        "header": "Pro trial",
        "daysLeft": "{{days}} days left",
        "body": "Upgrade to keep Pro features after your trial.",
        "urgentBody": "Your trial ends soon. Upgrade to keep Pro features.",
        "cta": "Upgrade to Pro"
      },
      "free": {
        "header": "Upgrade to Pro",
        "body": "Unlock Pro's advanced features for your project.",
        "cta": "See plans"
      }
    },
    "trialBanner": {
      "daysLeft": "{{days}} days left of your Pro trial."
    }
  },
  "shiftManager": {
    "title": "Shift reports",
    "tabs": {
      "shiftReports": {
        "published": "Published",
        "archived": "Archived",
        "inProgress": "In progress",
        "inReview": "In review"
      },
      "shiftActivities": {
        "activities": "Activities",
        "archived": "Archived activities"
      },
      "manager": {
        "managerView": "Manager view"
      }
    },
    "activities": {
      "emptyList": {
        "activities": {
          "title": "You don't have any activities yet.",
          "subtitle": "Add some here to quickly reference them on your shift reports.",
          "newCTA": "New activity"
        },
        "archived": {
          "title": "You don't have any archived activities.",
          "subtitle": "Archived activities will appear here."
        }
      },
      "list": {
        "shapeId": "Shape ID:",
        "taskId": "Task ID:",
        "percentageCompleted": "% Complete: {{progress}}% as of {{today}}",
        "expectedFinish": "Expected finish: {{expectedFinish}}",
        "archived": "Archived",
        "critical": "Critical"
      },
      "noResultsPlaceholder": {
        "title": "No matching search results",
        "subtitle": "Please check spelling or try different keywords"
      },
      "breadcrumbs": {
        "overview": "Overview",
        "activityDetails": "Activity details",
        "gallery": "Gallery",
        "weeklyPlanning": "Weekly planning",
        "dailyProgress": "Daily progress",
        "readiness": "Activity readiness",
        "resourcesUsed": "Resources used"
      },
      "details": {
        "title": "Activity details",
        "archivedWarning": "This activity is archived.",
        "actions": {
          "edit": "Edit",
          "archive": "Archive",
          "restore": "Restore",
          "seeAll": "See all"
        },
        "shapeId": "Shape ID",
        "taskId": "Task ID",
        "type": "Type",
        "location": "Location",
        "status": "Status",
        "progress": "Progress",
        "tooltip": {
          "shapeId": "The activity ID on Shape when this activity was created",
          "taskId": "Used to link this activity to your master schedule (e.g. in P6, Asta, Aphex, Excel). Just make sure that this is ID is the same in your master schedule."
        },
        "timeTable": {
          "planned": "Planned",
          "actual": "Actual",
          "start": "Start",
          "finish": "Finish",
          "original": "Original",
          "expected": "Expected"
        },
        "organisation": "Organisation",
        "owner": "Activity owner",
        "critical": {
          "title": "Critical",
          "yes": "Yes",
          "no": "No"
        }
      },
      "gallery": {
        "title": "Gallery",
        "actions": {
          "seeAll": "See all",
          "sort": {
            "label": "Sort",
            "newest": "Newest",
            "oldest": "Oldest"
          },
          "filter": {
            "label": "Show",
            "all": "All",
            "images": "Images"
          }
        },
        "emptyStateLabels": {
          "title": "Nothing to show yet",
          "subtitle": "Attach photos/files to progress logs or shift report progress observations."
        }
      },
      "weeklyPlanning": {
        "title": "Weekly planning",
        "actions": {
          "seeAll": "See all"
        },
        "emptyStateLabels": {
          "title": "Nothing to show yet",
          "subtitle": "Weekly work plans with this activity will appear once they are closed."
        },
        "tableHeaders": {
          "duration": "Duration",
          "expectedProgress": "Expected progress",
          "actualProgress": "Actual progress",
          "varianceCategory": "Variance category",
          "remarks": "Remarks",
          "mitigation": "Mitigation measures",
          "author": "Author"
        },
        "tooltip": {
          "weeklyWorkPlanLink": "Go to {{planName}}"
        }
      },
      "dailyProgress": {
        "title": "Daily progress",
        "emptyStateLabels": {
          "title": "Nothing to show yet",
          "subtitle": "Add progress logs in a weekly work plan or progress observations in a shift report."
        },
        "actions": {
          "seeAll": "See all"
        },
        "tableHeaders": {
          "date": "Date",
          "location": "Location",
          "progressDescription": "Progress description",
          "progress": "Progress",
          "author": "Author",
          "planned": "Planned?"
        },
        "links": {
          "shiftReport": "Shift report",
          "progressLog": "Progress log"
        }
      },
      "resourcesUsed": {
        "title": "Resources used",
        "actions": {
          "seeAll": "See all"
        },
        "emptyStateLabels": {
          "title": "Nothing to show yet",
          "subtitle": "Link this activity to a resource (e.g. people, equipment, material) on a shift report."
        },
        "emptyMaterialLabels": {
          "title": "No material linked yet",
          "subtitle": "Link this activity to a material on a shift report."
        },
        "noHoursAllocated": "No hours allocated",
        "personnelTotalHours": {
          "label": "Total hours worked by personnel",
          "tooltip": "People are assigned to work on this activity. This totals every person's hours on this activity",
          "emptyTooltip": "Go to a shift report and allocate hours to linked people."
        },
        "equipmentTotalHours": {
          "label": "Total hours of equipment usage",
          "tooltip": "Equipment is used to work on this activity. This totals every equipment's hours on this activity",
          "emptyTooltip": "Go to a shift report and allocate hours to linked equipment."
        },
        "tableHeaders": {
          "material": "Material",
          "quantity": "Quantity",
          "unit": "Unit",
          "date": "Date"
        }
      },
      "readiness": {
        "title": "Activity readiness",
        "status": {
          "ready": "Ready",
          "notReady": "Not ready"
        },
        "updaterStatus_true": "<b>{{teamMember}}</b> marked this activity as <b>ready</b> on <b>{{date}}</b>",
        "updaterStatus": "<b>{{teamMember}}</b> marked this activity as <b>not ready</b> on <b>{{date}}</b>",
        "requirements": {
          "title": "Requirements",
          "empty": {
            "title": "What's needed to start this activity?",
            "description": "Add task requirements to move this activity to 'Ready'.",
            "action": "Add new requirement"
          },
          "placeholder": "Type a new requirement..."
        },
        "createSuccess": "Requirement added successfully.",
        "updateSuccess": "Changes saved.",
        "updateError": "Error on saving changes.",
        "createError": "Error on creating requirement.",
        "deleteSuccess": "Requirement successfully deleted.",
        "deleteError": "Error on delete requirement.",
        "actions": {
          "newRequirement": "New requirement",
          "deleteRequirement": "Delete requirement",
          "markAsReady": "Mark as ready",
          "markAsNotReady": "Mark as not ready",
          "toggleReadySuccess_true": "Activity successfully marked as \"Ready\".",
          "toggleReadySuccess": "Activity successfully marked as \"Not ready\".",
          "toggleReadyError": "Error on changing activity readiness.",
          "seeAll": "See all"
        },
        "deleteConfirmation": {
          "title": "Delete this requirement?",
          "subtitle": "You are about to delete a requirement. This action is permanent and cannot be undone.",
          "cancelCTA": "$t(actions.cancel)",
          "deleteCTA": "$t(actions.delete)",
          "error": "Error on deleting requirement.",
          "success": "Requirement successfully deleted."
        },
        "blockers": {
          "title": "Blockers",
          "empty": {
            "title": "What's blocking this activity?",
            "description": "Add issues blocking this activity from being progressed.",
            "action": "Add blockers"
          },
          "search": {
            "placeholder": "Type to search or create new blocker",
            "blockerSuffix": "blockers",
            "createButton": {
              "withBlockerName": "Create \"{{blockerName}}\"",
              "emptyBlockerName": "Create new blocker"
            },
            "toasts": {
              "blankTitleError": "Blocker title cannot be empty."
            }
          },
          "actions": {
            "deleteBlocker": "Delete blocker",
            "addBlockers": "Add blockers"
          },
          "toasts": {
            "addError": "Error on adding blocker.",
            "addSuccess": "Blocker added successfully.",
            "deleteError": "Error on deleting blocker.",
            "deleteSuccess": "Blocker successfully deleted."
          },
          "tooltips": {
            "noPermission": {
              "delete": "You don't have permission to delete this blocker",
              "create": "You don't have permission to link new blockers"
            }
          },
          "deleteConfirmation": {
            "title": "Delete this blocker?",
            "subtitle": "You are about to delete a blocker. This action is permanent and cannot be undone.",
            "cancelCTA": "$t(actions.cancel)",
            "deleteCTA": "$t(actions.delete)"
          }
        }
      }
    },
    "export": {
      "exportModalAlert": {
        "all": "Exporting all reports.",
        "filtered": "Exporting reports based on current filters.",
        "selected": "Exporting selected reports."
      },
      "xlsx": {
        "description": "All in a single Excel file"
      },
      "pdf": {
        "description": "All as individual PDF files"
      }
    }
  },
  "activities": {
    "newCTA": "New activity",
    "searchPlaceholder": "Search name or reference no.",
    "filters": {
      "readiness": {
        "label": "Readiness",
        "title": "Filter by readiness",
        "options": {
          "all": "All",
          "ready": "Ready",
          "notReady": "Not ready"
        }
      }
    },
    "new": {
      "title": "Create activity",
      "cancelCTA": "Cancel"
    },
    "edit": {
      "title": "Edit activity",
      "cancelCTA": "Cancel",
      "loadError": "Couldn't load this activity"
    },
    "form": {
      "createCTA": "Create",
      "saveCTA": "Save changes",
      "fields": {
        "critical": {
          "label": "Mark as critical"
        },
        "description": "Name",
        "task_identifier": {
          "label": "Task ID",
          "helpText": "To link this activity to your master schedule, Shape will use this ID to identify this activity. Maximum of 50 characters long."
        },
        "status": {
          "label": "Status",
          "options": {
            "not_started": "Not started",
            "in_progress": "In progress",
            "completed": "Completed"
          }
        },
        "location": {
          "label": "Location",
          "placeholder": "Add location",
          "form": {
            "title": "Select a location",
            "cancelCTA": "Cancel",
            "selectCTA": "Select"
          }
        },
        "organisation": {
          "label": "Organisation",
          "placeholder": "Add organisation"
        },
        "owner": {
          "label": "Activity owner",
          "triggerLabel": "Add owner",
          "filterByLabel": "Filter by activity owner",
          "searchPlaceholder": "Search for an activity owner"
        },
        "type": {
          "label": "Type",
          "placeholder": "Select a type",
          "options": {
            "programme": "Programme",
            "additional": "Additional",
            "rework": "Rework"
          }
        },
        "percentage_completed": "Progress %",
        "planned_start_date": "Planned start",
        "planned_end_date": "Planned finish",
        "expected_finish_date": "Expected finish",
        "actual_start_date": "Actual start",
        "actual_end_date": "Actual finish",
        "progressNow": {
          "label": "Actual progress now",
          "placeholder": "You can only add progress when the activity has been successfully created.",
          "noProgress": "No progress yet",
          "newProgressLogCTA": "New progress log",
          "editProgressLogCTA": "Edit",
          "connectedInfo": {
            "title": "Connected to weekly work plans",
            "description": "You can also change this activity's actual progress now from an “in tracking” work plan.",
            "disabledNewProgressTooltip": "You can't create a progress log for the future. Also, an activity can only have one progress log per day."
          }
        }
      },
      "toast": {
        "createSuccess": "Activity was successfully created.",
        "editSuccess": "Activity was successfully edited."
      }
    },
    "activityDetails": {
      "archivedWarning": "This activity is archived.",
      "restoreCTA": "Restore",
      "header": {
        "shapeId": "Shape ID: {{id}}",
        "createdOn": "Created on:",
        "closeCTA": "Close"
      },
      "status": {
        "title": "Status",
        "options": {
          "not_started": "Not started",
          "in_progress": "In progress",
          "completed": "Completed"
        }
      },
      "task_identifier": {
        "title": "Task ID",
        "subtitle": "To link this activity to your master schedule, Shape will use this ID to identify this activity.",
        "placeholder": "No task ID yet to link this activity to your master schedule (e.g. in P6, Asta, Aphex, Excel)."
      },
      "location": {
        "title": "Location",
        "notEntered": "Not entered"
      },
      "overview": {
        "title": "Overview"
      },
      "planned": {
        "title": "Planned",
        "dates": {
          "plannedStart": "Planned start",
          "plannedEnd": "Planned finish",
          "expectedFinish": "Expected finish"
        }
      },
      "actual": {
        "title": "Actual",
        "dates": {
          "actualStart": "Actual start",
          "actualEnd": "Actual finish"
        },
        "progress": {
          "title": "Progress",
          "percentage$progressLogDate_undefined": "",
          "percentage$progressLogDate": "{{progressLogDate}}",
          "percentage$isToday_true": "(today)",
          "percentage$isToday": "",
          "percentage": "{{percentageCompleted}}% as of $t(activities.activityDetails.actual.progress.percentage$progressLogDate, {\"context\": \"{{progressLogDate}}\"}) $t(activities.activityDetails.actual.progress.percentage$isToday, {\"context\": \"{{isToday}}\"})",
          "notEntered": "Not entered"
        }
      },
      "date": {
        "notEntered": "Not entered"
      },
      "visibility": {
        "title": "Visibility",
        "privateTitle": "Private",
        "privateSubtitle": "Only your organisation can see this activity."
      },
      "footer": {
        "archiveCTA": "Archive",
        "editCTA": "Edit details",
        "restoreCTA": "Restore"
      },
      "tabs": {
        "details": "Details",
        "progressHistory": "Progress history"
      }
    },
    "activityHistory": {
      "noHistory": "No progress history.",
      "updatedProgressTo": "Updated progress to",
      "progress": "{{progress}}%",
      "withComment": "with comment",
      "from": "From:",
      "modified": "Modified on: {{date}} by {{name}}",
      "edit": "Edit"
    },
    "activityCard": {
      "archiveCTA": "Archive",
      "restoreCTA": "Restore"
    },
    "archiveModal": {
      "title": "Archive activity",
      "subtitle": "Are you sure you want to archive this activity?",
      "actions": {
        "cancel": "Cancel",
        "archive": "Archive"
      },
      "success": "The activity was archived. You can now find it in the “Archived activities” tab."
    },
    "restoreModal": {
      "title": "Restore activity",
      "subtitle": "Are you sure you want to restore this activity?",
      "actions": {
        "cancel": "Cancel",
        "restore": "Restore"
      },
      "success": "The activity was restored. You can now find it in the \"Activities” tab."
    },
    "search": {
      "activitySuffix": "activities",
      "createButton": {
        "emptyActivityName": "Create activity",
        "withActivityName": "Create \"{{activityName}}\""
      }
    },
    "import": {
      "trigger": {
        "title": "Import"
      },
      "options": {
        "importData": {
          "title": "Import from XLSX",
          "subtitle": "Upload activity data using the XLSX template",
          "toast": {
            "checkingErrors": "We're checking your import file for errors.",
            "importState": "Importing activities...<br/><br/>You will receive an email summary once the import is completed. You can continue using Shape at this time.",
            "success": "Your activities have been imported from XLSX successfully. Please check your email for the import summary."
          }
        },
        "downloadTemplate": {
          "title": "Download XLSX template",
          "subtitle": "A blank template you can use to upload data"
        }
      }
    },
    "export": {
      "exportCTA": "Export"
    },
    "title": "Activities",
    "tabs": {
      "all": "All",
      "archived": "Archived"
    },
    "blockers": {
      "drawer": {
        "title": "Blockers",
        "subtitle": "You can search, multiple select and link blockers.",
        "linkCTA": "Link selected",
        "cancelCTA": "Cancel",
        "tabs": {
          "all": "All issues",
          "myIssues": "My issues"
        },
        "createNewIssueCTA": {
          "withIssueName": "Create \"{{issueName}}\""
        },
        "search": {
          "placeholder": "Type to search or create new blocker"
        }
      },
      "badge": {
        "noBlockers": "No blockers",
        "unresolvedBlockersCount_zero": "{{number}} blockers",
        "unresolvedBlockersCount_one": "1 blocker",
        "unresolvedBlockersCount_other": "{{number}} blockers",
        "resolvedBlockers": "Blockers resolved"
      }
    }
  },
  "shiftReport": {
    "new": {
      "author": "Author",
      "title": "New shift report",
      "publish": "Publish",
      "saveDraft": "Save draft",
      "save": "Save",
      "private": "Private",
      "prefillFromPrevious": "Pre-fill from previous",
      "editAsCollaboratorLabel": "You are editing this report as a collaborator",
      "draftSaved": "Saved",
      "draftSaving": "Saving",
      "preview": "Preview"
    },
    "tabs": {
      "report": "Report",
      "collaborators": "Collaborator comms",
      "comments": "Comments"
    },
    "edit": {
      "title": "Edit shift report"
    },
    "view": {
      "title": "View shift report",
      "edit": "Edit",
      "exportCTA": "Export",
      "archiveCTA": "Archive",
      "restoreCTA": "Restore",
      "shareCTA": "Share",
      "archivedMessage": "This report is archived.",
      "deleteCTA": "$t(actions.delete)"
    },
    "list": {
      "table": {
        "you": "(You)",
        "removedUser": "(Removed user)",
        "date": "Date",
        "reporter": "Reporter",
        "team": "Organisation",
        "visibility": "Visibility",
        "private": "Private",
        "public": "Public",
        "specificTeams": "Specific organisations",
        "shift": "Shift",
        "author": "Author",
        "collaborators": "Collaborators",
        "approver": "Approver",
        "quality": "Completeness",
        "emptyRow": "-",
        "actions": {
          "header": "Actions",
          "view": "View shift report",
          "edit": "Edit shift report",
          "print": "Print shift report",
          "delete": "Delete shift report",
          "duplicate": "$t(actions.duplicate)",
          "archive": "$t(actions.archive)",
          "restore": "$t(actions.restore)"
        },
        "checkbox": {
          "selectAllLoaded": "Select all loaded reports",
          "unselectAllLoaded": "Unselect all loaded reports"
        }
      },
      "placeholder": {
        "noReports": "You don't have any reports yet",
        "noReportsInProgress": "You don't have any \"in progress\" shift reports",
        "noReportsArchived": "You don't have any archived reports",
        "noReportsViewer": "There aren't any reports yet",
        "noReportsInReview": "No reports are waiting for review.",
        "info": "This space will be filled with reports when your organisation starts submitting them.",
        "infoInProgress": "Shift reports will appear for you here if you are invited to collaborate by your colleagues.",
        "infoViewer": "You don't have permission to create reports, but this space will be filled with reports when your organisation starts submitting them.",
        "infoInReview": "When you submit a report for approval, it will appear here.",
        "cta": "Otherwise, you can start a new one by clicking below.",
        "noFiltersTitle": "No reports found",
        "noFiltersSubtitle": "There are no reports found with the filters applied. You may try adjusting the filters.",
        "ctaInReview": "Go to in progress reports"
      },
      "loadMoreError": {
        "message": "Could not load more reports.",
        "retry": "Try again"
      }
    },
    "visibility": {
      "private": "Private",
      "public": "Public",
      "specificTeams": "Specific organisations",
      "visibility": "Visibility"
    },
    "qualityLabel": {
      "title": "Completeness",
      "notuseful": "Not useful",
      "thebasics": "The basics",
      "good": "Good",
      "verygood": "Very good",
      "comprehensive": "Comprehensive"
    },
    "qualityTableInfo": {
      "title": "Report completeness",
      "info": "The report completeness indicator scores each shift report based on the presence of important information about the shift.",
      "percentageRange": {
        "notuseful": "0-19%",
        "thebasics": "20-39%",
        "good": "40-59%",
        "verygood": "60-79%",
        "comprehensive": ">80%"
      }
    },
    "progressPopover": {
      "currentScore": "Your current score",
      "basics": {
        "title": "The basics",
        "titleInfo": "{{complete}} / {{total}}%",
        "addReportDate": "Add a report date",
        "addReportTitle": "Add a report title",
        "addProgressDowntime": "Add progress or downtime",
        "addWeatherDescription": "Add weather description"
      },
      "people": {
        "title": "People",
        "titleInfo": "{{complete}} / {{total}}%",
        "addPeopleToReport": "Add people to your report"
      },
      "equipment": {
        "title": "Equipment",
        "titleInfo": "{{complete}} / {{total}}%",
        "addEquipmentToReport": "Add equipment to your report"
      },
      "material": {
        "title": "Material",
        "titleInfo": "{{complete}} / {{total}}%",
        "addMaterialToReport": "Add material to your report"
      },
      "evidence": {
        "title": "Evidence",
        "titleInfo": "{{complete}} / {{total}}%",
        "reportsEvidenced": "{{complete}} / {{total}} time reports are evidenced"
      },
      "allocations": {
        "title": "Allocations",
        "titleInfo": "{{complete}} / {{total}}%",
        "resourcesAllocated": "{{complete}} / {{total}} resources are allocated to time"
      },
      "info": {
        "description": "Complete the basics to unlock next steps"
      }
    },
    "approvals": {
      "title": "Approver",
      "submitForApproval": "Submit for approval",
      "pendingApproval": "Pending approval",
      "approvePublish": "Approve and publish",
      "inReviewTooltip": "This shift report is being reviewed by the approver. If you want to publish the report without approval, you have to unassign the approver.",
      "successReviewToast": "Shift report submitted for review",
      "unassigned": "Unassigned",
      "search": "Search for a person",
      "addApprover": "Select an approver"
    },
    "form": {
      "shiftReportForm": "Shift report form",
      "shiftReportView": "Shift report view",
      "projectDetails": "Project details",
      "projectName": "Project name",
      "projectNumber": "Project number",
      "teamName": "Organisation name",
      "teamLogo": "Organisation logo",
      "documents": "Files & Images",
      "docRefNumberInternal": "Document reference number (internal)",
      "docRefNumberClient": "Document reference number (client)",
      "shiftDetails": "Shift details",
      "reportTitle": "Report title",
      "reportDate": "Report date",
      "reportDateWarning": {
        "future": "Future date. Ideally, report within one day of the shift.",
        "ideal": "This is the ideal reporting timeframe, within one day of the shift.",
        "late": "Late entry. Ideally, report within one day of the shift."
      },
      "shiftType": "Shift type",
      "shiftStart": "Shift start",
      "shiftEnd": "Shift end",
      "weather": "Weather",
      "temperature": "Temperature",
      "description": "Description",
      "activity": "Activity",
      "activities": "Activities",
      "discipline": "Discipline",
      "location": "Location",
      "quantity": "Quantity",
      "progress": "Progress",
      "units": "Units",
      "comment": "Comment",
      "people": "People",
      "name": "Name",
      "role": "Role",
      "organisation": "Organisation",
      "hours": "Total hours",
      "equipment": "Equipment",
      "equipmentId": "Equipment ID",
      "note": "Note",
      "notes": "Notes",
      "safetyHealthEnvironment": "Safety, Health & Environment",
      "safetyNote": "Safety note",
      "activityDefaultTitle": "No description",
      "downtimeDefaultTitle": "No description",
      "equipmentDefaultTitle": "No description",
      "materialDefaultTitle": "No description",
      "peopleDefaultTitle": "No name",
      "safetyNoteDefaultTitle": "No description",
      "material": "Material",
      "downTime": "Downtime & Delay",
      "issueDescription": "Issue description",
      "timeLost": "Time lost (hrs)",
      "reason": "Reason",
      "linkedIssue": "Linked issue",
      "linkedActivity": "Linked activity",
      "addActivity": "Add activity",
      "allocateTriggerLabel": "Allocate",
      "unlinkToastMessage": "\"{{activityName}}\" was unlinked successfully.",
      "unlinkToastUndo": "Undo",
      "addProgress": "Add progress",
      "newProgressLog": "New progress log",
      "addExistingProgressLogs": "Add existing progress logs",
      "allocateProgress": "Allocate progress",
      "addPerson": "Add person",
      "addDowntime": "Add downtime",
      "allocateDowntime": "Allocate downtime",
      "addEquipment": "Add equipment",
      "addMaterial": "Add material",
      "addSafetyNote": "Add safety note",
      "activityDescription": "Add details about the activity like description, location, progress, unit, planned status, and additional comment.",
      "progressDescription": "At the moment, there are no progress logs on this shift report's date.",
      "noProgressLogsDescription": "Add progress observations from the shift. You can also reference activities from the Activities tab and specify what progress was made on those activities.",
      "downtimeDescription": "Add details about the downtime like issue description, time lost and reason.",
      "peopleDescription": "Add details about the person like name, role, organisation, total hours, and additional comment.",
      "peopleSubDescription": "You can also link activities and downtime to each person.",
      "equipmentDescription": "Add details about the equipment like equipment ID, quantity, and total hours.",
      "equipmentSubDescription": "You can also link activities and downtime to each equipment.",
      "materialDescription": "Add details about the material like description, quantity, and units.",
      "materialSubDescription": "You can also link activities and downtime to each material.",
      "safetyDescription": "Add additional notes specifically for safety, health, and environment.",
      "openRowLinks": "Open row links",
      "closeRowLinks": "Close row links",
      "delete": "Delete",
      "noEntries": "No entries",
      "upload": "Upload",
      "change": "Change",
      "uploadErrorMessage": "The file selected has an unsupported extension or must be greater than 0 bytes and smaller than {{max}} MB",
      "activitiesBadge": "Activities ({{activityLinksNum}})",
      "progressBadge": "Progress ({{activityLinksNum}})",
      "downTimeBadge": "Downtime ({{downTimeLinksNum}})",
      "attachmentsBadge": "Attachments ({{attachmentsNum}})",
      "hoursSubTotal": "Hours",
      "selectLocation": "Select",
      "noLocation": "No location",
      "locationModal": {
        "title": "Select a location",
        "cancelCTA": "Cancel",
        "saveCTA": "Save"
      },
      "all": "All",
      "details": "Details",
      "visibility": {
        "public": "Report is public",
        "private": "Report is private",
        "specific_teams": "Report is visible to specific organisations"
      },
      "progressHint": {
        "title": "What is progress?",
        "subtitle": "Previously the “Activity” section, this is a space for you to add progress observations you have on the shift.<br/>You can now reference activities from the Activities tab and specify what progress was made on those activities.",
        "okCTA": "Okay"
      },
      "unlinkActivityCTA": "Unlink",
      "searchActivityPlaceholder": "Search name, Shape ID, or task ID",
      "searchIssuePlaceholder": "Search an issue",
      "searchIssueSuffix": "issues",
      "issue": "Issue",
      "unlinkIssueCTA": "Unlink",
      "createNewIssueLink": "Create new issue",
      "linkProgress": {
        "removeAllActivities": "Remove all",
        "linkActivities": "Add activities"
      },
      "import": {
        "trigger": {
          "title": "Import"
        },
        "options": {
          "importData": {
            "title": "Import from XLSX",
            "subtitle": "Upload people data using the XLSX template",
            "success": "Shift report data has been imported from XLSX successfully"
          },
          "downloadTemplate": {
            "title": "Download XLSX template",
            "subtitle": "A blank template you can use to upload data"
          }
        },
        "removeAll": {
          "title": "Remove all",
          "success": "All items in section have been removed successfully",
          "deleteSectionConfirmationModal": {
            "title": "Remove all items in section",
            "subtitle": "Are you sure you want to delete all items? This action can't be undone.",
            "deleteCTA": "Delete",
            "cancelCTA": "Cancel"
          }
        }
      },
      "remove": {
        "title": "Remove all"
      },
      "attachLineItems": "Attach",
      "fileSizeError": "The file {{filename}} must be greater than {{min}} bytes and smaller than {{max}} MB",
      "attachments": "Attachments",
      "evidence": "Evidence",
      "resourceSearchField": {
        "placeholder": "Search or create an option",
        "createButton": "Create \"{{term}}\"",
        "noResults": "No matching search results",
        "error": "The current value is not a confirmed resource in Shape. Please click on the value to select or create a new resource."
      }
    },
    "gallery": {
      "emptyPlaceholder": {
        "subtitle": "Shift report documents will appear here as soon as they are uploaded."
      }
    },
    "modal": {
      "overrideTitle": "Override current form",
      "actionMessage": "You are about to copy information from <b>{{reportTitle}}</b> report, including collaborators.",
      "warningMessage": "If you have already filled information in the current report, it will be overridden.",
      "actions": {
        "cancel": "Cancel",
        "override": "Override"
      }
    },
    "progressLogsModal": {
      "title": "Review progress logs",
      "successToast_zero": "{{numberOfProgressLogs}} progress logs have been successfully imported.",
      "successToast_one": "{{numberOfProgressLogs}} progress log has been successfully imported.",
      "successToast_other": "{{numberOfProgressLogs}} progress logs have been successfully imported.",
      "errorToast": "Failed to import selected progress logs.",
      "banner": "Once added, you can still edit the selected progress logs on the shift report without changing the original log.",
      "tooltip": "Please select at least <br/> one progress log to add.",
      "actions": {
        "cancel": "$t(actions.cancel)",
        "addSelected": "Add selected",
        "newProgressLog": "New progress log"
      },
      "progressLog": {
        "createdBy": "Created by",
        "happenedOn": "Happened on",
        "linkedActivity": "Linked activity",
        "percentComplete": "% Complete",
        "percentCompleteAsOf": "{{percentage}}% as of {{date}}",
        "quantity": "Quantity"
      },
      "emptyState": {
        "noProgressLogsFound": "No progress logs found",
        "missingDescription": "Missing description"
      }
    },
    "exportOptionsModal": {
      "title": "Export shift report",
      "contentLabel": "Choose a format:",
      "actions": {
        "cancel": "Cancel",
        "export": "Export"
      }
    },
    "publishModal": {
      "title": "Publish report",
      "subTitle": "Are you sure you want to publish this report? You will not be able to edit it once published.",
      "actions": {
        "cancel": "Cancel",
        "publish": "Publish",
        "publishAndExport": "Publish & export"
      }
    },
    "publishExportSuccess": {
      "title": {
        "export": "Shift report exported",
        "publish": "Shift report published",
        "publishAndExport": "Shift report published and exported"
      },
      "actions": {
        "dismiss": "Dismiss"
      }
    },
    "archiveModal": {
      "title": "Archive report",
      "subTitle": "Are you sure you want to archive this report?",
      "actions": {
        "cancel": "Cancel",
        "archive": "$t(actions.archive)"
      },
      "feedbackMessage": "The report was archived. You can now find it in the “Archived” tab."
    },
    "changeApprovalConfirmation": {
      "title": "Change yourself as the approver",
      "subTitle": "You are about to change the approver of this shift report.",
      "firstPoint": "If you are not a collaborator, you will lose access once removed.",
      "secondPoint": "If you are a collaborator, you’ll still have access to edit fields but will no longer be able to approve and publish the report.",
      "cancel": "Cancel",
      "confirm": "Confirm"
    },
    "notAuthorizedReport": {
      "title": "Not authorized",
      "body": "This shift report is not available to you. This may be because you were unassigned as an approver or a collaborator. Please contact the shift report’s author if there has been a mistake.",
      "goBack": "Go back to shift reports"
    },
    "restoreModal": {
      "title": "Restore report",
      "subTitle": "Are you sure you want to restore this report?",
      "actions": {
        "cancel": "Cancel",
        "restore": "$t(actions.restore)"
      },
      "feedbackMessage": "The report was restored. You can now find it in the “Published” tab."
    },
    "collaboratorsModal": {
      "title": "Collaborators",
      "subTitle": "Add or remove collaborators.",
      "addTitle": "Add collaborators",
      "addSubTitle": "Select people to add as collaborators.",
      "noCollaborators": "No collaborators",
      "actions": {
        "add": "Add",
        "addCollaborators": "Add collaborators",
        "goBack": "Go back"
      }
    },
    "deleteDraftModal": {
      "title": "Delete report",
      "subTitle": "Are you sure you want to delete this report? This action cannot be undone.",
      "actions": {
        "cancel": "Cancel",
        "delete": "$t(actions.delete)"
      },
      "feedbackMessage": "The report was deleted"
    },
    "collaborators": {
      "label": "Collaborators",
      "addCollaborators": "Add collaborators",
      "editCollaborators": "Edit collaborators",
      "edit": "Edit"
    },
    "comments": {
      "empty": {
        "title": "No conversations yet",
        "message": "This space is for you to exchange thoughts and ideas."
      },
      "delete": "Delete shift report comment",
      "fileSizeError": "The file {{filename}} must be greater than {{min}} bytes and smaller than {{max}} MB",
      "input": {
        "hint": {
          "collaborators": "Only collaborators can see this comment.",
          "public": "Everyone can see your message."
        }
      },
      "state": {
        "sending": "Sending...",
        "deleting": "Deleting..."
      }
    },
    "shareModal": {
      "title": "Share shift report",
      "content": "Make sure whoever you shared this shift report with are able to access it. You may need speak to your project's admin to grant them access.",
      "shareLinkTitle": "Shape shift report: {{title}}",
      "shareLinkContent": "Click the link to see this Shape shift report. Title:  {{title}}"
    },
    "unavailableErrorModal": {
      "title": "Report unavailable",
      "subtitle": "The report you are {{action}} is no longer available because it was removed by its owner.",
      "actions": {
        "dismiss": "Dismiss"
      }
    },
    "managerView": {
      "dailyComplianceTitle": "Daily compliance",
      "reportsList": {
        "emptyList": "No published reports for this day"
      },
      "today": "Today",
      "actions": {
        "exportCTA": "Export reports",
        "reportsSelected": "{{count}} reports selected",
        "unselectAll": "Unselect all"
      }
    }
  },
  "table": {
    "cursorPagination": {
      "showing": "Showing",
      "of": "of",
      "results": "results",
      "next": "Next",
      "previous": "Previous",
      "resultsCount": "Showing <span class=\"font-medium\">{{count}}</span> of <span class=\"font-medium\">{{total}}</span> results"
    }
  },
  "galleryPicker": {
    "modal": {
      "title": "Gallery",
      "cancelCTA": "Cancel",
      "addCTA": "Add",
      "selected_zero": "{{COUNT}} file selected",
      "selected_one": "{{COUNT}} file selected",
      "selected_other": "{{COUNT}} files selected"
    }
  },
  "sharePopover": {
    "shareCTA": "Share",
    "copyLinkCTA": "Copy link"
  },
  "progressField": {
    "disabledTooltip": "You can't edit this field"
  },
  "directory": {
    "title": "Directory",
    "toggleLabel": "Toggle directory",
    "noResults": "No results found",
    "closeLabel": "Close directory",
    "collapseLabel": "Collapse directory",
    "expandLabel": "Expand directory",
    "searchPlaceholder": "Search for people or channels",
    "inviteLabel": "Invite people",
    "inviteTooltip": "Add users to your organisation",
    "goToChannels": "Go to Channels",
    "recentChats": "Recent chats",
    "sentAttachment": "Sent an attachment",
    "unreadIndicator": "Unread",
    "viewProfile": "View {{name}}'s profile",
    "profilePopover": {
      "email": "Email",
      "mobile": "Mobile",
      "message": "Message",
      "editRoleAndPermissions": "Edit role and permissions"
    },
    "constructionRoles": {
      "constructionManagement": "Construction management",
      "siteSupervision": "Site supervision",
      "tradesAndLabour": "Trades and labour",
      "logisticsAndSecurity": "Logistics and security",
      "projectManagement": "Project management",
      "commercialContracts": "Commercial contracts",
      "quality": "Quality",
      "design": "Design",
      "safety": "Safety",
      "schedulingPlanning": "Scheduling and planning",
      "environmental": "Environmental",
      "headOfficeOperations": "Head office operations",
      "headOfficeTechnical": "Head office technical"
    },
    "recentChatsEmptyState": {
      "title": "Invite people to join your organisation",
      "body": "Provide their email address and role to help them get started with the team.",
      "addUser": "Add user",
      "hasPeopleTitle": "Send a message",
      "hasPeopleBody": "Recent chats will be found here.",
      "newMessage": "New message"
    },
    "organisationsEmptyState": {
      "title": "Create new organisation",
      "body": "Invite people to collaborate while keeping your data private.",
      "newOrganisation": "New organisation",
      "sectionTitle": "Organisations"
    },
    "errors": {
      "conversationFailed": "Failed to start conversation"
    }
  },
  "onboarding": {
    "pageTitle": "Onboarding",
    "steps": {
      "aboutYou": {
        "title": "Tell us about you",
        "companyName": {
          "label": "Company name",
          "placeholder": "Company name"
        },
        "jobFunction": {
          "label": "Project role",
          "options": {
            "select": "Select",
            "commercialManagement": "Commercial Management",
            "projectManagement": "Project Management",
            "constructionManagement": "Construction Management",
            "operationsManagement": "Operations Management",
            "fieldManagement": "Field Management",
            "executiveLeadership": "Executive Leadership",
            "preconstructionEstimating": "Preconstruction & Estimating",
            "hseCompliance": "HSE & Compliance",
            "qualityQuantityProcurement": "Quality / Quantity / Procurement",
            "bimTechnologyScheduling": "BIM / Technology / Scheduling",
            "design": "Design",
            "socialValueSustainability": "Social Value & Sustainability",
            "administrationSupport": "Administration & Support",
            "consultant": "Consultant",
            "prSalesMarketing": "PR / Sales / Marketing",
            "studentTeacherLecturer": "Student / Teacher / Lecturer",
            "other": "Other"
          }
        },
        "projectType": {
          "label": "Project type",
          "options": {
            "select": "Select",
            "commercial": "Commercial",
            "industrialManufacturing": "Industrial / Manufacturing",
            "dataCentersTechnology": "Data Centers & Technology",
            "pharmaceuticalsLifeSciences": "Pharmaceuticals & Life Sciences",
            "residentialHousing": "Residential / Housing",
            "transportationInfrastructure": "Transportation Infrastructure",
            "waterUtilities": "Water & Utilities",
            "energyPower": "Energy & Power",
            "healthcare": "Healthcare",
            "education": "Education",
            "publicGovernment": "Public & Government",
            "miningNaturalResources": "Mining & Natural Resources",
            "entertainmentSportsCultural": "Entertainment, Sports & Cultural",
            "hospitalityHotelsLeisure": "Hospitality, Hotels & Leisure",
            "other": "Other"
          }
        },
        "hearAboutShape": {
          "label": "How did you hear about Shape?",
          "options": {
            "select": "Select",
            "colleagueFriend": "Colleague/friend",
            "email": "Email",
            "linkedin": "LinkedIn",
            "twitter": "Twitter",
            "youtube": "YouTube",
            "podcast": "Podcast",
            "jobAd": "Job Ad",
            "other": "Other"
          }
        },
        "phoneNumber": {
          "label": "Phone number",
          "placeholder": "Your phone number"
        }
      },
      "objectives": {
        "title": "What is the main problem you're trying to solve?",
        "manageChange": "Better manage change from site",
        "gettingRecords": "Getting records from the site",
        "defendingClaims": "Defending subcontractor claims / contra-change",
        "dailyProgressReports": "Better daily progress reports",
        "recordingDelays": "Recording delays and disruption on site",
        "timeAllocation": "Time and allocation data from site",
        "manageProduction": "Manage production / progress",
        "managingSubcontractors": "Managing subcontractors",
        "progressTracking": "Better progress tracking against the schedule",
        "noneOfTheAbove": "None of the above"
      },
      "joinerObjectives": {
        "title": "Before you join {{projectName}}, what is the main problem you're trying to solve?"
      }
    },
    "finishOnboarding": {
      "title": "You're all set!",
      "subtitle": "Your account is ready. You can now start using Shape to collaborate, manage tasks, and achieve your goals.",
      "areYouInterested": "Are you interested in a demo?",
      "options": {
        "yes": {
          "label": "Yes! Request a demo",
          "description": "Request a demo on our website and a member of the team will contact you."
        },
        "no": {
          "label": "No, I’ll explore Shape on my own for now",
          "description": "You can request a demo later on."
        }
      }
    },
    "welcomeTour": {
      "title": "Welcome to Shape!",
      "ariaLabel": "Welcome tour",
      "iframeTitle": "Welcome tour"
    },
    "skipConfirmationModal": {
      "title": "Skip onboarding",
      "subTitle": {
        "stepByStep": "Onboarding includes a step-by-step guide to help you create your first project. By skipping onboarding, you'll proceed directly with a sample project instead. Are you sure you want to skip?",
        "projectCreation": "You are currently in the project creation step. If you skip now, you will proceed with a sample project instead. Are you sure you want to skip?"
      },
      "actions": {
        "cancel": "Cancel",
        "yes": "Yes"
      }
    },
    "actions": {
      "next": "Next",
      "finish": "Finish",
      "back": "Back",
      "skip": "Skip"
    }
  },
  "productTour": {
    "dismissCTA": "Dismiss",
    "dismissAllCTA": "Dismiss all",
    "tipPulse": "Show tip",
    "forMoreInformation": "For more information, go to",
    "helpCenter": "Help Center",
    "dismissConfirmationModal": {
      "title": "Dismiss product tips?",
      "subTitle": "If you want to go back to product tips, you can click the (?) in the top navigation.",
      "cancelCTA": "Cancel",
      "dismissCTA": "Dismiss"
    },
    "generalPopover": {
      "title": "Product tips",
      "description": "Anytime you want to go back to product tips just click here."
    },
    "alert": {
      "message": "Learn how to use {{productTourName}}",
      "viewTourCTA": "View tour"
    },
    "storylaneModal": {
      "title": "Learn how to use {{productTourName}}",
      "ariaLabel": "{{productTourName}} tour"
    },
    "popover": {
      "title": "Learn how to use Shape",
      "description": "You can access the product tour anytime from the ‘Help & Tips’ page.",
      "gotItCTA": "Got it"
    }
  },
  "placeholders": {
    "constructionRoles": "Select a construction role"
  },
  "controlCenter": {
    "pageTitle": "Change tracker",
    "lockedState": {
      "title": "Change Tracker locked",
      "admin": {
        "subtitle": "No contracts have been created yet.\nContracts are required to track changes and records.\n",
        "whatAreContracts": {
          "title": "What are contracts?",
          "description": "Contracts define relationships between organisations working on a project. All records and changes are tagged to contracts."
        },
        "createFirstContractCTA": "Create your first contract"
      },
      "nonAdmin": {
        "subtitle": "Change Tracker requires contracts to be set up before it can be used.",
        "description": "Please contact your project administrator to set up contracts before using Change Tracker."
      }
    },
    "paywall": {
      "badge": {
        "title": "Upgrade to get this feature"
      },
      "card": {
        "title": "Change tracker",
        "description": "Track every issue, event, and change in real time, automatically building the bulletproof evidence commercial teams need to defend and recover claims.",
        "unlockCTA": "Unlock change tracker",
        "features": {
          "feature1": "Receive instant notifications of all change events",
          "feature2": "Substantiate every change with complete records",
          "feature3": "Capture change evidence automatically"
        }
      }
    },
    "noPermission": {
      "title": "Not available with your role",
      "description": "The Change tracker is visible to office roles only (Owner, Admin, and Commercial contributor).\nYour role in this project doesn't include it. If you think you need it, contact your project admin.",
      "requestAccessCTA": "Request access",
      "requestAccessModal": {
        "title": "Permissions request",
        "fields": {
          "permission": {
            "label": "Permission requested",
            "placeholder": "Select a permission"
          },
          "notify": {
            "label": "Notify",
            "placeholder": "Select an admin",
            "description": "They’ll get an email. Any admin on this project can review your request.",
            "empty": "There are no admins in your organisation to notify."
          },
          "message": {
            "label": "Message",
            "description": "Add a message to let the admin know why you need this permission."
          }
        },
        "cancelCTA": "Cancel",
        "requestCTA": "Send request",
        "successToast": {
          "title": "Permission request sent",
          "description": "{{recipientName}} has been notified. Any admin on this project can review your request."
        }
      },
      "goToProject": "Go to {{projectName}}"
    },
    "contractSelector": {
      "label": "Contract",
      "searchPlaceholder": "Search contracts...",
      "newContractCTA": "New contract",
      "myContracts": "My contracts",
      "otherContracts": "Other contracts",
      "noOptions": "No options available"
    },
    "commercialTracker": {
      "title": "Commercial tracker",
      "totalEntries": "Total entries",
      "showAlertsOnly": "Show alerts only",
      "newPotentialChange": "New change",
      "noPotentialChanges": "No potential changes",
      "inaccessibleRecord": "You don't have permission to view this record",
      "emptyStatePotentialChangesSelectionMode": {
        "title": "No changes yet",
        "subtitle": "Create a change to link them to change signals."
      },
      "emptyStatePotentialChanges": {
        "title": "Track what changed and why",
        "subtitle": "The change tracker helps you identify and monitor changes in your project by grouping all related events, known as Change signals.",
        "browseSignalsCTA": "Browse signals",
        "newChangeCTA": "New change",
        "step1": {
          "title": "Browse signals",
          "description": "Explore existing change signals in your project, such as issues or downtime records."
        },
        "step2": {
          "title": "Identify changes",
          "description": "Create a new entry in the change tracker table to begin monitoring updates."
        },
        "step3": {
          "title": "Link and track",
          "description": "Group related change signals into a new or existing change to maintain clear traceability."
        },
        "learnMoreInTheHelpCenter": "Learn more in the Help Center"
      },
      "select": "Select...",
      "fields": {
        "selectPotentialChange": "Select potential change",
        "title": "Title",
        "contract": "Contract",
        "author": "Author",
        "createdAt": "Created at",
        "priority": "Priority",
        "category": "Responsible",
        "status": "Status",
        "linkedSignals": "Linked signals",
        "estimatedCostImpact": "Estimated cost impact",
        "cost": "Cost",
        "estimatedScheduleImpact": "Estimated schedule impact",
        "workingDaysOfDelay": "Working days of delay",
        "formallyNotifiedDate": "Formally notified date",
        "notes": "Internal notes",
        "notesPlaceholder": "Add notes...",
        "archive": "Archive",
        "actions": "Actions",
        "date": "Date",
        "impact": "Impact",
        "shiftType": "Shift type",
        "timeLostInHrs": "Time lost (hrs)",
        "reason": "Reason",
        "linkedIssue": "Linked issue",
        "viewIssue": "View issue",
        "description": "Description",
        "discipline": "Discipline",
        "location": "Location",
        "observedAt": "Observed at",
        "dueDate": "Due date",
        "plannedClosureDate": "Planned closure date",
        "closedAt": "Closed at",
        "delayStart": "Delay start",
        "delayFinish": "Delay finish",
        "quality": "Quality",
        "activityType": "Activity type",
        "reference": "Reference",
        "linkedActivity": "Linked activity",
        "quantity": "Quantity",
        "units": "Units"
      },
      "events": {
        "create": "{{ownerName}} created the change",
        "archive": "{{ownerName}} archived the change",
        "link_change_signals": {
          "message_1": "{{ownerName}} linked {{signalA}}",
          "message_2": "{{ownerName}} linked {{signalA}} and {{signalB}}",
          "message": "{{ownerName}} linked {{signalA}}, {{signalB}} and {{signalC}}",
          "issue_zero": "the issues {{titles}}",
          "issue_one": "the issue {{titles}}",
          "issue_other": "the issues {{titles}}",
          "downtime_zero": "the downtimes {{titles}}",
          "downtime_one": "the downtime {{titles}}",
          "downtime_other": "the downtimes {{titles}}",
          "progress_log_zero": "the progress logs {{titles}}",
          "progress_log_one": "the progress log {{titles}}",
          "progress_log_other": "the progress logs {{titles}}"
        },
        "unlink_change_signals": {
          "message_1": "{{ownerName}} unlinked {{signalA}}",
          "message_2": "{{ownerName}} unlinked {{signalA}} and {{signalB}}",
          "message": "{{ownerName}} unlinked {{signalA}}, {{signalB}} and {{signalC}}",
          "issue_zero": "the issues {{titles}}",
          "issue_one": "the issue {{titles}}",
          "issue_other": "the issues {{titles}}",
          "downtime_zero": "the downtimes {{titles}}",
          "downtime_one": "the downtime {{titles}}",
          "downtime_other": "the downtimes {{titles}}",
          "progress_log_zero": "the progress logs {{titles}}",
          "progress_log_one": "the progress log {{titles}}",
          "progress_log_other": "the progress logs {{titles}}"
        },
        "update": {
          "field": "{{updateField}} to {{value}}",
          "change_field": "{{updateField}} from {{from}} to {{to}}",
          "clear_field": "{{updateField}} from {{from}}",
          "update_field": "{{updateField}} to {{value}}",
          "message_update_field": "{{ownerName}} set the {{parametersArray, list}}",
          "message_change_field": "{{ownerName}} changed the {{parametersArray, list}}",
          "message_clear_field": "{{ownerName}} cleared {{parametersArray, list}}",
          "message": "{{ownerName}} updated {{parametersArray, list}}"
        },
        "empty": {
          "title": "No activities yet",
          "message": "There are no activities linked to this change."
        }
      },
      "loading": "Loading",
      "viewDetails": "View details",
      "options": {
        "priority": {
          "high": "High",
          "medium": "Medium",
          "low": "Low"
        },
        "category": {
          "clientIssues": "Client",
          "internal": "Internal",
          "undefined": "Undefined",
          "supplier": "Supplier",
          "group": {
            "organisations": "Organisations"
          }
        },
        "status": {
          "clientClarificationRequested": "Requires our response",
          "underInternalReview": "Internal review",
          "awaitingClientReview": "Awaiting response",
          "underPreparation": "Preparation",
          "rejectedByClient": "Rejected",
          "submitted": "Submitted",
          "unprocessed": "Unprocessed",
          "approvedByClient": "Approved",
          "canceled": "Canceled",
          "instructionAndImplementation": "Instruction & implementation"
        },
        "impact": {
          "minor": "Minor",
          "moderate": "Moderate",
          "major": "Major"
        }
      },
      "modals": {
        "archive": {
          "title": "Archive potential change",
          "subtitle": "Are you sure you want to archive this potential change?",
          "cancelCTA": "$t(actions.cancel)",
          "archiveCTA": "$t(actions.archive)"
        },
        "cancelLinkPotentialChanges": {
          "title": "Cancel link to potential changes",
          "subtitle": "Are you sure you want to cancel the link to potential changes?",
          "cancelProcessCTA": "Cancel process",
          "backToSignalsCTA": "Back to signals"
        },
        "unlink": {
          "title": "Unlink change signal",
          "subtitle": "Are you sure you want to unlink this change signal?",
          "cancelCTA": "$t(actions.cancel)",
          "unlinkCTA": "$t(actions.unlink)"
        },
        "potentialChangeLinkSignalsDrawer": {
          "title": "Linked change signals",
          "cancelCTA": "$t(actions.cancel)",
          "archiveCTA": "$t(actions.archive)",
          "linkSignals": "Link signals",
          "unlink": "Unlink",
          "previous": "Previous change",
          "next": "Next change",
          "emptyState": {
            "hasNoLinkedChangeSignals": "<b>\"{{title}}\"</b> has no linked change signals.",
            "title": "No change signals linked",
            "subtitle": "Add change signals to help better document this potential change.",
            "noLinks": "<b>\"{{title}}\"</b> has 0 linked change signals."
          },
          "changeSignalsList": {
            "issue": "Issue",
            "downtime": "Downtime",
            "progressLog": "Progress log",
            "changeSignals": "Change signals",
            "linksFor": "Links for <b>\"{{title}}\"</b>"
          },
          "tabs": {
            "details": "Details",
            "updatesAndComments": "Updates",
            "scheduleImpact": "Schedule impact",
            "documents": {
              "title": "Gallery",
              "emptyPlaceholder": {
                "title": "Gallery is empty",
                "subtitle": "Change documents will appear here when uploaded, linked from<br /> the project gallery, or through linked records."
              }
            }
          }
        },
        "exportChange": {
          "title": "Export change to PDF",
          "subtitle": "Choose which version of the report you’d like to export:",
          "options": {
            "internal": {
              "label": "Internal version",
              "description": "Includes all details, with fields like priority, status, cost, and schedule impact."
            },
            "external": {
              "label": "External version",
              "description": "Hides internal fields and exports only client-facing information."
            }
          },
          "cancelCTA": "$t(actions.cancel)",
          "exportCTA": "$t(actions.export)"
        }
      },
      "alerts": {
        "archiveSuccess": "The potential change was successfully archived",
        "archiveFailed": "Failed to archive the potential change",
        "fieldUpdateSuccess": "Field updated successfully",
        "fieldUpdateFailed": "Failed to update the field",
        "potentialChangeCreationFailed": "Failed to create a potential change",
        "potentialChangeCreationSuccess": "Potential change created successfully"
      },
      "linkSignals": "Link signals...",
      "selectionMode": {
        "message": "Select one or more changes below to link to the selected signals.",
        "newChangeCTA": "New change",
        "linkSelectedCTA": "Link selected",
        "cancelCTA": "$t(actions.cancel)"
      },
      "contractNoticeAlerts": {
        "signalAlertOverdue": "Linked signal with overdue alert.",
        "signalAlertApproaching": "Linked signal with alert due in {{days}} days."
      }
    },
    "records": {
      "title": "Records",
      "emptyState": {
        "title": "No records found",
        "body": "There are no records to display. Try adjusting your filters."
      },
      "types": {
        "issues": "Issues",
        "downtime": "Downtime",
        "progressLogs": "Progress logs"
      },
      "fields": {
        "title": "Title",
        "signaled": "Date created",
        "alertDate": "Due date",
        "author": "Author",
        "location": "Location",
        "quality": "Quality",
        "type": "Type",
        "status": "Status",
        "impact": "Impact",
        "contract": "Contract",
        "contracts": "Contracts",
        "showAllContracts": "Show all contracts"
      },
      "addContract": {
        "trigger": "Add",
        "searchPlaceholder": "Search contracts...",
        "empty": "No contracts available",
        "emptySearch": "No contracts found",
        "cancel": "$t(actions.cancel)",
        "add": "Add",
        "successMessage": "Contract added to record"
      },
      "detailsPanel": {
        "issue": "Issue",
        "downtime": "Downtime",
        "linkToRecord": "Link to record",
        "closeLabel": "Close details panel",
        "attachedFiles": "Attached files"
      },
      "issueDetails": {
        "description": "Description",
        "discipline": "Discipline",
        "observedAt": "Observed at",
        "plannedClosureDate": "Planned closure date",
        "closedAt": "Closed at",
        "delayStart": "Delay start",
        "delayFinish": "Delay finish"
      },
      "downtimeDetails": {
        "author": "Author",
        "created": "Created",
        "shiftType": "Shift type",
        "timeLost": "Time lost (hrs)",
        "reason": "Reason",
        "shiftReport": "Shift report",
        "linkedIssue": "Linked issue",
        "linkedActivity": "Linked activity",
        "viewShiftReportLink": "View shift report",
        "viewIssueLink": "View issue",
        "viewActivityLink": "View activity"
      },
      "progressLogFields": {
        "activity": "Activity",
        "activityType": "Activity type",
        "workType": "Work type",
        "quantity": "Quantity",
        "units": "Units",
        "date": "Date",
        "author": "Author",
        "location": "Location",
        "linkedActivity": "Linked activity",
        "viewActivityLink": "View activity"
      },
      "progressLogDetails": {
        "created": "Created",
        "description": "Description",
        "activityType": "Activity type",
        "workType": "Work type",
        "linkedActivity": "Linked activity",
        "quantity": "Quantity",
        "units": "Units",
        "comment": "Comment",
        "viewActivityLink": "View activity"
      },
      "statuses": {
        "label": "Status",
        "unprocessed": "Unprocessed",
        "linked": "Linked",
        "reviewed": "Reviewed",
        "all": "All"
      },
      "filters": {
        "label": "Filters",
        "allContracts": "All contracts"
      },
      "toolbarActions": {
        "selectionCount": "{{count}} selected",
        "clearSelection": "Clear selection",
        "dismiss": "Dismiss",
        "link": "Link to change",
        "linkToNew": "Link to new change",
        "previous": "Previous record",
        "next": "Next record"
      },
      "contractNoticeAlerts": {
        "signalAlertOverdue": "This record alert is overdue",
        "signalAlertApproaching": "This record alert is due in {{days}} days"
      },
      "linkChangesModal": {
        "title": "Changes",
        "cancelCTA": "$t(actions.cancel)",
        "linkCTA": "Link to selected"
      },
      "linkToNewModal": {
        "title": "Link to new change",
        "inputLabel": "Title",
        "inputPlaceholder": "Enter title",
        "inputHelpText": "Name your new change. It will appear in the Changes tab, and you can edit the details later.",
        "cancelCTA": "$t(actions.cancel)",
        "linkCTA": "Create and link"
      },
      "linkStatus": {
        "linking": {
          "success$recordCount_zero": "Reports",
          "success$recordCount_one": "Report",
          "success$recordCount_other": "Reports",
          "success$changeCount_zero": "changes.",
          "success$changeCount_one": "change.",
          "success$changeCount_other": "changes.",
          "success": "$t(controlCenter.records.linkStatus.linking.success$recordCount, {\"count\": {{recordCount}} }) linked to the $t(controlCenter.records.linkStatus.linking.success$changeCount, {\"count\": {{changeCount}} })",
          "failed": "Failed to link change records",
          "withContract": {
            "singleRecord_zero": "{{recordTitle}} was linked to Changes under {{contractTitle}} contract",
            "singleRecord_one": "{{recordTitle}} was linked to Change under {{contractTitle}} contract",
            "singleRecord_other": "{{recordTitle}} was linked to Changes under {{contractTitle}} contract",
            "multiRecord_zero": "{{recordCount}} records were linked to Changes under {{contractTitle}} contract",
            "multiRecord_one": "{{recordCount}} records were linked to Change under {{contractTitle}} contract",
            "multiRecord_other": "{{recordCount}} records were linked to Changes under {{contractTitle}} contract"
          }
        },
        "linkingToNew": {
          "success_zero": "New change created and linked to the selected records.",
          "success_one": "New change created and linked to the selected record.",
          "success_other": "New change created and linked to the selected records.",
          "failed": "Failed to link record to new change",
          "withContract": {
            "singleRecord": "{{recordTitle}} was linked to Change under {{contractTitle}} contract",
            "multiRecord": "{{recordCount}} records were linked to Change under {{contractTitle}} contract"
          }
        },
        "unlinking": {
          "success": "Change record unlinked successfully",
          "failed": "Failed to unlink change records"
        }
      },
      "dismiss": {
        "success_zero": "Change records dismissed",
        "success_one": "Change record dismissed",
        "success_other": "Change records dismissed",
        "failed": "Failed to dismiss change records"
      },
      "search": {
        "failed": "Something went wrong while fetching the data. Please try again."
      },
      "progressLog": {
        "problemQuestion": "Was there a problem?",
        "instructedQuestion": "Out of contract works?",
        "answers": {
          "yes": "Yes",
          "no": "No"
        }
      }
    },
    "changes": {
      "title": "Changes",
      "fields": {
        "linkedRecords": "Linked records"
      },
      "table": {
        "linkRecords": "Link records...",
        "select": "Select...",
        "actions": {
          "view": "View",
          "export": "Export",
          "archive": "Archive",
          "more": "More actions"
        }
      },
      "detailsDrawer": {
        "title": "Linked change records",
        "cancelCTA": "$t(actions.cancel)",
        "archiveCTA": "$t(actions.archive)",
        "exportCTA": "$t(actions.export)",
        "previousCTA": "Previous change",
        "nextCTA": "Next change",
        "linkedRecords": "Linked records",
        "changeRecords": "Change records",
        "linkRecordsCTA": "Link records",
        "tabs": {
          "details": "Details",
          "updatesAndComments": "Updates",
          "scheduleImpact": "Schedule impact"
        },
        "emptyState": {
          "title": "No linked records",
          "subtitle": "Link records to help document and track this change more effectively."
        },
        "unlinkModal": {
          "title": "Unlink change record",
          "subtitle": "Are you sure you want to unlink this change record?",
          "cancelCTA": "$t(actions.cancel)",
          "unlinkCTA": "$t(actions.unlink)"
        }
      },
      "linkRecordsModal": {
        "title": "Records",
        "cancelCTA": "$t(actions.cancel)",
        "linkCTA": "Link to selected",
        "search": {
          "failed": "Something went wrong while fetching the data. Please try again."
        }
      },
      "scheduleImpact": {
        "addRowCTA": "Add row",
        "addRowSuccessToast": "Row added",
        "reconcile": {
          "updateCTA": "Update",
          "updateAvailableToast": {
            "message": "This change has been updated since you last viewed this timeline. Would you like to reflect the latest changes? Everything you have set up will be kept.",
            "updateCTA": "Update",
            "dismissCTA": "Dismiss"
          },
          "modal": {
            "title": "Are you sure?",
            "body": "New records will be added and removed records will be taken out. Everything else will stay as you left it.",
            "cancelCTA": "$t(actions.cancel)",
            "confirmCTA": "Confirm"
          },
          "successToast": "Updated"
        },
        "listPanel": {
          "title": "Activity details",
          "critical": "Critical",
          "searchActivityPlaceholder": "Search name, Shape ID or task ID",
          "deleteRowModal": {
            "title": "Delete row",
            "description": "Are you sure you want to delete this row? This action cannot be undone.",
            "deleteCTA": "$t(actions.delete)",
            "cancelCTA": "$t(actions.cancel)",
            "deleteSuccessToast": "The row was deleted"
          },
          "table": {
            "headers": {
              "name": "Name",
              "records": "Records",
              "location": "Location"
            }
          },
          "recordsPopover": {
            "title": "Records",
            "subtitle": "Select records to show on the timeline"
          }
        },
        "emptyState": {
          "title": "No records",
          "body": "Link records to this change to see the schedule impact.",
          "linkRecordsCTA": "Link records",
          "addRowCTA": "Add row"
        },
        "pagination": {
          "activitiesCount": "Showing <span class=\"font-semibold\">{{count}}</span> of <span class=\"font-semibold\">{{total}}</span> activities"
        }
      },
      "narrative": {
        "tabLabel": "Narrative",
        "emptyState": "No narrative yet.",
        "emptyStateHint": "Generate drafts a narrative from this change's linked records and activities. You can review and edit it before saving.",
        "status": {
          "generating": "Generating narrative...",
          "ready": "Narrative ready.",
          "failed": "Narrative generation failed.",
          "cancelled": "Narrative generation stopped."
        },
        "generateCTA": "Generate",
        "regenerateCTA": "Regenerate",
        "generatingCTA": "Generating...",
        "cancelCTA": "Stop",
        "saveCTA": "Save",
        "editCTA": "Edit",
        "generatedIn": "Generated in {{seconds}}s",
        "stoppedHint": "Stopped — the narrative generated so far is kept below.",
        "aiDisclosure": "This is an AI assistant's response and may contain mistakes. Verify important information before relying on it.",
        "previousVersion": {
          "label": "Previous version",
          "restoreCTA": "Restore previous version"
        },
        "guidance": {
          "toggleCTA": "Add instructions",
          "label": "Instructions for the AI",
          "placeholder": "e.g. Focus on the cost impact and the piling delay."
        },
        "editor": {
          "label": "Narrative draft",
          "placeholder": "Write a narrative or press Generate to draft one."
        },
        "errorState": {
          "title": "Couldn't generate the narrative.",
          "tryAgainCTA": "Try again",
          "kind": {
            "start": "The generation could not be started. Check your connection and try again.",
            "poll": "The connection was lost while generating.",
            "timeout": "The generation took too long and was stopped.",
            "run": "Something went wrong while generating."
          }
        },
        "replaceDraftModal": {
          "title": "Replace unsaved draft?",
          "body": "Regenerating will discard your current unsaved draft.",
          "cancelCTA": "Keep draft",
          "confirmCTA": "Replace and regenerate"
        },
        "unsavedChangesModal": {
          "title": "Discard unsaved narrative changes?",
          "body": "Leaving now will discard your unsaved draft. The saved narrative is unchanged.",
          "cancelCTA": "Keep editing",
          "confirmCTA": "Discard changes"
        },
        "activity": {
          "title": "Activity",
          "expand": "Show activity",
          "collapse": "Hide activity",
          "reasoningLabel": "Reasoning",
          "pending": "Generating narrative...",
          "reasoning": {
            "inProgress": "Reasoning... {{seconds}}s",
            "completed": "Reasoned for {{seconds}}s"
          },
          "headline": {
            "starting": "Starting the agent...",
            "reasoning": "Thinking it through...",
            "working": "Pulling the details together...",
            "drafting": "Writing the narrative..."
          },
          "tool": {
            "get": "Reading the {{subject}}...",
            "getDone": "Read the {{subject}}",
            "list": "Gathering {{subject}}...",
            "listDone": "Gathered {{subject}}",
            "search": "Searching {{subject}}...",
            "searchDone": "Searched {{subject}}",
            "generic": "Running {{subject}}...",
            "genericDone": "Finished {{subject}}",
            "failed": "Could not finish {{subject}}",
            "subject": {
              "change": "change",
              "changes": "changes",
              "changeRecord": "change record",
              "changeRecords": "change records",
              "changeActivity": "change activity"
            }
          },
          "toolCall": {
            "status": {
              "running": "Running",
              "succeeded": "Succeeded",
              "failed": "Failed",
              "interrupted": "Interrupted"
            },
            "moreRecords": "+{{count}} more"
          }
        },
        "citation": {
          "tooltip": "Open linked record",
          "brokenRef": "Linked record unavailable",
          "marker": {
            "ariaLabel": "Source {{index}}",
            "noRecords": "No record details available",
            "documents_zero": "{{count}} attachments",
            "documents_one": "{{count}} attachment",
            "documents_other": "{{count}} attachments"
          },
          "kind": {
            "project": "Project",
            "issue": "Issue",
            "shiftReport": "Shift report",
            "shiftActivity": "Shift activity",
            "progressLog": "Progress log",
            "weeklyWorkPlan": "Weekly work plan",
            "document": "Document",
            "location": "Location",
            "discipline": "Discipline",
            "contract": "Contract",
            "potentialChange": "Change",
            "changeSignal": "Linked record",
            "user": "User",
            "team": "Team",
            "generic": "Reference"
          }
        }
      }
    },
    "changeSignals": {
      "title": "Change signals",
      "subtitle": "Select signals to link with project changes or skip.",
      "fields": {
        "title": "Title",
        "signaled": "Signaled",
        "alertDate": "Alert date",
        "author": "Author",
        "location": "Location",
        "quality": "Quality"
      },
      "contractNoticeAlerts": {
        "signalAlertOverdue": "This signal alert is overdue",
        "signalAlertApproaching": "This signal alert is due in {{days}} days"
      },
      "emptySelectedState": {
        "title": "No signals selected",
        "subtitle": "Selected change signals below"
      },
      "actions": {
        "clearSelection": "Clear selection",
        "showSelectedToggle": "Show selected only",
        "link": "Link to change(s)",
        "markAsReviewed": "Mark as reviewed",
        "removeSelection": "Remove selection",
        "flagChange": "Flag change",
        "close": "Close"
      },
      "selectionCount": "{{count}} selected",
      "linkStatus": {
        "linking": {
          "success": "Change signals linked successfully",
          "failed": "Failed to link change signals"
        },
        "unlinking": {
          "success": "Change signals unlinked successfully",
          "failed": "Failed to unlink change signals"
        }
      },
      "filters": {
        "label": "People",
        "search": {
          "placeholder": "Search"
        }
      },
      "markAsReviewed": {
        "success": "Change signals marked as reviewed",
        "failed": "Failed to mark change signals as reviewed"
      },
      "selectChangeSignals": "Select change signals",
      "selectedChangeSignals": "Selected change signals",
      "linkToPotentialChanges": "Link to potential changes",
      "types": {
        "issues": "Issues",
        "downtime": "Downtime"
      },
      "statuses": {
        "label": "Show",
        "unprocessed": "Unprocessed",
        "linked": "Linked",
        "reviewed": "Reviewed",
        "all": "All"
      },
      "toasts": {
        "failed": "Something went wrong while fetching the data. Please try again."
      }
    }
  },
  "pushNotifications": {
    "addedToProject": {
      "title": "{{actorFirstName}} has added you to a project.",
      "body": "You've been added to the project {{projectTitle}}. Click here to view the project and start collaborating."
    },
    "youWereAssignedToIssue": {
      "title": "{{actorFirstName}} has assigned an issue to you. Click to respond!"
    },
    "yourIssueAssignmentWasAccepted": {
      "title": "{{actorFirstName}} accepted your issue!"
    },
    "yourIssueAssignmentWasRejected": {
      "title": "{{actorFirstName}} rejected an issue you assigned. Re-assign it!"
    },
    "yourIssueWasReassigned": {
      "title": "{{actorFirstName}} re-assigned an issue you created. Take a look!"
    },
    "newIssueComment": {
      "title": "{{actorFirstName}} left a comment. Take a look!",
      "body": "Issue: {{issueTitle}}"
    },
    "newIssuePrivateComment": {
      "title": "{{actorFirstName}} left a private comment. Take a look!",
      "body": "Issue: {{issueTitle}}"
    },
    "newIssueStatusStatement": {
      "title": "{{actorFirstName}} added a status statement. Take a look!",
      "body": "Issue: {{issueTitle}}"
    },
    "newShiftReportComment": {
      "title": "{{actorFirstName}} left a comment. Take a look!",
      "body": "Shift Report: {{shiftReportTitle}}"
    },
    "issueCommentMention": {
      "title": "{{actorFirstName}} mentioned you. Take a look!"
    },
    "shiftReportCommentMention": {
      "title": "{{actorFirstName}} mentioned you. Take a look!",
      "body": "Shift Report: {{shiftReportTitle}}"
    },
    "issueNeedsYourApproval": {
      "title": "An issue is waiting for your approval. Review it!"
    },
    "yourIssueApprovalRequestWasRejected": {
      "title": "{{actorFirstName}} rejected your approval request. Take a look!",
      "body": "Issue: {{issueTitle}}",
      "bodyExtra": "Reason: {{reason}}"
    },
    "yourIssueApprovalRequestWasAccepted": {
      "title_undefined": "{{actorFirstName}} approved the issue. Take a look!",
      "title": "{{actorFirstName}} (Approver {{progress}}) approved the issue. Take a look!"
    },
    "issueWasResolved": {
      "title": "Issue resolved! {{actorFirstName}}{{approverProgress}} approved the issue."
    },
    "issueWasReopened": {
      "title": "{{actorFirstName}} reopened the issue. Take a look!"
    },
    "newProjectAccessRequest": {
      "title": "{{actorFirstName}} has requested access to the project."
    },
    "newRoleUpgradeRequest": {
      "title": "{{actorFirstName}} has requested a permission upgrade."
    }
  },
  "shape-channels": {
    "issue": {
      "events": {
        "default": "An event has been issued",
        "accept_assignment": "{{ownerName}} has accepted the assignment of this issue",
        "add_approver_zero": "{{approvers, list}} have been added as approvers",
        "add_approver_one": "{{approvers}} has been added as an approver",
        "add_approver_other": "{{approvers, list}} have been added as approvers",
        "add_team_zero": "{{teams, list}} now have access to this issue",
        "add_team_one": "{{teams}} now has access to this issue",
        "add_team_other": "{{teams, list}} now have access to this issue",
        "add_watcher_zero": "{{ownerName}} added {{watchers, list}} as watchers",
        "add_watcher_one": "{{ownerName}} added {{watchers, list}} as a watcher",
        "add_watcher_other": "{{ownerName}} added {{watchers, list}} as watchers",
        "add_watcher_self": "{{ownerName}} joined this issue as a watcher",
        "approve": "{{ownerName}} has approved the issue",
        "archive": "This issue has been archived by {{ownerName}}",
        "assign": "{{ownerName}} has assigned this issue to {{recipientName}}",
        "change_status": "{{ownerName}} changed the status of this issue to {{to}}",
        "create": "This issue has been created by {{ownerName}}",
        "delete_document": "{{ownerName}} deleted a document",
        "delete_image": "{{ownerName}} deleted an image",
        "delete_status_statement": "{{ownerName}} deleted a status statement",
        "link_activity_one": "{{ownerName}} linked the activity {{activities, list}} to this issue",
        "link_activity_other": "{{ownerName}} linked the activities {{activities, list}} to this issue",
        "reject_assignment": "{{ownerName}} rejected the assignment of this issue",
        "reject_resolution": "{{ownerName}} rejected the approval request",
        "remove_approver_zero": "{{approvers, list}} were removed as approvers",
        "remove_approver_one": "{{approvers}} was removed as an approver",
        "remove_approver_other": "{{approvers, list}} were removed as approvers",
        "remove_team_zero": "{{teams, list}} no longer have access to this issue",
        "remove_team_one": "{{teams}} no longer has access to this issue",
        "remove_team_other": "{{teams, list}} no longer have access to this issue",
        "remove_watcher_zero": "{{ownerName}} removed {{watchers, list}} as watchers",
        "remove_watcher_one": "{{ownerName}} removed {{watchers, list}} as a watcher",
        "remove_watcher_other": "{{ownerName}} removed {{watchers, list}} as watchers",
        "remove_watcher_self": "{{ownerName}} stopped watching this issue",
        "reopen": "{{ownerName}} reopened this issue",
        "restore": "{{ownerName}} restored this issue",
        "unlink_activity_one": "{{ownerName}} unlinked the activity {{activities, list}} from this issue",
        "unlink_activity_other": "{{ownerName}} unlinked the activities {{activities, list}} from this issue",
        "update": {
          "message": "{{ownerName}} updated the following details of this issue: {{updatedFields, list}}",
          "change_field": "{{updateField}} from {{from}} to {{to}}",
          "clear_field": "{{updateField}} cleared",
          "update_field": "{{updateField}} to {{value}}"
        },
        "update_impact": {
          "message": "{{ownerName}} changed the impact of this issue: {{updatedFields, list}}",
          "field_impact": "Impact",
          "field_due_date": "Due date",
          "field_delay_start": "Delay start date",
          "field_delay_finish": "Delay finish date",
          "field_work_affected": "Work affected",
          "change_field": "{{updateField}} from {{from}} to {{to}}",
          "clear_field": "{{updateField}} cleared from {{from}}",
          "update_field": "{{updateField}} to {{value}}"
        },
        "update_observer": {
          "type": "Observer",
          "message": "{{ownerName}} changed the {{observer}} to {{updatedObserverName}}"
        },
        "upload_document": {
          "message": "{{ownerName}} uploaded a document.",
          "tap_to_view": "Tap to view."
        },
        "upload_image": {
          "message": "{{ownerName}} uploaded an image.",
          "tap_to_view": "Tap to view."
        },
        "update_status_statement": "{{ownerName}} updated the latest status statement: {{statusStatement}}"
      }
    }
  },
  "files": {
    "download": {
      "loading": {
        "title": "Preparing your download...",
        "subtitle": "Please wait while we prepare your file...",
        "projectLabel": "Project: ",
        "fileIdLabel": "File ID: "
      },
      "notFound": {
        "title": "File not found",
        "subtitle": "We couldn't find the file you're looking for.",
        "possibleReasonsTitle": "Possible reasons",
        "reasons": {
          "deleted": "The file was deleted after this link was generated.",
          "incorrectUrl": "The URL was copied or typed incorrectly."
        }
      },
      "error": {
        "title": "Something went wrong",
        "subtitle": "We encountered an error while preparing your download.",
        "message": "Please try again or contact support if the problem persists.",
        "tryAgainButton": "Try again"
      },
      "success": {
        "title": "File ready",
        "subtitle": "Your file is ready to download.",
        "downloadButton": "Download file"
      },
      "support": "Need help? Contact Shape support."
    }
  },
  "ganttView": {
    "timelinePanel": "Timeline panel",
    "todayIndicator": "Today",
    "showPlannedDates": "Show planned dates",
    "dateRangePicker": {
      "label": "Select date range",
      "minimumTwoWeeks": "Min. of 2 weeks",
      "applyCTA": "Apply",
      "resetCTA": "Reset"
    },
    "filters": {
      "location": {
        "label": "Location",
        "title": "Locations",
        "placeholder": "Search locations",
        "noLocation": "No location"
      }
    },
    "dailyLog": {
      "future": "Future",
      "progress": "Progress",
      "loading": "Loading...",
      "plannedStart": "Planned start",
      "plannedFinish": "Planned finish",
      "actualStart": "Actual start",
      "actualFinish": "Actual finish",
      "expectedFinish": "Expected finish",
      "downtime": "Downtime",
      "timeLost": "{{hours}}h",
      "issuesCount": "Issues ({{count}})",
      "statusLabel": "Status: {{status}}",
      "impactLabel": "Impact:",
      "impact": {
        "liveDelay": "Live delay",
        "potentialDelay": "Potential delay",
        "noImpact": "-"
      },
      "empty": "N/A",
      "noDescription": "No description",
      "outOfFilter": "Out of the selected date range"
    },
    "legend": {
      "title": "Legends",
      "dailyLogs": "Daily logs",
      "progress": "Progress",
      "future": "Future",
      "periodBars": "Period bars",
      "plannedStartCritical": "Planned start (Critical)",
      "plannedStart": "Planned start",
      "actualStart": "Actual start",
      "plannedFinishCritical": "Planned finish (Critical)",
      "plannedFinish": "Planned finish",
      "actualFinish": "Actual finish",
      "expectedFinish": "Expected finish",
      "problemIndicators": "Problem indicators",
      "liveDelay": "Live delay",
      "potentialDelay": "Potential delay",
      "otherIssue": "Other issue",
      "downtime": "Downtime",
      "varianceTones": "Variance tones",
      "onTarget": "On target or early",
      "behindTarget": "Behind target"
    }
  },
  "commercialAssistant": {
    "title": "Shape AI",
    "trigger": "Ask Shape AI",
    "new": "New",
    "close": "Close",
    "disclaimer": "This is an AI assistant's response and may contain mistakes. Verify important information before relying on it.",
    "inputPlaceholder": "Ask me about anything…",
    "send": "Send",
    "stop": "Stop",
    "thinking": "Thinking…",
    "result": "Result",
    "errorGeneric": "Something went wrong generating a reply. Please try again.",
    "stoppedHint": "You stopped this reply. What was generated is kept above.",
    "newConversation": {
      "title": "Start a new conversation?",
      "body": "Your current conversation and its answers will be deleted.",
      "cancel": "Cancel",
      "confirm": "Start new"
    },
    "upgrade": {
      "intro": "Ask questions in plain language and get evidence-backed answers built from your site diaries, issues, logs, and change records - ready to use before your next client meeting.",
      "bullets": {
        "meetings": "Prep for commercial meetings with cited weak points and counter-arguments",
        "records": "Find every record on a topic in seconds, with links to the source",
        "audit": "Audit any change for missing evidence before you submit it"
      },
      "unlock": "Unlock Shape AI",
      "talkToUs": "Talk to us",
      "preview": {
        "lookForRecords": "Look for records about a specific topic",
        "auditChange": "Audit a change and check what is missing"
      }
    },
    "toolActivity": {
      "searching": "Searching",
      "reading": "Reading",
      "fetching": "Fetching",
      "lookingUp": "Looking up",
      "working": "Working"
    },
    "thoughtProcess": {
      "drafting": "Drafting your answer…",
      "done": "Thought process",
      "doneWithSeconds_one": "Thought process for {{count}} second",
      "doneWithSeconds_other": "Thought process for {{count}} seconds",
      "moreCount": "+{{count}} more",
      "issueRef": "Issue {{code}}",
      "cancel": "Cancel",
      "expand": "Show the assistant's steps",
      "collapse": "Hide the assistant's steps"
    },
    "startScreen": {
      "greeting": "How can I help?",
      "prepareMeeting": "Prepare for a commercial meeting",
      "prepareMeetingPromptWithOrg": "Prepare for a commercial meeting with {{organisation}}.",
      "orgPicker": {
        "title": "Which organisation is the meeting with?"
      }
    },
    "recordPane": {
      "hide": "Hide",
      "openInNewTab": "Open full record in new tab",
      "loadError": "Couldn't load this record. Please try again.",
      "attachments": "Attachments",
      "empty": "—",
      "fields": {
        "author": "Author",
        "createdAt": "Created at",
        "impact": "Impact",
        "status": "Status",
        "description": "Description",
        "discipline": "Discipline",
        "location": "Location",
        "observedAt": "Observed at",
        "dueDate": "Due date",
        "plannedClosureDate": "Planned closure date",
        "closedAt": "Closed at",
        "delayStart": "Delay start",
        "delayFinish": "Delay finish",
        "quantity": "Quantity",
        "linkedActivity": "Linked activity",
        "viewActivity": "View activity",
        "priority": "Priority",
        "category": "Responsible",
        "estimatedCostImpact": "Estimated cost impact",
        "estimatedScheduleImpact": "Estimated schedule impact",
        "formallyNotifiedDate": "Formally notified date",
        "workingDaysOfDelay": "Working days of delay",
        "summary": "Body message",
        "title": "Title",
        "contractorTeam": "Contractor",
        "contractedTeam": "Contracted party",
        "alertPeriodDays": "Alert period",
        "alertPeriodDaysValue_one": "{{count}} day",
        "alertPeriodDaysValue_other": "{{count}} days",
        "reportDate": "Report date",
        "contractor": "Contractor",
        "shiftStart": "Shift start",
        "shiftEnd": "Shift end",
        "weather": "Weather",
        "notes": "Notes",
        "reference": "Reference",
        "plannedStart": "Planned start",
        "plannedEnd": "Planned end",
        "percentageCompleted": "Completed",
        "readiness": "Readiness"
      }
    },
    "citation": {
      "kind": {
        "project": "Project",
        "issue": "Issue",
        "shiftReport": "Shift report",
        "shiftActivity": "Shift activity",
        "progressLog": "Progress log",
        "weeklyWorkPlan": "Weekly work plan",
        "document": "Document",
        "location": "Location",
        "discipline": "Discipline",
        "contract": "Contract",
        "potentialChange": "Change",
        "changeSignal": "Linked record",
        "user": "User",
        "team": "Team",
        "generic": "Reference"
      }
    },
    "sources": {
      "heading": "Records · {{records}}",
      "note": "Only records used in the brief are listed. Click a record title, or a bold reference in the brief, to open the record side-by-side.",
      "truncated": "Some records the run retrieved aren't listed here.",
      "showMore_one": "Show {{count}} more record",
      "showMore_other": "Show {{count}} more records",
      "showFewer": "Show fewer records"
    }
  }
}
